export const data = [
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 330806,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6388,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110087,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14204,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43589,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 214840,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99989,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 44582,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 228046,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26428,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1601344,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 63250,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61424,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40475,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137762,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 277577,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39559,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7474,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56068,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85277,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13164,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5607,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257901,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9390,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55495,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 236107,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67165,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12935,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43463,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79896,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 86762,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 227803,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 437510,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 94075,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 116083,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9883,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 330375,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18092,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 750053,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98617,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100275,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 138904,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6842,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129170,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 319508,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100241,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 133008,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70040,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65474,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71496,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14997,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39910,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 347452,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 79061,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9267,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7911,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17266,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 18770,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83870,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120167,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58749,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1707216,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102120,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23578,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 622289,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35906,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58756,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69467,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95558,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12128,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43788,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6905,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 63234,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 22603,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 305732,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 210853,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 37281,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 133952,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55582,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 205270,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20549,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 198962,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8701,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77984,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57222,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95904,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37182,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24902,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83753,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5829,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5331,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 79363,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 40789,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125266,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69082,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94187,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 672837,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58164,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 243274,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 146403,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12259,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 39754,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 22101,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4869,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91339,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 446456,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74759,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 643026,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14282,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39276,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19856,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69436,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18164,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115360,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83712,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 708227,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19384,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140864,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24253,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 336326,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61096,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 63500,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62531,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 334069,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306825,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71562,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1183380,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54897,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9944,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24602,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 634274,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35412,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41077,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31437,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163445,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1371390,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 234118,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 401500,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 124435,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55456,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23369,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61465,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85085,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 166208,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 623182,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72721,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7167,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5983,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84764,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10166,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5126,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 38813,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 200442,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 112164,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 352981,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10704,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7059,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55053,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75307,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 220266,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54786,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13181,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79261,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37050,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12396,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6988,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68464,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 121556,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77698,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58714,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7266,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 894658,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 325076,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27590,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3355,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 112126,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16354,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42160,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56535,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135187,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78371,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63723,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300107,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4717,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75056,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6143,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18484,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 231230,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82320,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54633,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 170211,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65056,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19452,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 235892,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267341,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6218,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23486,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268589,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 58286,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6420,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94412,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54973,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 191985,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119440,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 210480,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 889679,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68657,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15802,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 173405,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71097,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58258,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56685,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 21081,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 605939,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88603,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67508,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9888,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4627,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26421,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258373,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 19068,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89549,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 55747,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 126302,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3432,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127235,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65944,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69108,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267540,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63012,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 39685,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 700404,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76138,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10988,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5316,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290583,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 513631,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3932,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298088,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12284,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19781,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77754,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62097,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 326514,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 502600,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 345709,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 891563,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20589,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31266,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 369265,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 43993,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93817,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26834,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60094,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68470,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11611,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 510312,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65033,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56458,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123558,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 82037,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16827,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 329294,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 138467,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55298,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19211,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 822672,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24288,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 294460,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101784,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39735,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 337266,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7002,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1020924,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37760,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57747,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40813,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1129412,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298592,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93612,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90441,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2970,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57356,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7853,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11052,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9978,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15532,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88129,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95114,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59380,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14991,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 192146,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10954,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 41914,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5168,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 696043,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 740791,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118217,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 195697,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7556,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96915,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61494,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 204481,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10376,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29854,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78458,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 474111,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 35397,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 209508,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86999,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 634339,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5167,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 30708,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 474778,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63356,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 136672,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 560789,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5473,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 48391,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110496,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68218,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68693,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 32231,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73519,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11941,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 892209,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 544988,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 85070,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56461,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 24081,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 472478,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282225,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56665,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66725,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89171,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75678,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142358,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324683,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41491,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 832187,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138105,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 198904,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85708,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 105439,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 98264,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79236,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35764,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8969,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22096,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14556,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165290,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 72982,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13147,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81742,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60153,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74833,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14734,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64661,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69054,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22915,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10044,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68221,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 305395,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19734,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 32384,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9313,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54700,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112900,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68017,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 711926,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 201152,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5475,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72467,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 704698,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 715985,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37350,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 169073,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8623,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 478663,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72763,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 192848,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 116904,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8290,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119819,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67191,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38375,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81081,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 103450,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57446,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 72586,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50782,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107172,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13180,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11026,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55267,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70634,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129214,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20842,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 574385,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 689496,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132867,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 831844,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7179,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12978,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25297,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34859,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1011922,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80366,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7579,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 126713,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 40349,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 105222,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 699035,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 195010,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 41577,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 116569,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5724,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54512,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 44299,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 38640,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36388,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5519,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67175,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 118803,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66110,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 134419,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276817,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 145708,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 102559,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 32483,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 209314,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 13054,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57088,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67296,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 208743,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8150,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86994,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17314,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 618277,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99707,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55293,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75187,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73957,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75454,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20500,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65869,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55692,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83533,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 29395,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55286,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 699297,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 180355,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 623955,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70836,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7790,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9233,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8227,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 688400,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55762,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111730,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119971,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57019,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 119261,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55521,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17169,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55080,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67717,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103314,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8192,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19667,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12686,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 37176,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8547,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 98060,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8421,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 787072,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301925,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 157176,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1139013,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62862,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79005,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74697,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86345,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 38177,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 714209,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 22664,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90275,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88342,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14578,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68400,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 40821,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 210085,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55253,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 342657,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81449,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38363,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8984,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55914,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99582,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26910,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62288,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 795915,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 177236,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61512,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72043,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 802913,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88266,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13139,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55484,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5543,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 193912,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 96669,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7826,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 61526,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18644,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7271,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37384,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58227,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59628,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 379774,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38605,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273789,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 73901,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5983,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 575238,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5760,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74225,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7961,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81319,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56102,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41426,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 368343,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 58220,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293639,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73695,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95593,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98382,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1192910,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39126,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128028,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 43660,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 598221,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66273,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19874,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85090,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33261,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 588906,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328780,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85512,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 948195,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93433,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8524,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73933,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104288,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87221,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1206511,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57065,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56898,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77732,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67367,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75280,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 95099,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 155832,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67138,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 201842,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10498,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137523,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 44336,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11881,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 181887,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54834,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 134443,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 136915,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 72162,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270060,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5785,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92835,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37741,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 641091,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 25212,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55057,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70842,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277573,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 143600,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 893755,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80334,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80999,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 112598,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 81016,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49411,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8875,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 28952,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 85460,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4610,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282419,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 254674,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 195075,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55448,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76501,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64940,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 116277,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54842,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9772,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13706,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127934,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78280,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68251,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 197958,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12776,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10151,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10907,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20701,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 138320,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72149,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 627823,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 327938,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69173,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73542,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 64235,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65469,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59505,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67867,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68910,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 362440,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 133075,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 783776,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 167279,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 24565,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301747,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5421,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 187528,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69547,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20348,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284040,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36320,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87322,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 44876,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73884,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14979,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 34529,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 601895,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12107,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 829600,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69837,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87615,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10092,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7368,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4111,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 694459,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6559,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 146489,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132797,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 37890,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55603,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 493395,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7552,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4648,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 31423,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5131,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35491,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 681465,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5503,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17483,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124411,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12086,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5814,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7564,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57754,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56489,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 291254,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 230573,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59340,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36860,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20649,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 746031,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 265864,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73113,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11241,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 339654,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 26899,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 29267,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20197,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56081,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 25450,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63576,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76964,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110417,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62582,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26812,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 67481,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91862,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7783,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80227,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 190154,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119397,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 338337,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41859,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 125464,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55592,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98595,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45060,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134356,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39318,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 35671,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 34258,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75334,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 863882,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10772,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 112240,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10934,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 371500,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36082,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 536649,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74398,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80127,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 145702,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63575,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45144,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41593,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92909,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304422,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89830,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 120544,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38167,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 766644,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 488401,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39388,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 828786,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 529573,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 230115,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8397,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 124698,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 206603,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65529,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80724,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67889,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10410,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 44262,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55476,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101303,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56599,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63633,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 35815,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27168,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11199,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 50189,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39541,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 181594,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 130339,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1008925,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8875,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4353,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 133550,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 715632,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 98436,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70279,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69310,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328607,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114235,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21205,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70629,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 131516,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120957,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60014,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69846,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61055,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60169,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 326156,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 303497,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66907,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8733,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96728,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43732,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12777,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 32316,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63547,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59536,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57819,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60841,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 235800,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57007,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11178,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 580040,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60008,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35542,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5559,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18633,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 55857,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5141,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86364,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 183675,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40009,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16038,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1000318,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9896,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67749,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91627,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 144905,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64333,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260097,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 852260,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 100950,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1193495,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15459,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7256,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1364992,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79277,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103450,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85188,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5500,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54760,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111914,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62615,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55175,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 661291,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 457545,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 189638,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5449,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 52315,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 67537,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19462,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7466,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 173977,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 129476,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71621,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 115891,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 184766,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85638,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 336772,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64530,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4510,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 344121,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 112896,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10344,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68138,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10520,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31430,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60485,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9357,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 71167,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95565,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55506,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 73124,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 113542,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 450329,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102887,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76515,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1146504,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21540,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29729,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281525,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61527,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127515,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57916,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 26780,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6076,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 908813,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 323488,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 56282,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 112387,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18151,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7778,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276027,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 483604,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71476,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92802,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 359368,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 629685,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 4838,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41584,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73975,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84145,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22482,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62091,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 193468,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5256,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65594,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88316,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3236,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42059,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24422,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19577,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 88287,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 56572,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55804,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86844,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 43886,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6494,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283612,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 420056,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70305,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91429,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 74620,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19665,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 96718,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 167824,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63106,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57065,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59175,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30163,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83395,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100401,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 189547,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65471,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 66798,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 207519,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11323,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81439,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88382,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9164,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 739657,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11915,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 409884,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111923,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20678,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83466,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 104154,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14244,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279186,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 105347,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4603,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93239,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 381564,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1267848,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284146,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 103442,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283387,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20294,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57175,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 651956,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99242,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74593,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42005,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20622,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 110626,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71215,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286652,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56631,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 892437,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73623,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37137,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61376,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63122,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69554,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24925,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38940,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35330,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 610196,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12459,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98207,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76024,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 546266,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12317,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70478,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41957,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56205,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49952,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269813,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9856,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5562,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58399,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54584,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59434,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20441,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 890332,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5317,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7501,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38994,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77014,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4878,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 381611,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 30042,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110118,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 394311,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69582,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 559126,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69331,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7044,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57014,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54206,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 156058,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 543778,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31555,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 114365,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 823516,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15010,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 72370,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 125484,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 177162,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 25307,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 200601,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 135456,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 116336,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69736,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 232346,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66274,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280593,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21211,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298403,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60733,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10160,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77168,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 188585,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 155468,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4700,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 25550,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 992507,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324381,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275146,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140355,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 37188,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7493,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270491,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88118,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87880,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282555,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38939,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55649,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19653,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 573023,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77898,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90113,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97574,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302989,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6743,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44475,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59353,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129918,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 55329,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49570,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 36844,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 110786,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55528,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 322528,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 82175,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 272998,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5258,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11957,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260243,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19217,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68864,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7248,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72382,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 894204,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7343,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8698,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22323,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 456148,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 28358,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61889,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 149114,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 46163,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 177120,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39169,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 79163,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 59773,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9336,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36771,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 72205,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98597,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81958,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55893,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8364,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64125,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 212018,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 401338,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 43043,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9118,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120121,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40180,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54763,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31401,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 64487,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22808,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85302,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14319,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17117,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 636160,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72741,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74549,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84180,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62135,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138570,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69145,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 64168,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 687614,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 245173,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 133186,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33695,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117839,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 590970,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 42759,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10332,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26323,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 119159,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115440,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54216,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55240,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 33694,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71316,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 591304,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112842,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64020,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5555,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 108699,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10645,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59478,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5815,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 56944,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40798,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 192526,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82013,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116053,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120510,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62281,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52353,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54598,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69763,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 949397,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67477,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 114007,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59214,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83333,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89288,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35422,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 76892,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73518,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65083,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 33858,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 91145,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 96457,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304106,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68472,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43740,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66033,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 323939,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 315853,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83362,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 461058,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62865,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59884,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1084181,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55973,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 32206,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5014,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 112925,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101812,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6227,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73512,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83153,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 34486,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102124,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 118964,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5951,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75072,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126348,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 26480,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 28826,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93518,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 156080,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56837,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91811,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 818556,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86973,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33843,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 834691,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132932,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54595,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15456,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114131,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112882,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97918,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 698205,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18567,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105805,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 677257,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 962321,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57642,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 131178,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 306392,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82577,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4403,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103231,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54830,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 702671,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8539,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108872,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 44144,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16543,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103360,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5983,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 187971,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70695,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11182,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65617,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69770,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301299,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4957,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302440,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279935,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56776,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62951,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 223514,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5728,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65496,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 528821,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96467,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1173633,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1479807,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 106293,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 208188,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4587,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292597,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91880,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 375916,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 36500,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 986231,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 111134,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7138,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18022,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 32778,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 792743,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8864,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79373,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 663947,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 274783,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 218797,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255360,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11256,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 859797,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85512,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71354,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80016,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 78382,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56172,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 232947,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103666,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4545,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 161232,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92078,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72102,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43038,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58912,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 29719,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296742,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 527143,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77700,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98117,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 765787,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1029517,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41511,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56851,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6778,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23101,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77338,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58843,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10448,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 164729,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74276,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73542,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59438,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 250364,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7061,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 105299,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8938,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104570,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15925,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31131,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33481,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110851,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320392,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57353,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 676426,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76122,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55957,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68442,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 213608,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 200830,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 339595,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 772396,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 42307,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7500,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98562,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 141740,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84291,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 46807,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 336745,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4751,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4698,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19403,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123196,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6981,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62120,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 636947,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91331,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99226,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65760,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57566,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77071,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292690,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 195329,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87135,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116398,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43534,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1510100,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 37664,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10865,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6780,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163251,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 469537,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82095,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86722,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23313,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71222,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 95862,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101267,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98459,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 546030,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96993,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11239,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 740701,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127716,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283500,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72885,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 26522,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7487,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4822,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114707,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 141051,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65978,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111164,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97631,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 881373,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 194550,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40449,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55548,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 287051,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7284,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 138962,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12376,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8255,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 126838,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64140,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73857,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4767,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 481764,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103378,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 137696,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142320,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324102,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66042,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 330583,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100736,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85882,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73423,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78368,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58955,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 473002,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70557,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3161,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81846,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58890,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111758,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21129,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56683,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69110,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 176068,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61976,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58611,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6721,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256316,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 186609,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11541,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 151988,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5573,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273276,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61898,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8428,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 85523,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58692,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12310,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 33935,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 96766,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3988,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4745,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 348665,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 136992,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16808,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 98693,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 124205,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98627,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270780,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 39840,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23642,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 834626,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14511,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 734798,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19370,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13089,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63723,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289689,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 28609,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61778,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 655077,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 233936,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 38569,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269995,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84885,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60113,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16639,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79517,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54713,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 114457,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298151,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85549,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70895,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61360,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75718,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 221812,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 740663,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77658,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17993,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42712,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 815003,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93621,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 550201,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66609,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5512,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5315,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3068,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 169343,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 715771,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 97633,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74279,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 143617,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70567,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 179069,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 191729,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66308,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11410,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43855,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 172702,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 214859,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 377878,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87512,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 90609,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 98031,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 592716,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61854,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66017,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91641,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83138,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 175055,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44162,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 386652,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44031,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 963588,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14501,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 212288,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 106216,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 200355,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70943,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272611,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 133574,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 111073,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 482912,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15136,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35440,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99398,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5399,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61096,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274262,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55612,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13097,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 124485,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 137127,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60459,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268837,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 831742,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39867,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119943,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62395,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7459,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 97110,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39299,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7111,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15973,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 98028,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63930,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9064,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 921348,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18395,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 193208,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42931,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38243,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29598,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 869051,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 115700,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 159603,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55860,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117977,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 60806,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54606,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65553,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23778,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 308598,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 103629,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 356811,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 113767,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 48539,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 840498,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81942,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132468,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 297920,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4897,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16323,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 70589,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58223,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 136165,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10197,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123524,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58883,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 78572,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70189,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293841,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58001,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78180,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 682439,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6986,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 26684,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61070,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 357616,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86441,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 53423,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 126779,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55104,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 724698,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71202,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163662,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257765,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21079,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21085,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57516,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65933,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 429914,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15807,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5101,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43025,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59858,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 494788,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 314303,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 340590,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55293,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39276,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91337,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41557,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60577,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12135,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129637,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69579,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 66875,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88596,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1020664,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65283,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11746,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40685,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 48928,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9388,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 182114,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 68529,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11310,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105084,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79673,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16784,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9328,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 75311,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55406,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82935,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 646826,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40477,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69987,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 686836,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 78081,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63122,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 193736,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62355,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4753,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7259,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107003,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64603,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 41852,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11773,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5768,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5637,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 139544,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16675,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56986,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136579,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16727,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5291,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 80633,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10861,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44183,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272013,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1003576,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55445,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123982,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 173104,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 69424,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57664,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42135,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61538,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61873,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 968742,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70770,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13366,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 364595,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 54354,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313179,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8020,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57325,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 31188,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109878,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6039,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78993,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9573,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 102456,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1416168,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9788,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 678478,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 596654,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 357737,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134400,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63335,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54671,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7464,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130733,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78532,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 113019,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 821145,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66265,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6026,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 32978,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267990,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258520,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1139539,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293084,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25415,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9940,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94898,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 122635,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 97671,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84343,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59898,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74550,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 585064,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 337149,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8749,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68676,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33200,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 989336,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91944,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 208737,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7706,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55592,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4578,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73546,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13699,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 76666,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62403,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263767,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 213452,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21314,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 874585,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6857,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 20109,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 91511,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107816,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5299,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 130736,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 80740,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 141337,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 252789,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8656,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121155,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60663,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131502,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263489,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40920,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17040,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54506,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 451024,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 74429,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7392,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11384,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7232,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 53688,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 78426,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 708569,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55511,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57068,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127425,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99958,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59783,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120738,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57155,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 593933,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 339720,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69882,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40999,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5745,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8451,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109381,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 233275,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12109,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82933,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 196043,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67907,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60834,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16635,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 44359,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 59561,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87554,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73475,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 472901,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 886327,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20679,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279999,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291528,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59119,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 295969,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1037023,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 703210,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42017,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 165881,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69578,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 102566,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4593,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30508,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 920578,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2902,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1124599,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 874986,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57361,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61468,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27402,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24247,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63137,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 877444,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 364334,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44070,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38587,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64505,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37247,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 233753,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36851,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 126288,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1089068,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311800,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72820,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81223,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 542913,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274689,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1266709,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263231,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19698,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6343,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 132969,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40218,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57457,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 797457,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 352237,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65009,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282573,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19288,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18788,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 102438,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10216,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71085,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 72809,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63331,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23397,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 72517,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58398,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70161,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69716,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16491,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122872,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78932,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10074,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35999,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 433316,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88533,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54968,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 775991,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15345,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75247,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 30785,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18399,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11696,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61985,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6007,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 86245,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75752,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84652,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81524,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63745,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257695,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 116111,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69547,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11900,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98340,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15967,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 112075,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 68338,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 411150,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111608,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 33319,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11872,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328590,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77318,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 336664,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7213,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5009,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 138943,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284828,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284233,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165634,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 364681,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69891,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18182,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 31908,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68171,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 639046,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31975,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20492,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70065,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115016,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8858,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5475,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 106858,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66508,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58300,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 308225,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17474,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 65275,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56083,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8239,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73869,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6810,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136293,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 94307,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 438955,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324895,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 323306,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16804,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 201711,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 299104,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92392,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13493,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 486619,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 472207,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63200,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82878,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101187,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58170,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55585,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 64845,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268223,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99994,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73190,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 208847,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 29699,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 29339,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65123,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 226650,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76833,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85570,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38901,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6118,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90353,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 166260,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132255,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 107535,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66500,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62911,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 41091,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62269,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 403221,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5885,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10580,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74105,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 605511,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87748,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 20200,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67665,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10310,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91648,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255119,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91356,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 115369,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 56857,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6404,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 510708,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100513,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89015,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58123,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5005,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 32398,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5481,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87230,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55426,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57161,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270871,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5812,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 535513,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55840,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60103,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 241793,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7183,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63104,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35978,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 40160,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 408193,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11480,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 126461,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 539926,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 87992,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 28030,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 39431,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 132198,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126583,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118498,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21305,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 112763,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88280,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12437,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85543,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66086,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 421205,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312342,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63087,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 115182,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102427,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 207858,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 341333,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 203456,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70459,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 342914,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 99727,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16123,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 101002,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59524,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22563,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64829,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71567,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83188,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 61866,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43185,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77250,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75229,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 611634,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74628,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6394,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111829,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 358097,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87305,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55201,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 344411,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93995,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 369560,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5452,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18529,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7681,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126609,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99032,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262155,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 63952,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 721124,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 105796,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57375,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7699,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 606507,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 372500,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76062,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73781,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 107710,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55735,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 39334,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63991,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80028,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15799,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91677,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40799,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55754,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 120683,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 395082,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 218967,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 107991,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 232762,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74513,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57621,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110388,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106231,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 184261,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9402,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87270,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71525,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281764,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 186247,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 620297,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 51125,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271064,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 97026,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311987,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99901,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 378950,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 390633,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18812,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114791,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 21586,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101250,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1135932,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55559,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39189,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 101421,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64867,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7364,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 299746,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91101,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6152,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6172,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5664,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 44399,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 114706,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18149,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68065,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 899714,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9648,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20650,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96043,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60592,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57687,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84946,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10738,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9253,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6994,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 688433,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54778,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 114583,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57768,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 133718,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7208,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39749,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5428,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 875890,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 63661,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62584,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9636,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57654,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 26643,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 208780,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55994,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10927,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42206,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 661588,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 143829,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 34703,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6957,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 369151,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7794,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89756,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 80608,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 231277,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8264,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44301,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5239,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 59295,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 597953,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84794,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66269,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 69657,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 122440,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89477,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 76464,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83484,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66650,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 400743,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 141300,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117910,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4525,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5467,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 564247,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100457,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 90560,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5050,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33835,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6966,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 33796,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63539,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 204433,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92751,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 33503,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 183502,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12184,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94725,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88278,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 219797,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65759,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 29062,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78017,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76932,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 231517,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7776,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 368780,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 48413,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 130955,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 337990,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14005,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58704,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94251,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77169,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78055,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 201850,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5269,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84384,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101254,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 96752,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306205,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 50616,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 185215,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 60484,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 216736,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6863,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 879882,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100212,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304557,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 49311,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267726,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87444,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 340899,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59795,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5904,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31415,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163025,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21758,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273735,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 381168,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 28079,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9304,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 179780,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63983,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 96740,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105929,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 181748,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55191,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 568971,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 3151,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58100,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 34190,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63084,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60591,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73445,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 177928,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 267462,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 142227,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84278,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4694,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7172,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68289,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 439782,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 22501,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101294,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43834,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7693,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64002,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105676,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 558192,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11662,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54663,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 96516,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107413,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82889,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73945,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56161,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55451,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 403785,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 84062,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19133,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 41380,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84935,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 73039,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55927,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83263,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41895,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4855,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 632819,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3681,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57173,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99858,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39005,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61023,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 699869,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 124440,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 155513,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297106,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 287737,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161257,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60168,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 105503,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10300,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281591,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112891,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63078,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272486,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6606,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11560,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78994,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29203,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11545,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59796,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6878,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 81280,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 459904,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122414,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93180,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39277,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87640,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61222,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63549,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12604,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10094,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17481,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 439364,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1029112,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5394,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137689,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 502311,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88230,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5705,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 71663,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87293,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74960,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23071,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92275,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69848,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55707,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120680,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60446,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 238912,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41168,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6750,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91211,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60201,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9757,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 38829,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68100,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9201,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16909,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99933,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95358,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37903,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 361038,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92371,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20856,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 83832,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 130670,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61501,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92010,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 666433,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311144,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 44817,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82009,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22285,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83387,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5037,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 239342,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 496376,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108965,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55302,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 138031,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73357,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 527595,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7066,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57027,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59518,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68918,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 98945,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40692,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67215,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85359,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4849,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43214,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 21044,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 221159,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 390900,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56122,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88369,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 62823,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 18016,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59564,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 636763,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19850,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 214165,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 57391,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 829797,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86657,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13914,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58594,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 89610,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59779,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42310,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 171436,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70446,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61642,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 604527,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 510454,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66943,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37410,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 90026,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22640,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 132544,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1389066,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 130271,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293080,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161987,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 83367,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6620,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8668,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6594,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74183,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5231,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40504,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80877,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 44470,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 140981,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65983,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14918,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25642,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 134816,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270750,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 608946,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100780,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36689,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58738,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6282,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 325800,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8678,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91950,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4608,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 333977,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258963,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82683,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 917157,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56253,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36398,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43009,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8622,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 4896,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 59820,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 421981,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 72174,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82661,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2108,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290099,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4950,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 115140,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269701,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9603,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 32740,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 800985,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63651,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8543,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14698,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283749,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105582,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67422,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42374,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 338747,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 74396,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78222,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76060,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67591,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 472138,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111736,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1019527,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93607,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 166928,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43038,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78971,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16972,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 852836,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 816081,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 177344,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73003,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 668256,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109263,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33995,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59148,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70682,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39053,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12358,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 825385,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11716,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102731,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16010,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 105378,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15420,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37411,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8471,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143319,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 955576,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68408,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92136,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 124053,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57041,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280420,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 169554,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61352,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68946,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6982,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68071,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62408,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 168358,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3232,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42469,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14543,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9552,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76310,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129364,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65251,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 192153,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38231,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19214,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11077,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106916,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67905,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292220,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6638,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 108305,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54791,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 497713,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 277698,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96939,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 158685,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62465,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6195,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 265419,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257920,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20083,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6204,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 295195,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 105207,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7951,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 98853,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134183,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1431712,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10078,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55275,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11033,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56427,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 402552,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78965,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10691,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 96691,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 86060,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 319576,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 503377,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55046,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 52279,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 108867,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 167485,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 243466,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98901,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272688,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18244,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13797,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 121915,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290717,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 198734,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119723,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 164080,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58186,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40943,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17883,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 35274,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61028,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 984623,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 98604,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105149,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66889,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79247,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 88740,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 142885,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75247,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31454,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 415671,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 783464,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78227,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 611755,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 469718,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100954,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 27285,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 159481,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69048,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67799,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 154506,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 319846,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4839,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67913,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 40803,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 747277,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 884514,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 264845,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11174,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12853,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108084,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66631,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13014,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82578,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54959,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10894,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 208905,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 106639,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68888,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7979,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 865534,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41280,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59460,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31852,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41168,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 75542,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70940,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5076,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307999,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120048,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58288,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36240,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55221,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56330,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67658,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 89639,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37253,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 220346,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4720,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 125704,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55888,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57489,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21763,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54832,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293298,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37742,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 173622,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 42450,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 211916,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11699,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 433155,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94220,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5969,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4597,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 49639,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 295002,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9959,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72494,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21120,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75387,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 166890,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133845,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19782,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136269,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 74823,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 83210,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110865,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 506609,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 94814,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 84609,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143002,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6035,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 23560,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16552,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 185927,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73911,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31760,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 86757,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76430,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 172421,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 242476,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68246,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57934,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 558062,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 203056,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68210,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14940,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4856,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63261,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109535,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65252,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7353,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 217239,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78623,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5813,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271707,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117449,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97770,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90318,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94132,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5280,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27791,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68028,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 212503,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70886,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 862125,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10096,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 43539,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18409,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20570,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300671,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88922,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 77159,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 667125,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 82013,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59474,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 408995,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 169236,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117470,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 91091,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113856,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56884,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16365,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8850,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57738,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97823,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8612,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 65560,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 48605,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18209,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 63097,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 185795,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90188,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 108535,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 562548,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 119447,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74363,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 130942,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117329,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 330205,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67719,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 196768,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57353,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 638931,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282874,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 315703,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56949,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55224,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 36091,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78947,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12109,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 714036,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270026,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10847,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93016,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 135907,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19793,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 303165,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17277,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87809,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1058283,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 85918,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82858,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 331187,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73633,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 13458,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5463,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 773746,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86073,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78928,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7459,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135424,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11509,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 128021,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 86967,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 166103,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312409,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80329,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 203388,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69855,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 34238,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17397,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6627,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1228474,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278597,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93056,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107453,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71673,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267959,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108053,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8485,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74064,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18944,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18169,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 873926,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79478,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 167690,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 103529,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4824,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1093218,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62583,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4768,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5575,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 354517,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 29477,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 83478,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25172,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63736,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54731,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21133,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65513,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86838,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62796,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88185,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75716,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22216,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282862,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 216694,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67892,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64278,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42244,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 72247,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 46808,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40994,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61475,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14106,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73684,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135979,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59513,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88893,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10888,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87593,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10709,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108696,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8063,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9408,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70778,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 765707,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 130209,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5286,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56241,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12698,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63503,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275579,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 375318,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62700,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 403217,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16390,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100041,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14480,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115071,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 384335,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 48110,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 102957,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89196,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62057,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81533,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 28305,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14500,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116424,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 29440,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92298,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 55381,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80897,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 249953,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63781,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69065,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82443,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112926,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19487,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54597,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 327889,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78763,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39374,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 867280,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81861,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110879,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104392,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58903,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 59810,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26800,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55202,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7395,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5565,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310214,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56776,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78893,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82321,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 642441,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57032,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55715,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41709,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90596,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 133066,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 391103,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19395,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118138,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 46983,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23631,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11453,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82480,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30948,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77565,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69992,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24377,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 167336,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17398,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 113671,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23321,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60893,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57913,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69880,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75265,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255593,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 137587,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60231,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55134,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86159,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85038,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6289,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74062,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 645231,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9105,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 532726,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5261,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8017,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33398,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 48145,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7561,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4555,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67436,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 76659,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291570,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58226,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54669,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87553,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 264097,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6505,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300177,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 229296,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5671,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5188,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 214241,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74001,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13498,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 32832,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 48715,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56635,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5181,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88574,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78321,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80607,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1584194,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40190,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73069,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5625,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54840,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90422,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59592,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82574,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4539,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9756,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 110760,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3371,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 172362,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55550,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123524,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5675,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 326654,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 42871,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 87217,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90044,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 58495,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14362,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86189,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7545,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65219,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44389,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 123573,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71117,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20541,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61724,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86628,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 122263,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73165,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1051679,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74786,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 182547,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42961,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 89991,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11930,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70034,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272067,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109942,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59665,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73143,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 355666,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 23633,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 161347,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21252,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55103,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9296,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 421001,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1017960,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 3088,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11543,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9925,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 105344,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78734,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 57793,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22217,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56295,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84162,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67323,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84228,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136222,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89192,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43264,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 959506,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 54952,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13651,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 676182,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123947,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42171,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 118170,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 270847,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275129,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10484,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 72711,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9075,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120907,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79672,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7453,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95928,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57174,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 166505,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 94039,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300269,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59632,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1524076,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 651829,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6367,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16638,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 556018,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39576,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 205665,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36574,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 158835,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 538495,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 938154,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52377,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43050,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 174435,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5177,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41372,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60747,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 38776,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57056,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6126,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 164152,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277529,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 213721,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5541,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16639,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87412,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 72176,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12191,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86376,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 70548,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72826,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78718,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 252864,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73236,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 716413,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 199811,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91263,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71666,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 557290,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 55801,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58437,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20302,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60687,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 267346,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 36497,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6682,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64426,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59632,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275722,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 390195,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60560,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 34449,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87328,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300224,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 94323,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22911,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128462,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262560,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91562,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4576,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66683,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57363,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10046,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 87575,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56574,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 165264,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 30464,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70104,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5268,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 369180,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8301,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 171406,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 59230,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6515,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64518,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 172181,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56234,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267748,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80387,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 50792,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93825,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 39981,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24702,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64803,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 220813,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 113294,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 434327,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66376,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77913,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 94920,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 53805,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 401466,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11327,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86266,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 624033,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61612,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 892488,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 20818,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107026,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61882,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55798,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 22217,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 374407,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 90339,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81031,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80862,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132980,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65475,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 29231,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96861,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280105,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 365745,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88586,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8208,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 44137,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74311,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 72282,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11422,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15919,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63025,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59226,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55216,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18028,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 158035,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7778,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101075,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64552,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 73516,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76490,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 294127,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88106,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24806,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73319,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 59152,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5381,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59158,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260396,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89198,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 19148,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268942,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96634,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 822884,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27484,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3100,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 3219,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 37530,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20144,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 366306,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 84585,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 150818,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 953818,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43010,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19111,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131803,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 50542,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 169804,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69293,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42035,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69451,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163698,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61058,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93463,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126260,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 695882,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60735,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5246,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 154874,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318318,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 335875,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 230999,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 32334,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64206,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 169012,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10475,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312029,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 178732,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 895948,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82885,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 259671,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19704,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93590,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99071,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 111812,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68207,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63242,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57987,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 57811,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 94996,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 162927,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59875,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70451,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43438,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81486,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 97150,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81851,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1129889,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99637,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35606,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 35278,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 26580,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 83328,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5297,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 43361,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27120,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 71560,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 44546,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96221,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138133,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60550,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6707,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73552,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 330579,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7904,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139041,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 96441,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1434598,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 357368,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92971,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127742,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 57291,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92651,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69448,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27588,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60927,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130343,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 697860,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 190477,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 84255,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 314531,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 81472,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17020,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 356916,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 42577,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56513,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44153,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26449,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66916,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 136595,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 59281,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7831,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 512321,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 997514,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63598,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98439,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321395,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 155020,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118757,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260609,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56581,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76470,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88029,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75548,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25569,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69150,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115264,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58050,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 36946,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8029,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119318,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6346,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 124412,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 57383,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 135482,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59023,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79968,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68708,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77871,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81585,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 77628,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7010,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 365421,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5256,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5335,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271885,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92104,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40814,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 341269,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68404,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 375831,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5735,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72008,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289629,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70397,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 81793,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137882,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16236,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 100029,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76245,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 193252,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6160,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63500,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55229,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 43471,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 141413,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59328,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 222667,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7279,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289155,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20753,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64801,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 163187,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85588,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70574,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2612,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23848,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68359,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4560,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5679,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36459,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 117074,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 894825,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5094,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113592,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63588,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 87412,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1240929,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67021,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8643,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 317478,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10125,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310479,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89542,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 879237,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88002,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8136,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 43912,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5666,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 35448,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 325968,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9153,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112267,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76329,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98675,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 27834,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14655,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1023235,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5650,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64882,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132608,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77925,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 155750,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 735027,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 759116,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82005,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 380991,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8316,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22389,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5693,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 266082,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 232557,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6817,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83966,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8224,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4728,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18398,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77988,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11563,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59365,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59557,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8763,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 294568,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 171787,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44554,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 801329,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5270,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17049,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309209,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 32538,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1027933,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 51664,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4614,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5367,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128313,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7162,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 221251,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 43904,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 174719,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 95943,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24188,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13382,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 268798,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85421,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 116847,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27633,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71505,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 427210,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61267,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78179,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63444,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98721,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 587518,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 45423,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 688493,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55865,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1382247,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 374945,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 784570,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 754182,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34867,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 264810,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57260,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77230,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 725117,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79883,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 316980,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 371920,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 59016,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 44364,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 119026,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 382232,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 218184,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 330370,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 112203,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10320,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113731,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89844,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309260,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84454,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 87020,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55635,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17828,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21315,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5497,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69791,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62672,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 401822,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 39439,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87108,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61706,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 94578,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 723904,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271379,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80497,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59313,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33822,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55867,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 378194,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 743949,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 133432,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 558250,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90640,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307383,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61208,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6389,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86188,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77964,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36165,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79453,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24489,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 384796,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68792,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286371,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70298,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 368883,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60364,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 99472,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1020041,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12956,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11180,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70244,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97823,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 66163,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95426,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54671,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74832,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 984362,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 78547,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83963,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 133259,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92909,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39564,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71306,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106627,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2836,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105235,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10390,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4473,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 158749,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37217,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73038,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59304,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96770,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 815449,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14378,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8222,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5736,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91083,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256052,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270895,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9753,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12547,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 243575,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77989,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67672,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9711,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55758,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9456,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 80407,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68716,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69389,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61800,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95895,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5146,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98748,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11460,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43921,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 188710,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 196173,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41843,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91213,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97839,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 97571,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109867,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19421,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15430,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 225885,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82669,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 331189,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64182,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111841,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 54804,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 192570,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324834,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110323,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36204,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68823,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 197340,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 171990,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82269,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70015,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88999,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 801177,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 326513,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 253308,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86509,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57922,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 326682,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 919979,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78426,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35212,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94565,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88525,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68673,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8290,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57297,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10324,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 704623,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19630,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 39968,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99822,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69539,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 183968,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116791,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108477,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 959938,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71481,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 132172,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 20187,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65323,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63793,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80352,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5121,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 672208,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63485,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4502,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 39878,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21028,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84227,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67469,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84575,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 141747,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88993,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6321,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 141302,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15484,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33789,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 66532,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5464,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 187839,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79411,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 75860,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304755,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127783,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4737,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 101003,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111295,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56096,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63643,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42209,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 146140,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 237836,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62636,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137025,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40092,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10410,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11876,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 236417,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1020077,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 230033,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 221588,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 323355,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86674,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118295,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 488874,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 985932,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41635,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1146385,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11129,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108473,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60341,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71669,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 53675,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 160141,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271321,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54588,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10183,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 501448,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21868,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 118347,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105194,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1175172,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81245,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36386,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84439,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2593,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99920,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58927,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 338887,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 332967,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6314,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 331779,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 602435,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24011,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321233,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67527,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22083,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285859,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119225,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 135696,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6658,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93876,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103733,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 29631,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 25078,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55669,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14729,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 228178,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101222,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 356014,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126342,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8752,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 113470,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 79403,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 537100,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4884,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 607629,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70012,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85690,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 52055,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58752,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260393,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5095,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75478,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 93873,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7916,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36116,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300440,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87268,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286516,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20898,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60313,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 333803,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4590,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5409,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9285,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 133153,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39318,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 190133,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 80037,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9277,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71704,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107186,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102474,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5905,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72870,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274081,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88011,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14382,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73551,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 570013,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63771,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39951,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14601,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 439138,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3591,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67762,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65195,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33027,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289659,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94773,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40225,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5607,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5293,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 35023,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1193226,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 670756,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99493,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6675,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 666087,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63911,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4435,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100298,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 580041,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56459,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63673,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 138205,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 99943,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 141092,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1106424,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 421525,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5010,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288764,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88964,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 46541,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71970,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 23960,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258360,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8764,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59282,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 33375,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 40955,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 112644,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88677,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100437,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59230,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83125,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313531,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 683900,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16079,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7812,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 89385,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 26904,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 28288,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7058,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 29113,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 416396,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8606,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 217928,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262968,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10443,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 390977,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40863,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70013,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75459,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77456,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88569,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4982,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9528,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76319,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 182339,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271935,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 389647,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83643,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103206,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 665032,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106301,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 39077,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 415466,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39946,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 4727,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12899,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88316,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24150,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 242073,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57020,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68646,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56227,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58809,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21094,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4568,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 820229,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 319421,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60810,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73896,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78066,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 479935,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83407,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 553280,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 162100,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255857,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91263,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36507,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80377,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 2105736,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 224973,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86766,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87338,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 725583,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 13681,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23370,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66017,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77322,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67354,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85265,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34250,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 182932,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274839,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6421,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 127338,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11593,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 900473,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18816,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9240,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5171,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33348,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 84267,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83280,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 655626,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70988,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89029,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16357,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9587,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57255,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60273,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41227,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4350,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102913,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 97574,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68814,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268417,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12167,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 670571,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4987,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87159,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304082,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55163,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54929,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 51661,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 98631,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 390213,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285016,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 309056,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90758,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55298,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7101,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19180,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 54278,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18724,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103841,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12435,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 725921,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310338,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58930,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127619,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 32498,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 159156,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 163981,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143264,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 402643,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 135163,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 283479,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121952,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126368,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73339,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54640,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92076,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 513918,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25813,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 109373,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72852,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54867,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7458,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 59837,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60385,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 123181,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281267,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78636,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73362,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86983,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88415,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15877,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110296,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 326547,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 41329,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 50976,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60528,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93743,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 111756,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5425,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139018,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 100599,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133910,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 151870,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43926,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26052,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7530,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43156,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 63774,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7285,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99033,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68952,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 61631,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 60504,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106022,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140913,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 69509,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 214665,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 116989,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11190,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78057,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28090,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38164,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20538,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 487187,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 38516,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3083,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91916,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66429,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81835,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90983,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24444,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59565,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 184976,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59395,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76270,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 170813,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 317016,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27411,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101750,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 727030,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62828,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 194072,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88247,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277069,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83295,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258412,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97027,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 174855,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 178375,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70939,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7376,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 386881,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88850,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37900,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5851,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96307,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42811,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 193447,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77133,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81366,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59907,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57379,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 122332,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56009,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124201,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 109742,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 91679,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 30355,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97589,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23284,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 39554,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81312,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 939023,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 25268,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62562,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 168589,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 893069,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 55974,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 153993,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131246,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108001,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17470,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 732857,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56246,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 570702,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 305069,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6799,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13138,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87475,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60595,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 655102,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 163939,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 28724,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100827,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66568,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67455,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 307163,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20119,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110901,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81002,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 594944,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276133,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 155494,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18717,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6466,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97518,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4607,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 160113,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1024269,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73931,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11070,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 72363,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56280,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66898,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54739,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64296,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11024,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 313012,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 872661,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62560,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 339979,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110898,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56004,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36528,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104352,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131553,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107518,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 86439,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57995,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5926,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91428,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39063,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 68118,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8961,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59115,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1102308,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18809,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8119,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 998110,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 202082,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18161,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11296,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 22858,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 684421,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12485,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93503,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7685,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 43141,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258256,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17661,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72522,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105412,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81739,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79615,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13782,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6157,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12488,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 120344,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286791,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6130,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16066,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60517,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 188657,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 38861,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44050,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14450,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76529,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 369250,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 171488,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1320198,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110034,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61627,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 96530,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261864,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14793,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 691402,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 331033,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 29599,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12434,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1089470,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1569356,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6740,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9923,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92966,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 206051,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 46957,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33712,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 181653,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99660,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21746,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 162740,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56026,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75363,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1113471,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60016,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64746,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 223943,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11734,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35764,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16244,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16977,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77166,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6788,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 58918,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 875437,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10953,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35023,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 681818,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 949877,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12627,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56163,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71164,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 714432,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 688357,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119626,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60579,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66797,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15426,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269699,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66620,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268709,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163669,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 2722,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 182029,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302488,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8940,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 60258,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132339,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 198658,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 399039,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 74174,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 236562,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 296799,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 68597,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 337999,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 120788,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 51107,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282559,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38900,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57489,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81734,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 130488,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22972,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68158,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 233476,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124768,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 60677,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9684,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21698,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 732010,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58121,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7066,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33682,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69623,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62664,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68022,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 44265,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 28077,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91340,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 22924,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60847,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87984,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91183,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 829783,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 315582,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70438,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 299106,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 82302,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 339807,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54911,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 38504,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57457,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9014,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60033,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272071,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 121940,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 112464,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 114992,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88981,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56202,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2640,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 373570,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30500,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14638,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102949,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 114045,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59761,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26288,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7502,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108680,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67204,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 178307,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 40289,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280358,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68346,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 74135,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 285784,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 49856,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57414,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62191,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 84245,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 162529,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29562,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130373,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 40366,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 81322,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80505,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43383,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24079,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83852,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66226,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80029,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 106799,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64629,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 225337,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8240,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33365,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 184179,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33403,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 343520,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55639,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 43788,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290439,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67502,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 514194,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6084,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312343,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 29033,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7613,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78760,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71877,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23488,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55205,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297833,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 159061,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 705549,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 44417,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21501,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61364,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268512,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 43080,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 368921,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7317,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 97157,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 170980,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22613,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7132,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 167158,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273579,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 638937,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16848,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5130,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27664,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77729,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 187032,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39089,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272998,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10089,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5301,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300636,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8929,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 97022,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36195,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 369559,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 94192,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55414,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3544,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60001,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15483,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74837,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 353053,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 158455,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 163432,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8595,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 348989,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4776,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126053,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58284,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99102,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40867,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8339,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88412,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54806,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9033,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 128075,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 116744,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1003333,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 640524,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 922023,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67529,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 199838,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1021240,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 36665,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8805,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57174,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62095,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84876,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 25496,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19682,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 93251,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8160,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288225,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38900,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88891,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 167328,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 138730,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69035,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97768,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17615,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38286,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79297,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 72368,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142579,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88389,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87421,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5373,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42649,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66502,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1243522,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115060,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55589,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81213,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 513699,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12531,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56326,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 305958,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7335,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4744,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70265,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61310,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 236859,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 42155,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 467361,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8655,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58620,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 203452,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7464,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163980,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8014,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 108352,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1015365,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320019,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37624,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 333304,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58626,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 22748,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14829,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19167,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102532,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92816,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8534,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70276,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88206,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56731,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298788,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56651,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126422,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58339,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 37233,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55811,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77290,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71186,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62924,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79041,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40218,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73797,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44266,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82488,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98137,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106813,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34710,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8425,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298203,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72832,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 238112,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74265,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37220,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56441,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 119917,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 93097,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76335,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3893,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 178443,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66819,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12214,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71772,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 39693,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261597,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62450,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54820,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55945,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 607345,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59448,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 261232,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269709,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59801,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60998,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 64274,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257468,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 37842,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297263,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1168276,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137779,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 19097,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57869,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70861,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 103711,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 117705,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57356,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 199719,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71340,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56747,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87361,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310222,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 424670,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4551,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73289,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 548226,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59616,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99823,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61683,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 96738,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255532,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 218913,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2940,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67511,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7074,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8360,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25412,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54981,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 33096,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101639,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 40738,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272744,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3908,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34586,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20397,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5151,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 718669,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111545,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 265522,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 119637,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133293,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31545,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311780,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55695,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 563711,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 3730,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165717,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20021,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72479,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93319,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6168,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82010,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 155353,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 41788,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10453,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 74328,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41372,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67293,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34997,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85432,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 39546,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55414,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 37025,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 287896,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71366,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104922,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55178,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 86670,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6590,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 48285,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92894,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127457,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20287,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91365,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62709,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 456896,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 26287,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 138314,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77227,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100684,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55448,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 389374,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16665,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 619392,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 25517,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 308245,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 85589,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8517,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55359,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 78677,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127846,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96765,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12614,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68958,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6781,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297694,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87153,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23794,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1676471,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 85481,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111515,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 27104,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71013,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74574,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61197,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 303547,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 291737,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38246,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105625,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320562,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87202,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 127094,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66394,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258727,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58843,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92499,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59509,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60302,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24763,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 397811,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89462,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6782,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 123874,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73908,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 64502,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4284,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118701,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313554,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 36292,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85602,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58481,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20954,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68736,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4856,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 539120,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5852,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 266885,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78535,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12631,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 108975,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 219462,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 615384,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279310,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 264729,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 176916,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8033,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 89260,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83380,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 204951,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82287,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70680,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49702,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18871,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 43597,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 93993,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80496,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58301,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74579,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6758,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90561,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1160143,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321665,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 560863,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119288,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89500,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58257,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289420,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 810871,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 207153,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56480,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77044,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85996,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100622,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92992,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59182,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 645964,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 88435,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 404469,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23266,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74663,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72695,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 374879,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82734,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72738,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7953,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 230023,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 110405,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16339,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71171,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75618,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 246452,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13399,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 192554,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 287951,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138523,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55861,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71388,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270515,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 72111,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 200137,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 57964,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281639,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3922,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12412,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 89989,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 33361,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 996217,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292912,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 123727,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6711,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14308,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89968,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71572,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7024,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69695,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 709667,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 418882,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61450,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 90668,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296888,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 105117,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57519,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 139908,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111196,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 98972,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27875,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60157,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302893,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116887,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 305120,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67461,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 63623,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5312,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63733,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124225,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65130,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77239,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1153310,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 226779,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69905,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69543,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1359281,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69175,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63514,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 110325,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 370664,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 51068,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3405,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77211,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81629,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100486,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93560,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 196010,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126337,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 49880,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 55609,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57250,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59981,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 153446,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40883,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78061,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8973,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 107481,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40970,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 54591,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66214,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58698,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 555231,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273873,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 107363,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85066,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79956,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33785,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 58070,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3269,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268868,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58043,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7109,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 29809,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69294,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 326852,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9093,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 383040,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 158885,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17532,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 404926,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94242,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40029,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 158140,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 48205,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 902100,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39404,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 95118,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 35812,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87774,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30435,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108006,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 40129,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83820,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3118,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13082,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88219,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 745951,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5670,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65749,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22468,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 590567,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17889,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 330144,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73430,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 972092,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62104,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11470,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 161876,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 192954,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57374,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10792,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20944,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70421,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76289,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 211387,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285847,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83013,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 242699,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 332751,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 32653,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27039,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257956,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5715,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9229,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 93734,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280411,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84545,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 175413,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 164704,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56087,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135966,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60542,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78588,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 658493,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 116890,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58825,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76407,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36437,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283787,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62045,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80031,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113492,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67856,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 625485,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102211,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9696,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75311,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 132697,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78441,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 80088,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16381,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 647287,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41191,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 293785,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1604657,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108987,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4739,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59400,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121020,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70995,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43276,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5195,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27360,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 471817,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13764,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89050,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91099,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10317,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75817,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102587,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 853866,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127500,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7206,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128167,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 32603,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 715879,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 777843,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18842,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 732409,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 16272,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8723,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280640,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 79872,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81600,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 85186,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 181431,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 730793,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91109,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7486,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75574,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 249338,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6443,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92037,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 335264,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 862379,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73242,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121444,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81952,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89043,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 215025,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 75087,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104825,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276092,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73095,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91480,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 571949,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81946,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66226,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69970,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61631,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131662,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 141070,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 319302,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87912,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8794,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 39295,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 58040,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15584,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 393065,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 105685,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 107649,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 85218,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82355,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6586,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 754276,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 316941,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73914,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16395,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115062,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 486555,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5612,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2647,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15385,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24448,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78675,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60186,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61182,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7591,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81040,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126276,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90739,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134691,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302529,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10863,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 72863,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24631,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 29653,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69715,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 425760,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7263,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100039,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81665,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129209,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6156,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76043,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 27629,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4628,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111750,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10853,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 489883,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 810195,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 167216,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55524,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 144152,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80088,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92841,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286960,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5721,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16753,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 160813,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90946,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 27665,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 122686,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56958,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318513,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282594,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127132,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277264,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 28551,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 778973,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 72310,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57697,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76052,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66946,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74460,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 79689,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71311,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321282,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79089,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91730,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 362921,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101144,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5839,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 540301,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72015,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89762,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56444,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131031,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18508,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10400,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74097,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 47582,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50169,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 63672,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43004,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 29167,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 84581,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36506,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 29855,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54877,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15470,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 131029,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55592,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72032,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 93742,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 335465,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54630,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14539,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41480,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 140067,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 56349,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111394,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25555,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284186,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7683,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 877156,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8356,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 820731,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73108,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 94092,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 363083,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304530,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57068,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70844,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 175040,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 546240,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 179067,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73562,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 98268,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 744591,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 79956,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 88101,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82845,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71295,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87394,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62217,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 325120,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60655,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 32008,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5444,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 364549,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115006,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55655,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120695,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28173,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63389,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 455985,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56690,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55285,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61863,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39754,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 349976,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 773371,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82149,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 758041,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 85858,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10955,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5464,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21782,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79191,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 374801,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 595727,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82762,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 37714,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 117901,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12892,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55336,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10249,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72622,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 812928,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307415,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6255,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 361034,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57993,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66831,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 105630,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 357882,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 35906,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142939,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79540,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85713,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312360,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 236897,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 768154,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83793,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 817786,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57701,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100483,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5152,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101306,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80650,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84661,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 46903,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96240,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7536,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5958,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57368,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5489,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5072,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122847,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283687,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114392,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292172,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118449,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15632,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268345,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 53730,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41698,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 329952,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 660758,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 58599,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 224041,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 465728,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 615919,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45889,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 169684,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 322816,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126862,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 60497,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23648,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 190688,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41362,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78580,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80943,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12233,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54452,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30970,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 233432,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17523,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128500,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16803,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 50262,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66473,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22912,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 232157,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55374,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138212,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 621932,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66710,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 491437,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60861,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 219301,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57893,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306016,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7845,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57366,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 241304,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 125108,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 98354,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 287867,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55750,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 26741,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9139,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 513111,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21290,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70264,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7667,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 81890,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 146938,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34088,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19872,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29622,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61861,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7937,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52293,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1407201,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 380135,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 315753,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 266220,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83422,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 35471,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 122966,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68782,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58607,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 89559,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 125621,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75876,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 254378,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 677144,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 163626,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75435,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63513,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310894,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283273,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 735539,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301031,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 177579,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5823,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77984,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98987,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59658,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 29959,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55675,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 132998,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70726,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 203953,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 56156,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 469182,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 333799,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133791,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43971,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7023,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9148,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9215,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 88132,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11746,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9358,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4547,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13219,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71909,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69684,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 49511,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70755,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71349,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36074,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 325923,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 107642,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31027,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 34390,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21491,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42781,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1110204,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44090,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22052,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259691,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8250,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13099,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129250,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302559,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85830,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88113,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 78555,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 172796,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3973,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 125792,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62906,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 142789,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23125,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10270,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94978,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 781284,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 30281,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71436,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 223460,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61995,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 211599,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133471,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256098,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86516,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3110,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75965,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67333,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55367,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5155,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121452,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7500,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 43461,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 144090,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15290,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 137548,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10799,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68731,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90591,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41919,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 206584,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11710,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304755,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 361974,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72085,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 826126,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 700732,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65615,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 695332,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 185804,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 74584,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16383,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 144570,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66153,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7758,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42709,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4726,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 811069,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5796,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 28307,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109654,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104127,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 83923,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59349,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70168,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76595,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1051351,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64664,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 539334,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 265357,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 746802,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103685,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 84778,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44187,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 319671,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128238,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 28827,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79270,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 118632,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101942,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36349,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85150,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 191951,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20608,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106283,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31414,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61736,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10228,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76352,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88656,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 465966,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82955,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96331,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111068,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8142,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6727,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29846,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276101,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55260,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 179385,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 97803,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78338,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54840,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104281,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 146229,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 197511,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56438,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67812,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8171,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55595,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17484,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68556,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312839,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79500,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69127,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 603835,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 177018,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99486,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 540429,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80814,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59318,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96334,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7267,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101206,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6054,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 24003,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288014,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80782,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41816,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55114,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 609036,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306861,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61469,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61487,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58811,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18344,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273203,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59493,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123864,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7107,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43523,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17961,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9540,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20353,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82108,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97551,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57060,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1002099,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66685,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82573,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291997,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16369,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 299889,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15711,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56751,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73772,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109055,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 219852,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69103,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290168,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77140,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30633,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 347045,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13081,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16906,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82733,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74708,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 200875,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58620,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18195,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66623,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 71592,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 40202,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93789,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 93791,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59177,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 37757,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72566,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14673,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4856,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60742,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7676,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 28300,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109355,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 187975,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311343,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10417,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84181,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 317414,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324998,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38770,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57491,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140340,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1278467,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 101500,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76538,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98317,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288564,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70448,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79411,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63327,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54594,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89938,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 92951,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6545,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6418,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 835604,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59894,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4836,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63200,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39659,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56247,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 93882,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12559,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 229270,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 229617,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81251,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 129044,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55795,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99733,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 2198305,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7436,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91935,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298899,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 788105,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 60505,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163878,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44181,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 774751,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7804,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7751,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79925,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 49102,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 21902,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 308138,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71207,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57093,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128358,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63619,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66672,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 181232,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54989,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3174,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 214658,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 88754,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 181390,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 337051,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75475,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67856,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 237920,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 305146,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 104255,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73880,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 34212,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77217,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90280,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 104988,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15567,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56788,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 180757,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7412,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57530,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 229970,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75195,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93150,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42996,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82204,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81257,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54972,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42338,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15947,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139943,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73668,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 154898,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 31116,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54532,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6778,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114701,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 736287,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62322,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306210,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14511,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 16914,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92668,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302237,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11650,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82783,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13928,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59248,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5240,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83072,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10565,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113198,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70387,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1628903,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 660712,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 32203,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 129924,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9356,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1509233,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 24356,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 541795,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44363,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8025,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40812,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57032,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 766830,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119823,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58507,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59829,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 381246,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 323627,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126777,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5015,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 18175,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6106,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 44307,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44497,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 921771,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8491,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71258,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91700,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9526,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 240405,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87049,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75582,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72336,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89606,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 197809,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85407,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79449,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6284,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140034,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7692,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106295,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78716,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55784,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105036,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70754,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5344,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 112310,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136679,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12940,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261212,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283891,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 165303,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324548,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8154,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9898,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 901638,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 871920,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 29775,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9954,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 370841,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271187,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97067,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56263,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 753488,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118792,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 131181,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 34751,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88475,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 18612,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 163480,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39584,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 817679,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60120,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27457,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 178706,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78911,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36909,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30373,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118507,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 423264,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74992,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23434,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289458,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4503,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 670634,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88892,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118195,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74958,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288592,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 854141,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8408,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 203940,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78767,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36653,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 190518,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96885,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 674174,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4727,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 125360,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 131060,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 281458,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4788,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5922,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85612,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298993,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79601,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5636,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27116,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 46855,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 23293,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 220802,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 681311,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7006,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55211,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 99599,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18959,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82792,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64321,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92912,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55419,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8162,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55131,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 58237,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 167983,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 756042,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 179716,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93181,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79188,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 433748,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64668,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40738,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73390,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5710,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6423,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65343,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262615,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19982,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94419,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7663,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62114,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 662551,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 338724,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12055,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5963,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 174340,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 110104,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79106,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14213,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 123401,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 170254,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15654,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 29959,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1050859,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90378,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276872,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73692,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 230911,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43738,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125213,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37706,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65693,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104649,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97799,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16134,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42814,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17866,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40478,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1100756,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 156930,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 193960,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 651921,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8061,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8800,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 135900,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33438,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12380,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115824,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 25013,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43928,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7190,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12731,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9434,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118304,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24475,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 381977,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96840,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 129818,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9663,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 315375,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5773,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54771,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67397,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77342,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8690,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312453,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101871,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 49167,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 41188,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 39112,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 369180,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 26562,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301151,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89586,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 330339,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73034,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26394,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100035,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89118,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20396,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301911,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60036,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 336965,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101768,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42180,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 37367,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262285,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59155,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 107693,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61476,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 909048,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 504484,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66931,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105620,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 20930,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 352797,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 608701,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 100165,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 122258,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10257,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37693,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19787,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43989,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81702,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56799,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 680143,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275608,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 130595,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58064,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111236,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10209,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8736,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 411175,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90721,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10083,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 479163,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54516,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79275,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 116183,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 304696,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 375952,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1067039,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280221,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 141337,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11220,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9161,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97438,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 53238,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7172,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 29316,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5463,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1626187,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 435733,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 42577,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 684088,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 130783,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60465,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 171952,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1059203,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 43045,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21665,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86442,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258281,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 626078,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 864165,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 162732,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 396298,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21008,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49779,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 27468,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163778,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31242,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67303,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2695,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 75521,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128021,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 585078,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56080,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 42137,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 26291,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119207,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 596122,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38244,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79036,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30012,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 568823,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19906,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 139779,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11524,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58799,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 196972,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70921,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 517282,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 28423,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 77880,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 48201,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14635,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 122813,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60451,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 828086,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 386098,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 186273,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17100,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 991311,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2634,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15116,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 57256,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55384,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26191,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5376,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58486,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1026624,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286161,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60832,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309743,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8592,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 732175,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279917,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 741946,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81532,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 58907,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 239754,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 815954,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 154608,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13003,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5350,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 44712,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 274772,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313219,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286041,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93833,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109783,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 503443,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74739,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 57702,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 123102,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 20289,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39195,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93844,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41100,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58380,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55161,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 180886,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 56780,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 176015,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7134,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106446,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 51993,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 331783,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68230,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 92715,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15160,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 188853,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61036,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62578,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13112,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73585,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59316,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 192409,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80941,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5841,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68349,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 159169,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1059149,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 436952,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114225,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13112,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6075,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 161410,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5543,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39983,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84259,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88128,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66583,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39566,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38885,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18745,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119554,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69050,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90483,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77850,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55729,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7730,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12508,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6244,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80465,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62833,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128123,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4837,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123172,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6901,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 265830,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5534,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70633,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37545,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71123,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 671500,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81828,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 112407,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82683,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70514,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4776,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56052,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 90133,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15076,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56870,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8991,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65184,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 129338,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88200,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 43677,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 32090,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78647,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56244,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 176503,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99957,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57637,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71744,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 377507,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3225,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10719,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 342417,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88584,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 409966,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 78722,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102976,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 517508,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44182,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60347,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15057,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 114354,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127524,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91428,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55989,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6208,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79490,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7568,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 295740,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119645,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 2305585,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37140,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26425,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 412595,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 678247,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5038,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55600,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 20732,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9911,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 284673,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86585,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 155878,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120315,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7821,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278837,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1274088,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90248,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 34413,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54812,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30949,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109695,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16844,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56088,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1275964,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5680,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36622,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66012,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 429594,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282538,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9959,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117186,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4579,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285917,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111938,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74561,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 168768,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 155358,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75418,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82556,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60855,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70013,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72304,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68427,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 402228,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7125,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258444,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35261,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58671,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1123526,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101522,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 28620,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61112,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111695,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19462,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 157934,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328554,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 36926,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257646,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77333,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 41160,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 353533,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1595381,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111579,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 56343,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4321,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 56449,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10929,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64680,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12062,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4891,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 119389,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321854,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 213749,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 208682,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63069,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73006,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 343337,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 673869,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 28924,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 95529,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70624,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43528,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 197823,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114844,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 97535,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 720778,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4972,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60448,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83619,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58243,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 41044,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 133123,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280810,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313176,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75232,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27210,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 227212,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57407,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57146,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67600,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9323,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 52124,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113494,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38472,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58932,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39763,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34948,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 48904,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 29275,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 120025,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54728,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 138511,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67188,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70254,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38896,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 22587,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97193,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 98048,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 605429,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43140,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 88729,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58444,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120972,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14024,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12054,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 190539,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54694,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6971,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13252,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 409013,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77978,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104150,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80458,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73137,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7314,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6103,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15192,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 193062,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 23220,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 147062,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 104859,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 994154,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7869,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69276,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5218,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 138655,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 126254,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54760,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 105060,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293518,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306796,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68213,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113265,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2510,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37271,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41771,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5418,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60410,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 97940,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73109,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10086,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73219,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 159041,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 166826,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5465,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 35625,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 140962,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 37673,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57318,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 21553,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 55129,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5488,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103518,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115907,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63829,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328808,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97143,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60398,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5824,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70625,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 330884,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 234753,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58835,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12310,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57886,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6593,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99203,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62923,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 718529,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 127151,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 468633,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 26540,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 444377,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15916,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 61720,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57284,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18480,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 859152,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39571,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30502,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44249,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75980,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 670022,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64326,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76162,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5751,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 590209,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55348,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64814,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 13691,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63747,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 133149,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91853,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140136,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119158,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57280,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68381,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23342,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 50667,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 58026,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 792144,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62339,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 51474,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 978137,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73255,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63241,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63310,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73050,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70080,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68118,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30855,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263535,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113990,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 702162,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64923,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 132290,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69517,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 139893,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56227,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69153,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94235,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98075,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4979,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4958,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 362940,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 32377,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 758895,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87456,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119019,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 170425,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4829,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313785,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68547,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 58120,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63695,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23008,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118385,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11067,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140273,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 76359,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69057,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80772,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119357,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5403,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 39174,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75016,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 198714,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89349,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55265,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 175416,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262533,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55969,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 592702,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94770,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71635,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60936,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38421,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70851,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59631,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74317,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 172206,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7800,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286755,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1526991,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5386,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 469745,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20011,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21680,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33311,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 102115,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 132043,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69114,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86420,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59591,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 107685,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 84161,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84724,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76238,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 331501,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5344,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 517566,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 493562,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6149,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56833,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 176081,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 174175,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 466029,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67506,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 229129,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58672,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71433,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134415,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280454,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8035,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 25426,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56682,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 615369,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321461,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80212,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82284,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93653,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 184746,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 103470,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 31168,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1238607,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44164,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54752,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 391112,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318075,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1034449,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102853,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55132,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62455,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 254218,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1227281,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60134,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 154559,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61064,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 294682,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71214,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42573,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 175270,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311897,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61248,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263001,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55956,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58743,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6221,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27943,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4342,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61294,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 171487,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4818,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 51490,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8669,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 89184,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71515,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67779,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76742,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85104,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 758821,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 157137,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 183412,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77815,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 826103,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5798,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20685,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 76774,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109570,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 22849,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 939582,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 150411,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 32956,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 179646,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130542,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87849,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104034,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57035,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138728,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307187,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80182,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116388,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9852,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42718,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5145,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5601,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 353158,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55391,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74961,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7417,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63610,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 185878,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7390,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77970,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8125,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1159219,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139997,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77455,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 89522,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67677,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38460,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74093,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14059,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105875,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33371,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12607,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65543,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7252,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 158573,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 221799,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301390,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65730,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6467,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55422,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26084,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68432,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82423,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83827,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57996,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 213707,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 100126,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 548670,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72528,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58675,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74049,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31606,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42591,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72344,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7170,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21379,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73945,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 444901,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 401878,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 69434,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72720,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5017,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 133084,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112475,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85318,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 338858,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60229,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 603775,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269296,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9358,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1194500,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107005,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59474,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66423,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44057,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41214,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87182,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106788,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24708,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 206288,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83033,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 24571,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 218759,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108751,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 343829,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83944,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271293,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61802,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61956,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7148,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58301,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 66421,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40487,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101227,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11017,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 316444,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6483,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65434,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 175201,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56866,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5675,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78267,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66925,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6863,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33066,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 600486,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61455,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 88726,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78873,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60453,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57178,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106701,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37364,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13988,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117789,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78939,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74712,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17603,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 71928,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8727,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 134229,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 43704,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91704,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41276,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 533698,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9522,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8528,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4583,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71555,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1330468,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103714,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 36091,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87969,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5340,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 117416,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7498,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7613,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 114651,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71283,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59826,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9257,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143945,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 28045,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70730,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 711951,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77957,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19893,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69513,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80047,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99563,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9014,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 62158,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12641,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11133,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 41276,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105295,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 686959,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4828,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36961,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57312,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 185326,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 95257,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40775,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2710,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60642,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 32088,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 37893,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59094,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79023,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9574,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 385408,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140869,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 104885,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121218,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117457,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108399,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19320,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15719,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112487,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 239920,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 80544,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300117,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4672,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80865,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17670,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56634,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 150269,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 115442,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 152488,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 316137,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64226,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 876874,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59121,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68140,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 761037,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 997990,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 551640,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 352078,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59475,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81369,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126853,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 522643,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 122515,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 210005,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 337618,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276324,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 233784,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 139355,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38393,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5209,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 386944,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82218,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 29604,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 41476,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 178023,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19129,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64034,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 133028,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 121492,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 440577,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76350,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66326,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43138,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9138,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281099,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 112415,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7208,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90109,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 697512,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5001,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6817,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59988,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97956,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5363,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83699,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 874449,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 75682,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25679,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39582,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71401,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21828,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 164449,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 123509,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5281,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 144314,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5800,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 213698,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298509,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268910,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65500,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3220,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20979,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 18819,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73361,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86219,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56824,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 437431,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140733,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1384201,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34617,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 125756,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85827,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55334,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 199499,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69463,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 336829,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12817,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4811,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18763,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16025,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 294359,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5320,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59212,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 237898,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60069,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1310815,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 29930,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 41789,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56804,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55930,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39834,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96428,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45473,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 196903,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56479,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 170683,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96568,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82191,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6776,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7853,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5601,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58698,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 343843,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71172,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297602,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 406191,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58372,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 213518,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6845,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4778,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17361,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 710973,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 534322,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 251712,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10068,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161405,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16471,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 364555,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 881707,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 392702,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5192,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84128,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70271,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62442,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 420904,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101091,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270746,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91413,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77314,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 663849,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 57270,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82033,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23962,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 77504,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57311,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 198715,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10152,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55347,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 355160,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 106482,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88168,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 50683,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 177775,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130397,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57250,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 132299,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129776,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142517,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16409,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131979,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291980,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55662,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 474118,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77571,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71192,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 424293,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59658,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269666,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75513,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55250,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 28084,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35429,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 142230,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76649,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19120,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39042,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43908,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8736,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11789,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 134954,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67595,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4595,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15519,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56209,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35906,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297878,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122731,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76525,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81395,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84530,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101207,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 421835,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280888,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65813,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15176,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67855,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87209,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 39843,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64131,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102609,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39305,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 113866,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71547,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25156,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 326983,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1170542,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59608,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82504,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82952,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70016,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 224387,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97762,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 758167,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55646,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68493,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39031,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63157,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 649890,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68485,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66281,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42818,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77724,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22338,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25028,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107044,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 65828,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78719,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119888,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 174776,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41851,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45904,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116973,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89557,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100465,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 144714,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91736,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38916,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67144,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 108501,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 102202,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60310,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82272,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79013,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112290,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11650,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65220,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 334636,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72594,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81267,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 58107,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41941,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 167692,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55411,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81709,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7188,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63184,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 138073,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129961,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135312,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 120772,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7358,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41909,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18266,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105895,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82646,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59328,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54890,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291619,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58367,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 34910,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 225824,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69700,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 700308,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 13363,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 108610,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92945,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33537,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75509,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27213,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94474,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 26429,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 85411,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27121,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255927,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 95971,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 208989,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93545,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36304,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88678,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13826,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 464598,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 123469,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 315789,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49744,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12135,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84481,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65352,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 134679,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 252953,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 140028,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 369572,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 21400,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4940,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 164903,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 373639,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60481,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73481,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130430,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57764,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 502053,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 125113,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21028,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 751335,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4958,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66298,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256967,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120208,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 32230,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 126915,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14045,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 319260,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9980,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23483,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71368,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73589,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307861,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 287382,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73975,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84602,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 937630,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82807,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67197,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86247,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105751,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 199373,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109436,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5996,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 77182,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75231,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11603,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92448,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54713,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64711,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43891,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79501,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 926442,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 869336,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 185704,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123457,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6800,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 13599,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58930,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 332358,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105625,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 497670,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57382,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 225018,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67372,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121761,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99909,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43911,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 171094,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86861,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4742,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 35777,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 335751,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 162120,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114413,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13326,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59524,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31935,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77175,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62480,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88841,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1084973,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288150,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61207,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 265721,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68056,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 341993,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42840,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68413,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5848,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20541,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 75817,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 98687,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14877,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111206,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 895676,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121765,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3101,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 749250,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1060129,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78866,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 156181,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10310,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55059,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101297,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11662,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94957,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85950,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21169,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 72246,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55758,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 343878,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 679153,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106702,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 695168,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 144479,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56409,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 16554,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 70737,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57710,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107660,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 719684,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63940,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5609,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100417,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10854,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 56149,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 209116,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 78707,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 41709,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12913,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67111,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70996,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 386260,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 642134,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68616,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120166,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4746,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 20478,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63270,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60929,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73296,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29289,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119946,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5003,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270835,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114309,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138316,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 599262,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5139,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30346,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102971,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89545,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 629020,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128221,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 184575,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6001,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75608,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 188218,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4471,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14280,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255849,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 692540,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111226,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70557,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 25335,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 99836,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 894221,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6667,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 343374,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55156,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73390,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 666162,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 101594,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37876,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18193,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 146838,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 47029,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54583,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99829,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1186886,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37225,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 213801,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106888,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15671,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74045,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66986,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41883,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56632,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63359,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57002,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6609,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 38033,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 175784,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19848,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291355,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 132599,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 129169,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58576,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 408056,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 848381,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10692,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13398,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42920,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92162,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 178948,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 331706,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7793,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97166,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 441071,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 779275,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 237625,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63038,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60806,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57860,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 171373,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 159124,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92854,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22085,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61597,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 107046,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57861,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 791379,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 163340,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57616,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110512,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 463079,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21253,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57007,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71225,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6871,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 103473,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73081,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6253,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55211,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58950,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 148223,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56213,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6477,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96980,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92964,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95245,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29720,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1083329,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8174,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87082,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257577,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 25935,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59482,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 221312,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 344977,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74516,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5147,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 315608,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 606041,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92345,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71460,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 18800,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17022,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111494,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4960,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9551,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16985,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55412,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82236,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 444989,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58105,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90442,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 954217,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296058,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297957,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10135,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7934,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37154,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92056,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4619,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44248,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 126632,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 154133,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14111,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 283450,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7417,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7771,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64305,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6153,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 88633,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282683,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 170432,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72144,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 62489,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 299902,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 287983,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86392,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126855,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 168262,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311791,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 56371,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91634,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17042,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15485,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 20358,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9045,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7547,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268007,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58603,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59288,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 114443,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 908322,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16471,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10508,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100577,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 192728,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114272,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42807,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92044,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 140624,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68835,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99007,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56114,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5109,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56057,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39145,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59711,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62134,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4062,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41246,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8434,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69685,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105424,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 25641,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27640,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8944,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 143017,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125813,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10410,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22800,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107263,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282685,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43462,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59569,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 171070,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 402251,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5860,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69979,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10500,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132894,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60834,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 164393,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293963,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7813,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72775,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16739,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 50076,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27204,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62230,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 264220,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135100,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128952,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74916,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11496,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 216955,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282500,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42461,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90316,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109067,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 143127,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35693,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5761,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112628,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8409,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61771,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17981,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58488,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8434,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8698,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255552,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63711,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 553601,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6438,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129222,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1349193,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90196,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40709,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 97497,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 212343,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92189,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 441877,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69807,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 534678,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4978,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60574,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85490,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21664,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7567,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31391,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42385,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67788,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6271,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70420,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 345329,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56130,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21011,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 423678,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60727,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286756,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72052,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104371,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 234616,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324210,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 341962,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 50629,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 75538,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 620817,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 200525,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93409,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 171183,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 165592,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77345,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16761,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63699,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112720,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 27916,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1590707,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163022,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94097,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 32392,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75223,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26637,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70447,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55431,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104052,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 415524,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121038,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16032,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 83567,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 826052,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58449,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43626,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105575,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 170212,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39659,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85151,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4318,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 27311,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8460,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59437,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 152886,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1212227,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 329378,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25005,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 126366,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38766,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71900,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103349,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72945,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 199972,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56389,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78411,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100146,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 319417,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78919,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5359,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 459040,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77342,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93736,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 28458,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21935,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63421,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65008,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 972895,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72177,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8084,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 388895,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73075,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33214,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10893,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80127,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11718,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26147,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83711,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4456,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124572,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71797,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 98483,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68308,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8271,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9131,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42593,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 177309,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59404,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7608,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1114119,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36615,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2748,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2782,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9965,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54982,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67429,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 476262,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63691,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 37807,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41248,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102164,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 164465,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 254819,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57370,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37747,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 686584,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103003,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119689,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 83370,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49815,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 677628,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80631,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7179,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10210,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19844,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 58053,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63740,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 229856,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 262612,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67114,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36927,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 170239,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 325333,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 25545,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60462,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 24425,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 193632,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49996,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127286,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69100,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6058,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33552,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55075,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1070179,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81806,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56620,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77850,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256220,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55752,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88690,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6490,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55590,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77037,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14314,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135778,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 332758,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117787,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14546,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1230605,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12551,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105910,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 939986,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54891,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 32910,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 788336,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4912,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8605,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65400,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6843,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 113873,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61423,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87993,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 186454,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 204640,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114966,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56184,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71594,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82654,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 239603,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63826,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59713,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83348,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 178686,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 144018,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37163,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 636695,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 140931,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 36517,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63049,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105659,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69326,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 299131,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71495,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290574,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 44004,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 175082,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 709631,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 140837,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 504680,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66649,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85912,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 85464,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14898,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41160,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99403,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 776556,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 99279,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75885,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55342,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65426,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 323185,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60746,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90153,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 426819,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1080108,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42517,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276129,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6855,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123843,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56205,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273231,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 33091,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 206560,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161901,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11073,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 334569,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63376,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35582,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13722,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 88122,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 96673,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56259,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304266,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 80892,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57098,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55452,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19441,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55911,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 296287,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6625,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 227060,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 573202,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270912,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25037,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 96527,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 168805,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57222,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 323648,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30892,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134487,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4926,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76040,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118961,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293451,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72764,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3449,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123480,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 57029,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71223,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 95061,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 327050,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 140805,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85048,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109496,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34309,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7970,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15638,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55182,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 26857,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 177302,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8413,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69581,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 415606,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83358,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67379,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 94394,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40234,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13398,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4885,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 60491,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 694988,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70429,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 517716,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256617,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293576,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111630,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65423,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 120734,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55238,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59943,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96311,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 161519,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126639,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 116586,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 97141,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15984,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257275,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43191,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114499,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60429,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60676,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 43342,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55187,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7949,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42905,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91292,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 463533,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69953,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79194,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 166783,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61225,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54861,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98006,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61730,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 112683,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 59338,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161862,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16491,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 56781,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 720427,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55105,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 171484,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54791,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92877,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 125108,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 28534,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 18777,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81722,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 338208,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127327,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 396903,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12017,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 177156,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39510,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55800,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 103585,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274565,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302201,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15122,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56462,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4940,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71891,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260393,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73826,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9362,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117539,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 50948,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5307,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 100804,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77055,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129566,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 237408,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58050,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90207,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28743,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298996,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87723,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 315135,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 62033,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 62719,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9224,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267174,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 29860,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79017,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307439,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 28412,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36117,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63659,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 481964,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68577,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 452686,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19668,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 216791,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 137989,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288733,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30403,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 220837,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60942,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67842,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107670,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91760,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 165384,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55209,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71834,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1071926,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52882,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267481,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7937,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 93026,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55036,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20745,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272814,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63151,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55114,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42485,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 628306,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67305,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 118788,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 330793,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 378919,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77324,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1391881,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7550,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 72989,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79580,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54884,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 121891,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133798,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 169678,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 28679,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 143726,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278039,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72228,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71843,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4544,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63110,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14873,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90508,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4597,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69989,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10762,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6732,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67116,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 37827,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 359679,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 211662,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 238465,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61326,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 106256,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302641,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59933,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36333,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 176439,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81925,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44353,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12428,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86760,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5111,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 104293,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15135,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69487,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10940,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94402,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57468,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111975,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60482,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 159023,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 740742,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 162597,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 200208,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76175,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78310,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75255,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94385,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 33806,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59379,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80008,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79457,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43753,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 200233,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 135173,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82118,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143817,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328368,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66454,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14895,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6570,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 70569,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19478,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 97276,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38651,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33707,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 43016,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35126,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5230,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 539116,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 301239,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31593,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18130,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96898,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 230512,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66467,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 105440,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7272,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55160,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 191141,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58529,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 35775,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67678,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7183,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7278,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 120948,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12680,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73917,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20550,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59506,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4679,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65745,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267307,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100446,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 196955,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85586,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34953,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 234758,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9088,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50557,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 166581,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62360,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5489,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 375267,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14989,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59080,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78873,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15867,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272755,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1505526,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 371737,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6295,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96698,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69444,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7405,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15937,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 134049,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17611,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 116065,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281353,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6043,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 378834,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21228,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116131,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9914,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 738043,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99274,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17248,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39721,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58052,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86529,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62436,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16414,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9705,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110309,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1278169,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114547,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99268,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 30615,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56896,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 167444,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 169039,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65894,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 364583,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41771,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12974,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 35768,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 203187,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 51042,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90909,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104452,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 218066,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 55210,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281409,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5796,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55791,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5427,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55437,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61952,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9284,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44626,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43616,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61883,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 357940,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 339677,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281497,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4654,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 117905,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 810553,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40171,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 52450,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110490,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 41521,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 616485,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44021,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63985,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63374,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 333778,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 54393,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57878,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261555,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5240,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17846,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 25885,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 40135,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 671046,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55205,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 88302,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135870,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19020,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19400,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127238,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5306,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12768,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 73829,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99375,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82378,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43413,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4815,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7906,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 807500,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 355663,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 199121,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138764,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 75574,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 186177,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310655,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 197203,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 885345,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10086,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 693306,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312530,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 71588,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 48847,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 62946,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 203058,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 637521,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117872,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 3386,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24325,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77234,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76188,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9310,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55919,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8727,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 328054,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33653,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58781,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269828,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8072,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95763,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71273,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1109178,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87155,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15849,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 34898,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300075,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 31063,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13480,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58304,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 62520,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1270105,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55360,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 573484,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 3999,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6192,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81658,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35102,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6199,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 166281,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 70699,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 535503,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42489,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88663,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14454,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89584,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279354,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 240244,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127354,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6365,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20025,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 578015,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79182,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9728,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2552,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309369,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7482,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82566,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 176035,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133102,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68721,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67438,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16167,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23170,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8846,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38882,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70608,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 69012,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77678,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79004,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11002,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271938,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 596579,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1775239,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92731,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 868354,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6991,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17440,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 991764,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92446,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 59003,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 75835,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78558,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 116009,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87971,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21501,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120850,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55037,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 58512,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 204195,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 540851,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55616,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9376,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 73500,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69278,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5167,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 74194,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318478,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 43532,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92742,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 965289,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55737,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12432,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 158324,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55642,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8335,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81524,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10586,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257434,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5153,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 28438,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7555,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50996,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14285,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104888,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163846,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57249,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61493,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98268,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 194992,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 611105,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 116670,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18644,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131797,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54869,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 160517,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67709,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 137890,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275734,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13251,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 217284,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63252,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56311,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310454,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102925,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108985,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16446,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6375,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320524,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 209700,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75737,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37009,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11632,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120438,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68349,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 85586,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291543,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324267,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279169,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 509951,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109208,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 184674,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 475371,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118239,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5440,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8201,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6252,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36089,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 345758,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6982,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 30820,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111500,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 91271,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 115421,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 716674,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 85681,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60057,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 25754,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 37367,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 76569,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256447,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55409,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17509,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71540,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107563,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37784,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67111,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90425,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 136712,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302442,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293011,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6125,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27095,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 712291,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270044,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123820,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58442,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74658,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 202691,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38690,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23316,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22689,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76022,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255153,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81648,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1503649,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269251,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4942,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124647,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54724,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8812,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29921,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63803,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4734,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52407,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55845,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 478794,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304800,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39129,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 32648,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 136792,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115985,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58238,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17784,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71058,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69824,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118453,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 222838,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 246156,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30539,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 170566,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 361060,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58737,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267613,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 974172,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57684,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 736194,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70099,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 190500,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 94623,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9188,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318081,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35384,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4964,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 96315,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108293,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 36090,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 325824,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271540,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20436,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127297,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4290,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288610,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6227,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71111,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286689,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6530,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7129,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13252,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 342005,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13035,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79046,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110209,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139801,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35151,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 50216,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9606,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 458851,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60071,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 117174,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 20101,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83919,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73215,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 642198,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79679,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4508,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59115,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 102998,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 41719,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108403,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 655897,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 202504,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 340375,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59023,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67811,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56759,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61417,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 13144,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 131970,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8717,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76017,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 156823,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 592283,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72435,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 59900,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5600,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 121389,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 53452,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7633,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63409,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 70782,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85812,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301896,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 364662,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29379,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10630,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69024,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30769,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40539,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85784,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12339,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 287365,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74626,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 740438,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 59281,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 164742,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 74032,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55045,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70604,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135131,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 108530,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11194,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7131,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 183806,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37354,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58281,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28770,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5315,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 484493,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77104,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13647,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59336,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 28557,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55967,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89304,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78616,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 3556,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74423,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9315,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60837,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36187,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19762,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 176277,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55597,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124673,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59522,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55759,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 189041,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5004,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 611473,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44288,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 139538,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 131905,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 41175,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6608,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 54908,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63481,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5344,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 155204,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 99264,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94721,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 339524,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64287,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91331,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91831,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 113470,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66535,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41689,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130574,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 77918,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 59121,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4559,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 953100,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 18329,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 295883,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17814,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 30836,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 238366,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277603,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 141252,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24216,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8557,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56303,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 585049,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255179,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81951,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8527,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8650,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24420,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75105,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 926267,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 391606,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9708,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12948,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5396,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 55042,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66755,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56669,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83215,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 374403,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55967,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 86097,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10174,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6001,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60246,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76708,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59937,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 517177,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 372370,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1328899,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 442492,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 322717,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86652,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 79886,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67566,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6245,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 303381,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290815,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55468,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82641,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13305,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 25477,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 36232,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56573,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8037,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 38048,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82968,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 429903,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 100515,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10582,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320207,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 412732,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13325,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 212937,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 20140,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133040,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 555875,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15345,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 95241,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27198,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 60355,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50925,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57607,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130199,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 420604,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89300,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62441,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74402,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309038,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278072,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 85193,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81843,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26781,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 230596,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12899,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96696,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6499,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57818,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5630,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 355831,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 807392,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56154,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5863,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 56051,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 25741,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84186,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 204267,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68527,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 44462,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 576349,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10681,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4829,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292410,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52834,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 294727,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 961245,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9829,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89088,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83101,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99023,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 317124,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27053,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 246337,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135078,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5325,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89176,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15605,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 919013,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59185,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 43505,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 92719,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 43081,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4804,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 187717,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15362,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12232,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 340874,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40336,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 157034,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 141247,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97958,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92662,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 220799,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57933,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 546608,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 160332,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57026,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1050272,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 250243,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107402,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55896,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5967,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60249,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17053,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59602,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93537,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65871,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 303189,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261115,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86089,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113689,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5859,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78282,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37957,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13007,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290174,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60933,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 515317,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 30447,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 87641,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 100332,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60746,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 139699,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68577,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 536568,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67045,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1347667,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 631349,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10033,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5192,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 586063,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43839,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120553,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1045682,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 188984,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91852,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7324,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68370,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 132745,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71889,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 681174,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6544,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10111,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104620,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55530,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65007,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 36642,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79821,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 129434,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61555,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268741,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59576,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277822,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133347,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64438,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4811,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 730632,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257561,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38955,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31295,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26224,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 854750,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4776,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 72297,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 129322,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 22294,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 231905,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 112685,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20754,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 32380,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 181158,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107834,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 33455,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 447844,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 760749,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13837,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 358126,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37365,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 25848,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41110,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 101708,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 116781,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55995,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8662,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 401914,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 610602,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 264594,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69168,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9397,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125806,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 104128,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 369733,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67331,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17737,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 303690,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6970,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70191,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 331360,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1330513,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8070,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39383,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66557,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68203,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 624046,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64850,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 172885,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328349,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6933,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12772,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 28494,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 96007,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40848,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 380643,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 84953,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1475474,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 127470,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139965,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 42386,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62126,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 510024,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9930,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 229061,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276690,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57806,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28173,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56118,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30798,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 299003,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92651,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3220,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43644,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84596,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 41044,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60423,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12027,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84152,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81086,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68056,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55499,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297420,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10506,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60118,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277499,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 664362,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65650,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6707,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11153,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15729,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 96476,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 877203,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 861683,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76046,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 56386,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69309,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4838,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 812015,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 34275,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 841137,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 125144,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 128139,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69494,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9432,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 35578,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 225794,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 35152,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90286,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9432,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75804,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67675,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 465662,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16668,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70124,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10601,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63003,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87243,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268602,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 196453,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6314,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307228,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 40434,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 39880,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6466,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 102763,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 27024,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89781,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101006,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114663,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6472,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57995,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 144309,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 671378,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 28259,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70437,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62090,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31025,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105629,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55204,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60915,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10640,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298570,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 374701,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 22021,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 80194,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261783,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87930,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 142351,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 178240,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7451,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42067,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128945,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 56729,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1088292,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69842,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 138304,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64243,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 663673,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 807632,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1124115,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1090755,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136468,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80598,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20379,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 643060,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 59098,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1138788,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 35164,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60023,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69648,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 90926,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71447,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 674951,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 116170,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 106515,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 129624,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14167,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 343425,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59965,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 227107,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 598133,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 37234,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77885,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 113499,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7483,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 851173,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 677052,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 248759,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6794,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 605814,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44244,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76283,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 368052,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104584,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 81533,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 700531,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 978023,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58116,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110943,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86475,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 687363,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 13396,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102538,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40151,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80622,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59123,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81235,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6606,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79692,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54884,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11324,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111431,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84647,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37165,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 28817,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8425,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6840,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 235915,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 52221,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41235,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286339,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16509,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 873482,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7568,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 33712,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58155,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56134,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 859695,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 37157,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312245,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73605,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272605,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 49573,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5567,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310723,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103191,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17865,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79678,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60374,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14891,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56244,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288819,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 229179,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5166,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42593,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4595,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 557183,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 222777,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43995,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298060,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26030,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97470,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76704,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 153430,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16205,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123133,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58419,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65837,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 227153,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9939,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 87312,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8630,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 775705,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41165,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 579435,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 62558,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 763138,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 331406,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18254,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 96196,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 48206,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85919,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10294,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65215,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6968,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77966,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276568,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96892,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 188548,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 360577,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 579565,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36180,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5082,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40727,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85832,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114775,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 42084,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 607807,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 439737,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 111139,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 201169,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1459327,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 132763,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 138403,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10096,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 376764,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55708,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 40873,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 92014,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 119840,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 191546,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 125443,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 67283,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1070163,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138600,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6485,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98886,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 769476,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255866,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17781,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102541,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 110803,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 40628,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42227,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137258,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82556,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13472,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17780,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 172246,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21925,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12903,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86593,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63581,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 42071,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 197202,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18194,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70156,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92934,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 71050,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 226270,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10949,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64085,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73759,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74779,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 26222,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 110577,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81759,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 265744,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55195,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17072,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 201555,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56598,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64971,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86279,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 838866,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105851,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56839,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103972,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 142725,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119046,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 809487,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 157345,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 124739,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55475,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57543,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 648754,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 126960,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9279,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5631,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91986,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71141,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10170,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11608,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56419,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 124779,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99236,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137815,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18757,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35231,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136453,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 106150,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 308831,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109800,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56413,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134993,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 172471,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10957,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102271,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 29006,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 364726,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 405930,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6652,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99799,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 521825,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5425,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40620,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5438,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 69345,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103100,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 43925,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55006,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91745,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73006,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 476241,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6797,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1006618,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 699189,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139647,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 958110,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 944076,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9488,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283374,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23175,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42484,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91404,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 216817,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 338816,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11865,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 224379,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67975,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 253612,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272002,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5953,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73463,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76278,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6663,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286365,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19382,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40189,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71618,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66191,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 35739,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8179,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 46264,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91713,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 188508,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72079,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 112380,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59343,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56190,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107420,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 183579,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19304,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56782,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82214,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94218,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60134,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 71998,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 176192,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8933,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12974,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36829,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58228,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 129330,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 266589,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114180,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 97425,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 112943,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109065,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36516,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79484,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286263,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 81391,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 123243,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61484,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 124941,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79331,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69843,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21056,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 49266,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5988,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67777,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 580167,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87288,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57674,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4976,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64208,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 101816,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 16379,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55680,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76831,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 823166,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55414,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302334,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103935,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6661,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68202,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 687673,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54672,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 159832,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59454,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285507,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27964,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9526,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21996,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 50135,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7338,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27768,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91506,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278360,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70101,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93165,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291781,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 472033,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 23673,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64365,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 49237,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27167,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111198,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 41929,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64342,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12098,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81727,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 34893,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 37607,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17726,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93207,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 143532,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15800,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118628,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9619,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 96612,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 141578,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37791,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7190,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 989627,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 777663,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15748,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11681,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 235707,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 59737,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84285,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126784,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90566,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269063,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 186840,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5287,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 25974,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 652301,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78412,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 88658,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 135605,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42177,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136700,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 269406,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324712,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283955,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10016,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64689,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 81873,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55920,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 465925,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72734,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1887308,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 41159,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 75770,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 575982,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68454,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64393,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59859,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 111367,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64980,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271214,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59131,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 66237,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 122683,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44204,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78381,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58785,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 58726,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73963,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110593,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 82841,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 77454,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64563,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321484,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 98851,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81371,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42454,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69198,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100618,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11307,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17746,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 295020,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64444,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16637,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5618,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 813468,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55314,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 202131,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 172086,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59687,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 59273,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64883,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 765778,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 94140,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67231,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 224300,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82828,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18512,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58294,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107257,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 174251,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70559,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8628,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309044,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126824,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11100,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57944,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 131859,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 443496,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 74227,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 113628,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58675,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 399727,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75823,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4815,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 22074,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 38014,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2934,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117616,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99012,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 78074,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 697203,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 317912,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74598,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 170726,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 134398,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55696,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73583,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64316,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62633,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6400,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 954613,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54579,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120978,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 80209,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40629,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80787,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12309,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 795350,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291916,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 409163,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81052,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 560142,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57075,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5179,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 182259,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 443539,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57899,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107869,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55107,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 165874,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59153,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11379,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 30928,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 107952,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10557,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1393361,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 101078,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 513626,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 56753,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57230,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16430,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79978,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5326,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 95585,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 331733,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108191,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5084,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 91981,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 359767,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59424,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60457,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 678931,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63196,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89466,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262190,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84408,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6556,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10978,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140811,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 363245,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127014,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17897,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 186567,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78193,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58636,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38836,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 335393,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70795,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 341033,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 91987,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165478,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10238,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 186614,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 505537,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 114039,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42692,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 81040,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 175179,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96612,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6123,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83196,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40070,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38430,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163467,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261078,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 249757,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93976,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85177,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 174951,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 475993,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321528,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120046,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78946,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60148,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 32640,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5818,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39415,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39425,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5269,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44500,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 479365,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41210,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 133472,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 404970,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38728,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9916,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92167,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43528,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2576,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 44030,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62990,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108221,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1334113,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65354,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256759,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 126389,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20876,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 49166,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7428,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4081,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62269,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85202,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 824731,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7375,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18954,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 127242,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63350,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9866,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35091,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88646,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 29686,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 270831,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7958,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20933,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41195,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30208,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 97072,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 158034,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9035,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19819,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 434506,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87826,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128824,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11339,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 912816,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101193,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 121828,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92752,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117865,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54915,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258986,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10095,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6336,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 31370,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9033,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 3880,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12012,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 123338,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 3636,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9385,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 420159,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 98513,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 260904,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 254477,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60737,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5618,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 35500,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58893,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 658369,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131931,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57256,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18272,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 399725,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55516,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111436,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39229,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26867,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 131275,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9659,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8182,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 789840,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286549,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 76255,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14619,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77945,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56396,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 73424,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90885,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 185509,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37010,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81602,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7847,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6105,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 93503,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328463,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6964,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163569,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4745,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75810,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80080,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 158834,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87933,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86599,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70704,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 205161,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56151,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 682282,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39459,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 182410,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14782,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36439,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93325,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 58052,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45577,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280098,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65741,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90685,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64461,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69848,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17436,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 97784,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21176,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 611270,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118682,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142361,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55950,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 23291,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68336,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78617,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94534,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 939028,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 336276,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 107522,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 126456,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25239,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1170424,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62075,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 185283,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18274,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275564,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4562,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63210,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 927395,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 53471,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54634,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64267,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 599834,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103935,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57687,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55139,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43180,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 131928,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58873,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 145633,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 294243,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72856,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6638,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 141298,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39923,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 294143,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 192662,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74470,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3244,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133439,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 24892,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 42063,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8962,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115646,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4213,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21809,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86545,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 582483,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55322,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57287,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63484,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57451,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9494,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55090,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55006,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 61619,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92997,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 206327,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1173430,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 113280,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 178149,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88751,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62944,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8735,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4727,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77816,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101390,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56639,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 84897,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107125,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114245,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 138663,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111435,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4976,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17253,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63008,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9620,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27350,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 25815,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 114485,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87060,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282745,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81823,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18749,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36576,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69681,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5966,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 192499,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 159574,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 41791,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7483,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44017,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 154715,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74116,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16750,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102454,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27162,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73163,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 337518,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 672855,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22188,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 585936,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 612750,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81264,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 175626,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11148,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10660,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18798,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79450,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 201333,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 305171,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4839,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 84450,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4880,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104038,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70071,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 37128,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5080,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 60693,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 676542,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 335208,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1359844,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37499,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 30348,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 315676,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 124022,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 336183,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111597,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69436,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16981,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 28816,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 122634,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8955,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6477,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 105882,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55935,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 2100545,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10755,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310851,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 797568,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83572,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 35766,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111300,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17303,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4949,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26485,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20392,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55074,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 443521,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 106968,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71113,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67818,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 122637,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91677,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 519613,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57821,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 170825,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 412865,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55251,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1077255,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8041,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96523,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 159306,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18447,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 282022,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39873,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 75177,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75432,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 26079,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50541,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71495,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6241,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114553,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 37919,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 265047,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5236,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42675,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 533524,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 265283,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 98144,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 519429,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 725913,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12533,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310458,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288809,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61911,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11812,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 26207,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70101,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60992,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6869,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67299,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13793,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5202,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 47679,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 44064,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 64875,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 186656,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18304,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 180872,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24221,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81504,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81874,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 701383,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54102,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43211,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58455,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 207659,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 181059,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55483,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9605,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57895,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119837,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 67036,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12971,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104439,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69917,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58494,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67490,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7780,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 190349,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 285179,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4702,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93941,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9845,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70435,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131557,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116348,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69720,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91578,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68503,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4526,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69361,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79340,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293576,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 199373,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73057,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 143486,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82598,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84936,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 46559,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44748,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68742,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8703,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 198913,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31677,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83435,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74608,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77047,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 552322,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 31543,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125107,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 343192,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 70995,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 180815,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56171,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71314,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 47580,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 169972,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 252164,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77524,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 601950,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 332650,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300578,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304423,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8423,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89067,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60107,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9586,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12626,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1051451,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 182735,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 806201,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99102,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90563,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 183097,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 45421,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81086,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1027437,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85423,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163790,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41840,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22703,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 176912,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 602406,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19699,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129751,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16283,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35540,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5870,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8465,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7524,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 46160,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 935016,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54680,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18617,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 176206,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89944,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 339256,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259731,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96868,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 389479,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71245,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85521,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4667,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 630840,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88636,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 58316,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 82646,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43848,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 229317,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 259263,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 618452,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 608539,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 60381,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 46409,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63679,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31945,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64310,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 249256,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19836,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78408,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6277,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 103947,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 18309,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290520,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311042,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95825,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 348465,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 201514,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 142134,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132765,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302552,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15908,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87806,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129394,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 100678,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 160656,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73040,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277597,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70098,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20142,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 221269,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38494,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7571,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 641700,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283967,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55918,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12749,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17432,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 75855,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36236,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 169564,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7196,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7500,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 35355,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40351,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15760,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57762,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4601,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81968,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7088,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57871,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71507,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 221329,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8243,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 692921,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 895641,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 31318,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 88803,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75457,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77124,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101639,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18126,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 52197,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1544172,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96791,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43992,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 170628,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318048,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 203545,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133803,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 52054,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 29193,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110635,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18533,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131467,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 223646,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7486,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 425465,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 118978,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20761,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 27340,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 341423,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40773,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 191843,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35362,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69598,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 172417,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 110169,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8891,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34551,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 222695,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39253,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6820,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 155384,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 99807,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41167,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 677613,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 67657,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9907,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1151970,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127954,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57742,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95605,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26541,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9235,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82877,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 776259,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54805,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 185859,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84502,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 261186,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 369913,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55565,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11051,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6503,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76163,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75376,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6988,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19479,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11147,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97798,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 753627,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90156,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38270,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 20492,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 134744,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 319506,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 109607,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131334,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1633573,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 372725,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7626,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58424,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 369701,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56479,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55885,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 34631,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 43529,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 425142,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119082,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34628,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82523,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79464,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54890,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 40140,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 129021,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 878667,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56176,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6847,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59204,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67556,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66804,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42012,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 123339,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 625876,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118581,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 127648,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 21512,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5231,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16596,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 110991,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 959498,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20778,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89820,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110298,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260552,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9542,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 83240,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 264688,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 66026,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260748,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58584,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54566,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68982,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9236,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1188940,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5095,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 815016,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 154693,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 145616,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61380,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12448,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100750,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5753,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126878,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74233,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 685473,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4727,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13427,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55289,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55114,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 75101,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102785,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293441,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3105,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70883,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 60647,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 330884,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 109607,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 48222,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63287,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38380,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 551699,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 364600,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 770765,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42156,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55295,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77545,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139526,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 314222,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68029,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 93492,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58825,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8782,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 665383,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61298,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67428,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11919,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88562,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5422,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37386,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11267,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60565,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79965,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12719,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68951,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 57067,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4513,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62898,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65906,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 41920,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 132176,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76783,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106579,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90234,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49050,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 441999,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 188323,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68495,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126612,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5598,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88057,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 240874,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62431,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72667,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6580,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280728,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55474,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 205742,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119215,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30092,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 212150,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 41995,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9913,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8631,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4939,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71666,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 739494,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11913,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6606,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 636549,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 40743,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 81981,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 120510,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99186,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104840,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 34085,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57864,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54624,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 558311,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13462,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5230,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 3018127,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 73100,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 105678,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96166,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 192274,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58232,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59291,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 39525,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88099,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104025,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 137575,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 172904,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89825,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 180161,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6874,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 114133,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87196,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39718,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 233904,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21713,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280366,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56521,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 178554,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58151,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31441,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 104120,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143992,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 35028,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40826,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70582,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38772,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109574,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74555,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68513,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 646339,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 265967,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101707,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 201656,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6535,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 34409,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 27140,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 111395,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 333801,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4902,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261500,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11306,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63820,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 182475,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38499,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3010,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57029,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 128304,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 70096,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8065,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 530092,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75474,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 87560,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100951,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 204394,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71586,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55162,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 396200,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39605,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14228,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297152,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 109160,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 62555,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65564,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12298,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 702399,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20029,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 54593,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68589,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83054,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45872,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 331979,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68566,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73410,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93819,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 756271,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1096376,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 332181,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 365093,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59174,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 40732,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 782693,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 497696,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 874292,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27479,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260510,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62406,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15808,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57470,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 265104,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42809,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73340,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 53469,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81729,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6200,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 40545,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120196,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122971,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69973,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1086014,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65783,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23289,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65138,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115007,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9729,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 221262,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 36295,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136856,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39897,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54790,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7035,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9478,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72715,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 190087,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8006,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56643,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24710,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 159665,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 500784,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83367,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84434,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 340909,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 455164,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71359,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 596564,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 392244,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5496,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 57440,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 30764,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99111,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76605,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18104,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22791,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57505,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42870,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 707896,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 366377,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 476421,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62351,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 173020,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111143,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12466,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9023,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 151923,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131268,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 18408,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41107,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260634,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 78308,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59482,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 212999,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75263,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62316,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 59687,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 57065,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 109118,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60433,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7091,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 232960,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71816,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 880805,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66006,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161899,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6279,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36842,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143540,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120551,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71442,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68500,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59123,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87990,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 30956,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 101364,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57019,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82874,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 554521,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 143944,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60298,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 164084,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31651,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66357,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55444,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56436,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89760,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71483,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12484,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 451274,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 373166,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13463,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 76080,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 218149,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 58709,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58266,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263177,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56206,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 97427,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 957486,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55512,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 29204,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43328,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 404718,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107059,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75818,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 482785,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4770,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 132639,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82815,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282773,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104218,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 169794,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7692,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15628,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270786,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56178,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63222,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 240951,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17546,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 953166,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55132,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59653,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 95260,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35920,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7031,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61671,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59487,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16590,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55777,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161499,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91049,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5341,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73034,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58325,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63110,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 29944,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 26441,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24269,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 32460,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 121970,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84536,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10962,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40751,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 87181,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 536136,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15928,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 361498,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 238829,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75528,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19042,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42269,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 542160,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312434,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119849,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 803441,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38412,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 250745,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 357222,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54190,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 720767,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55660,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63257,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30268,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 141381,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57405,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115040,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123509,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55863,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54746,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57022,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59672,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14683,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7247,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 804239,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97753,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57911,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267500,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18340,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 56943,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 184745,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63831,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 734955,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 169755,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74349,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9338,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56455,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 906369,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 38501,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 196532,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 436952,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 844486,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38795,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99529,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 105264,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76514,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68784,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63068,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 377897,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60318,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85357,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 78474,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16616,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 215646,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13029,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 178877,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 25119,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8001,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67254,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 722821,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 171150,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 355493,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291117,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89777,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 92742,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 220684,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60340,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114986,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140076,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 357723,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 89994,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5039,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143930,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81857,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89903,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64773,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57405,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70007,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96955,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 84659,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 344268,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 183782,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130775,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28383,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 376052,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77801,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1102869,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277213,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63627,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55106,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304184,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83156,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 875999,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307908,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60014,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 416469,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89524,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 27536,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 373623,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 252139,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72850,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8574,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90816,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86948,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 624990,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19705,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 176620,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56436,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50003,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84773,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10624,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6630,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85464,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 80997,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 513371,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55079,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7352,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274869,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7416,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65037,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6470,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85980,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 174962,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55949,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6883,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117611,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 139009,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259036,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42720,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 411520,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283547,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 116193,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7148,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 94841,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95791,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62960,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274089,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6192,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306470,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110255,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 318504,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126093,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 181858,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 29454,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90970,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 113747,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75521,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59108,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99849,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13287,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66258,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5680,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 236359,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118648,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73023,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 103452,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90821,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85037,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13465,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71949,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63258,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75552,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64336,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7419,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70363,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 39433,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19388,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60457,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21900,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 659653,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 98053,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11386,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 22912,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1463911,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73680,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298801,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111083,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 594584,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60364,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 123696,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 370436,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291776,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5966,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69437,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1165961,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31614,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55658,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 155826,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 103314,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11916,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 111241,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 743104,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 77124,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17099,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321834,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 122643,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85444,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42132,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19069,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 528006,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 358103,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58199,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9322,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20912,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4603,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71821,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 761337,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9167,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 247249,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261748,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 44456,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56238,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43322,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8626,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 186392,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163306,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8866,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120408,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 264532,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 135643,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256829,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 685812,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87699,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16671,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93114,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 698425,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 135569,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119185,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55112,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62293,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11406,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21182,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19719,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 273722,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 80475,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 59992,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16415,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 55618,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17247,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57863,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83305,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 325565,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 489613,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114048,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71568,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5619,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85194,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55665,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8752,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 81442,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110077,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 100042,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70208,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5762,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58599,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57518,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10304,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 268707,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4759,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 390488,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98434,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 81013,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71809,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1028707,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42809,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1213096,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61500,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111595,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 107810,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16260,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 75746,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65374,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 569620,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7794,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 134601,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34648,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10136,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23630,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 234249,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65538,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55678,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 707744,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 303701,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8049,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11893,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 76113,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 464717,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 43210,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 129281,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 203074,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66995,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 193070,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42415,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 50666,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 42423,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8768,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 943569,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 44700,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22747,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90316,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86319,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 266511,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307175,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56774,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133828,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4143,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 56561,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55149,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 70765,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37448,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5532,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34633,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 29033,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61429,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117312,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76848,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58697,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59816,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22297,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 999567,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55790,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 39203,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 31008,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64946,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 168966,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 169569,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 196663,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10939,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 212550,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 380398,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9879,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 45231,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257618,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68392,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74350,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111525,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 173147,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104967,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 358698,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 104054,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40905,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 156397,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70294,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 156220,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 131757,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5710,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83214,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278840,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 279380,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 507295,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5236,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50490,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118338,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311832,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96038,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5707,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68197,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83913,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83580,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 39839,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55200,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 86483,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6041,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 106270,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 96006,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36682,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91074,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 55258,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54920,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 638509,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118467,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 90800,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 781050,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89764,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 41698,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59343,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10874,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19363,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75818,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 713779,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59348,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 662379,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 141698,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 148226,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5243,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 936066,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 677974,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41968,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 170248,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 305324,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26337,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55020,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69766,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 389401,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66035,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60265,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58072,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133744,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112710,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80729,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19806,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117530,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7260,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13871,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 95234,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96196,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6375,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 136070,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64917,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36100,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56715,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8122,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91277,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 314094,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76575,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 2260525,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 93648,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 132295,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77394,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6557,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12371,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67733,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37051,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 887534,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138970,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56155,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84463,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118503,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55480,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57166,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56955,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42220,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17467,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 712785,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 343925,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96619,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69725,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34015,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 75670,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36360,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19574,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15093,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64839,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 730937,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111717,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1088237,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 322323,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34617,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57637,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50177,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 380995,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80483,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288851,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87946,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64692,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 113772,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1096058,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72649,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114266,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 203102,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39824,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24397,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7012,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61325,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 74269,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113477,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38396,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8163,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41941,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 80488,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 474822,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6159,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57663,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111584,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131329,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43751,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 714852,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13405,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 50474,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 75788,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55232,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 142302,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128529,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5940,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42657,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58793,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60541,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 316267,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128689,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1243223,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12518,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73165,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8219,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 101677,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5648,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13261,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63331,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 42936,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87697,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161817,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6126,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77457,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79779,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15984,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 96531,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105146,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69528,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41828,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 123903,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100604,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3613,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86449,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82270,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10717,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1070210,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60515,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 196893,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 209820,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17621,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 93254,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8938,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9679,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66409,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85232,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14761,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44954,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 83203,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79507,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17822,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 266105,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7427,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20406,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125704,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91883,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 217259,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 368190,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 196620,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6220,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12166,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 39221,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75946,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62238,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8677,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5647,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69202,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 78935,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70364,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 424305,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82071,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9375,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55913,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19387,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 337544,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 382314,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7205,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40443,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57173,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67185,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 116336,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 499101,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62005,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 110965,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77038,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 19798,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6096,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 264967,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 166539,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56017,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 667069,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36073,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88436,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70294,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9281,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 134763,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62754,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14085,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140562,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 177103,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4892,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 738721,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61040,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 915725,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61697,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88834,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87600,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6719,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23207,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 382546,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120888,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76875,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62089,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60649,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 124940,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57941,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9788,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72179,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55009,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23753,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 110341,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24229,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6236,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70743,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14738,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5032,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15273,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72732,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 16775,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 35616,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 152275,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 71374,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 548376,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 287138,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8283,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 20563,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 144253,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 294830,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3053,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11934,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 28864,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11917,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7802,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24337,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14490,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54940,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63665,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68726,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16800,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9183,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62496,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42497,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19870,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 267565,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15401,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 494684,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69567,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 96188,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 190156,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1121828,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296082,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69434,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6805,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 117881,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 108086,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128069,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 115397,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 882445,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116277,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73826,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64883,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 105236,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54661,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 239728,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8292,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15355,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5612,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75674,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86549,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 136625,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143049,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56892,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 714076,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19372,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10915,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14213,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 778542,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63767,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83772,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 67073,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20398,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79004,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56209,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56315,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58965,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21331,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 84907,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 358973,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10558,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55169,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78344,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 362145,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4646,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7366,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64749,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58457,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321960,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1099914,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88588,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 208279,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127923,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38958,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88384,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77006,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 85608,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57614,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121416,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16857,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 25113,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 213271,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58133,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284145,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106870,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61901,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74011,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 16667,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35660,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126548,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8148,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94073,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112527,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6413,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52542,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56194,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80564,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4623,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165404,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 278942,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93676,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1154146,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63326,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63225,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119062,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6017,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34941,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 345978,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 316570,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12800,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68157,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55474,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42652,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 158652,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131528,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 224870,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63628,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 25737,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 308380,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 224806,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18509,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 155789,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102089,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86037,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 139191,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19412,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 98325,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57761,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98853,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 139134,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57864,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20284,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 228140,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 702949,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 116664,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 39669,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 59795,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 592540,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 141959,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6014,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 462416,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95880,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55013,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286595,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8723,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40969,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 347358,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101054,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73720,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74332,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 33260,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108233,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281521,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6938,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 60443,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55327,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40957,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14966,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60798,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4613,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21028,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6159,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8310,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59625,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108215,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 816630,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78962,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268308,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 89376,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1091122,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8834,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 84853,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65243,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 121998,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 177481,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41762,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 230506,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127181,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 206732,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7364,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 214201,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10409,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5794,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17143,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 32364,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 56883,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4584,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296561,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 184748,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7648,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22832,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 609660,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16378,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61814,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 64431,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 19088,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 318519,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67913,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58617,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20103,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6724,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58153,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 25493,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 43344,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 697298,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66280,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67379,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59033,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84179,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 87443,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57785,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61535,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77105,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44038,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64018,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56253,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6164,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261261,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84104,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65869,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 355132,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 77582,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57186,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18138,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8104,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116035,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14488,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22329,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80037,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65687,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 115117,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7277,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71039,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1307584,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 35415,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 242184,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55738,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291008,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42055,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42273,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30288,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59674,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16417,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293784,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4869,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93203,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 209897,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17818,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 26719,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58541,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 894628,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25330,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 18517,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 23196,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 659862,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81451,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13416,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8841,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81296,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 314720,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 36989,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312076,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42027,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66690,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69425,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115280,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7288,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 40653,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77654,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8002,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 48193,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14720,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111035,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82271,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 327432,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5342,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 13789,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75089,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21994,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 64994,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88350,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126490,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91115,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97457,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 50283,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 205292,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139291,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 373707,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105820,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64786,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 505894,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90794,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59856,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25537,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41915,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 103472,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31469,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74771,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7295,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73869,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13284,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 33147,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 341949,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290312,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59628,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 333447,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60811,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 27670,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 334544,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 338743,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 43824,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82112,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24717,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73252,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23381,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118361,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63318,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 29624,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16840,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54772,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 39575,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 233045,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63290,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67189,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279641,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 916171,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10817,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 71264,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311413,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93255,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11368,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4704,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11150,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68846,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63412,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77771,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30622,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73168,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65200,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 164513,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30421,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 387658,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9160,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79812,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9932,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54657,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128244,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 39487,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4865,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7080,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 201447,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76737,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55257,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74899,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 347274,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1091303,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23856,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290551,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76127,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68453,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36753,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 84495,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59632,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52395,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67398,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140332,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5341,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 323515,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 41448,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91509,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 128650,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99558,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256497,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58521,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30793,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18526,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89850,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60798,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 515135,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18301,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 233084,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66357,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55987,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 742220,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41753,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288374,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 227173,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87014,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12768,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117792,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58342,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78819,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8461,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59324,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10186,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102770,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84266,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 531770,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 57668,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44156,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15821,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39577,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5904,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 109669,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 381077,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23933,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61735,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5739,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58375,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 77028,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43342,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 131614,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 104008,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59362,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6039,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 145817,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68683,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 83278,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55102,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88936,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30345,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66408,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79483,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6954,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55183,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 581670,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8534,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89414,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63715,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74380,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 586951,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57554,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 382556,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 50108,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1580105,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101289,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16540,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80105,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94479,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58520,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 692883,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 77617,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22471,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20970,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 617772,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 116259,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 355613,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 107547,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 40335,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 191413,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59465,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69334,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55874,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10386,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39919,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 570280,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70238,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8717,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72116,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 142693,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66755,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79155,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 715605,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96276,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111286,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9142,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41780,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293777,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 121478,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64966,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 190969,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56568,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101142,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37771,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34767,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 174123,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1191181,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 77498,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285715,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 130093,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 200239,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 784039,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 56396,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11352,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 239684,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 372591,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 111915,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57550,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 433349,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 228210,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10771,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 23610,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7688,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68908,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5320,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 200864,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108494,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5710,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62669,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 587731,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 61650,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64305,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 18731,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58540,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297529,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 938096,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 326915,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1061871,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 416440,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6781,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123699,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1140473,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27716,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60501,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20919,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 564267,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6924,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 778783,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 29043,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306752,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10806,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1040220,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 41117,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 43433,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43187,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54864,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61159,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120840,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 50908,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94473,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58482,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79247,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7791,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 71422,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 138147,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37718,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41257,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11098,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81917,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 776978,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9866,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68293,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8013,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38639,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69750,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81563,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84723,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54943,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5124,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 38792,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8284,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5144,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69569,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 75639,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24550,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 119333,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58402,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121341,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 684883,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1075979,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59136,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69065,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64836,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50245,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 295309,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57775,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20805,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273050,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 35790,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77073,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79304,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8346,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42613,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7131,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79499,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55354,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4765,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101360,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8735,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 109597,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 95003,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67279,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42029,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77293,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70717,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 200159,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 156732,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43055,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320050,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91113,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 29319,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58339,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 76586,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92408,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27372,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39375,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5140,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73834,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77777,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 125493,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274713,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97312,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13218,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54945,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142702,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 34611,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 105861,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68708,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60069,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1169511,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 72873,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28810,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27469,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285273,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75001,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 397561,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4874,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 79246,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11043,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14622,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131354,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136044,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9377,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42402,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63426,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126901,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 240108,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89991,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41027,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306267,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6894,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70833,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267790,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 210555,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 62738,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37415,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68938,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57585,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42765,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5496,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5505,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 773148,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83500,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7640,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 319051,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43659,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89681,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 75011,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19182,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 28700,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82607,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55161,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34484,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67723,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 246043,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62345,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 74435,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56097,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43456,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 46616,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 123335,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301708,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50243,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64223,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66802,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22902,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307979,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34629,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38324,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59074,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 117625,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57148,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 104384,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5103,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106741,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 295488,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 58742,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5002,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 226687,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5969,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26458,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39380,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8758,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11865,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 116699,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 793343,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109171,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105038,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 197590,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17053,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 346746,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9478,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58561,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17105,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87500,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60214,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276432,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92737,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123774,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18518,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42543,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 68090,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43535,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59593,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70493,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91927,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5919,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 138621,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 396767,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8827,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 490062,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37065,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63958,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42312,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 259912,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 386298,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 244084,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 36885,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 336862,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 360764,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9133,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 37987,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 53500,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15992,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6387,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31829,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96529,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92706,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 901024,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41638,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 124524,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 71713,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15472,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9406,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 143791,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 29998,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 55416,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18038,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285704,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4623,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104472,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57837,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 43209,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83575,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94466,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 590757,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56330,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313627,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60273,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65160,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65124,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 56650,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 62771,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7349,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8900,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56632,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88734,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 111301,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107889,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 177324,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5612,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42574,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 71481,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5421,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 875664,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8598,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49167,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78004,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7455,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8967,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 462140,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42850,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55620,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92353,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6315,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93994,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 401659,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37557,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86715,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56291,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80827,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124387,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7132,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29994,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134589,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 713517,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116914,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5915,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21260,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124287,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94385,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120416,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17120,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34721,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12478,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10484,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85499,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67837,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113070,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1296177,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62007,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 341862,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 28338,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 620093,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11960,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42198,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9138,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9695,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 101866,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6689,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1002095,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10446,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105676,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55399,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 147321,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27927,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56364,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9340,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 28965,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7368,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 56566,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 96339,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66109,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4829,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54828,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318623,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 831960,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68349,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58828,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 945832,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 64199,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4832,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66581,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 72726,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 195174,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63518,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 61571,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113452,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 326309,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 87636,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 239580,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 229544,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34656,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 175144,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19131,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8947,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4833,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 100703,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93715,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 339267,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30162,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 171377,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33017,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5195,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55921,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60476,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74970,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1311305,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11002,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68308,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45563,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 24089,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4920,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137353,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59259,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 697639,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113649,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69968,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75987,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 109391,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5530,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73031,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107822,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68536,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8201,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67880,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41908,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268529,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52671,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5867,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81429,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63518,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 651198,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119776,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2980,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69836,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71431,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 49739,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98251,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 649301,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12950,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11685,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20297,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60944,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17821,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 90035,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70782,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41163,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55385,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134378,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65347,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21920,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57787,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82255,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6719,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6520,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70037,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 103930,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 165655,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 101059,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136351,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16767,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 816473,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4685,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100443,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83556,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 31103,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 24108,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 447224,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85152,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 400184,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83573,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56382,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99680,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37044,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63766,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 81171,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64010,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5593,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1047414,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43860,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91411,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24852,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 296374,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66586,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 38623,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14781,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104620,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 144305,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10559,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123406,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5677,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 39438,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 80975,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 200970,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7212,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6757,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22813,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 22021,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60573,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 63314,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14586,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1048952,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 505839,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19846,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139002,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19404,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5541,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84997,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 26067,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 523334,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 887432,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68021,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81598,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57238,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 62146,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68782,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 113125,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35206,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 379297,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123077,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 177005,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 609828,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77216,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87288,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28309,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 266126,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75741,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 689219,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9726,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60689,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96566,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 100390,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 90355,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4897,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37471,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93260,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 156634,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5934,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68142,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 156522,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 631917,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 97491,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 130416,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 670648,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17294,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90363,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63301,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74048,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43435,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79519,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 85623,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1408797,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 80134,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62205,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93882,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 87549,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 305343,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 115698,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 504340,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 120119,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2930,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277405,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4529,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62514,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74460,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 122958,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11001,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18372,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 139055,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56761,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 179454,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61554,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309784,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 167234,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128307,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311942,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 781466,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 109442,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 93241,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 46474,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63414,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 175005,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 206243,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302995,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40044,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76993,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4707,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 129695,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68662,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300445,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55917,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79719,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 329806,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38493,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 76553,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5629,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67699,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 155401,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7632,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 43123,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4549,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140887,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66042,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65583,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36713,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25651,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4959,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64375,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 26368,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74150,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 84987,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 21806,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31231,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86944,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 111232,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78908,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9184,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35572,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58457,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15217,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 190639,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20204,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 111705,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5041,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22236,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 421289,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27221,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60162,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 394058,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108757,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7667,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 99170,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 210390,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256115,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5656,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67606,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67927,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139753,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11039,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 503865,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85716,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 100310,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7087,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 60357,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65886,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 256309,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11870,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 72549,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 213882,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1196823,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 172560,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71788,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 114901,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6611,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59571,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77482,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105616,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83315,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 159368,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59375,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5206,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 180440,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84062,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50375,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76141,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85222,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14090,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62443,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 39313,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 156062,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69567,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 833247,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 144909,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72702,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6228,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 689062,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 641819,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96433,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68592,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114136,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 204142,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 749280,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70746,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7691,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60236,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59039,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 36781,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113188,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10116,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35789,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88290,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4673,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 40884,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8890,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 303995,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 84852,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263705,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59713,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 22978,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120240,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61651,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63974,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84560,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6766,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91380,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272630,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 223784,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 162555,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96043,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23695,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41559,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26413,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268333,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 39184,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8037,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 700878,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 341315,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78447,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 225794,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 337563,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10250,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12668,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108169,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 507897,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 770479,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17181,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 200154,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18388,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4712,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86257,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9209,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73702,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27018,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7457,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55140,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101571,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58131,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81750,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79463,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 225213,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6705,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37783,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111197,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16455,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4677,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 501603,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81333,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56435,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114248,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 323834,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 72859,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1137259,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28997,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5120,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91326,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 63973,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 42893,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 576475,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14427,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 127610,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 523757,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127202,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300251,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 679285,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62321,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42421,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4721,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92713,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 65295,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102457,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8059,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 670667,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81980,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77417,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 109952,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93853,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39613,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43893,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29206,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 583935,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67535,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39526,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93495,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43621,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 325498,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129492,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24244,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 141021,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115373,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40488,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 749137,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 527593,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56748,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42905,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7169,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139967,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77864,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 89761,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38900,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 398977,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60908,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75278,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4597,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 73480,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 131403,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63536,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93106,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6526,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 22485,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70105,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66326,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1073543,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69876,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306101,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 728680,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84321,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 176105,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84221,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 58068,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 148027,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58748,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 583104,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 682770,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109314,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27043,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85089,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58895,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 16740,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 94681,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 408892,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 74149,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1156239,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 81435,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33775,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 221041,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73483,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263855,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 214535,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31389,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60377,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 116921,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 170720,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 134591,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79308,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 631096,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 389796,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42243,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 238245,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6129,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115456,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121852,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43990,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9960,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 62433,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63454,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43015,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 432961,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8430,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 663502,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78525,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58506,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63550,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49923,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55180,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8191,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 135716,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23280,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83289,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42775,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111498,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1118225,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88397,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54941,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90910,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 80670,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55065,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19158,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26665,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 102573,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79060,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 119127,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39936,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70146,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311137,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4840,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 55017,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 56463,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36511,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9447,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79368,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62993,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35163,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8605,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7270,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 95056,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274825,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273174,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 137072,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17130,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 636792,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 190915,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309125,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40250,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36830,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90755,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14788,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 136121,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85592,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 205269,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 144016,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70863,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54620,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89662,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 32618,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23494,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12277,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18419,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 224770,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 108051,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64084,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 376130,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64600,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78949,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 29166,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39464,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 846050,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92617,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 117239,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 360249,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14768,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70917,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49295,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 30580,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 341512,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69377,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 336317,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18630,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 99428,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328878,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64129,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9262,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275960,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81126,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98215,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56346,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56644,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106084,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 179116,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 500024,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 25712,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105234,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114787,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296591,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88908,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 68348,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97433,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72658,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8099,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71170,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8153,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8994,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96364,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57185,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 74537,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23319,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5687,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 144597,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58599,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7989,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63232,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55915,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 167027,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5768,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76450,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11601,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 59404,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135987,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 250669,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 185856,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76688,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66405,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1216696,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83806,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84074,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128920,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57107,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257285,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 312856,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 529218,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84091,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90552,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1499247,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 932230,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 564215,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6090,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80077,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121853,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8598,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72670,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 27813,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18705,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 23062,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 77168,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94637,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2884,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41471,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 44481,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59352,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 94404,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54948,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77734,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 122524,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56275,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10402,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 221592,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83197,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73067,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71964,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6331,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288287,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21983,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10757,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9332,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60799,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41781,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40720,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74226,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112792,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127412,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55222,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55333,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 899856,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120683,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286678,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79516,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12883,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 355796,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 719771,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92559,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58142,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 252223,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 681923,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6143,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26800,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67617,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 113510,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 540131,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100832,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68738,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5337,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 157195,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55881,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161002,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87531,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8198,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 229328,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 41500,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 96741,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55772,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 203219,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71329,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71899,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7814,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5089,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 669807,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 232589,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 154861,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5236,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102373,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 411456,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86762,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15792,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 105219,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 22806,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11742,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58070,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24948,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 225962,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8764,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 141456,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38718,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75295,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44233,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20773,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 869710,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 156101,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56649,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16982,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83152,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58732,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21006,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142946,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 280673,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4712,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69523,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54684,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42069,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 123213,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 198666,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24144,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6305,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8047,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37326,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 380346,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83534,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79757,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38668,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68218,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4788,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 238072,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71095,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 242976,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 235435,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13813,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43731,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312783,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6481,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122477,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8997,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55362,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 53132,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66992,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8342,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7559,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27236,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56763,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 29680,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78145,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66444,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9012,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 44036,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7197,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11001,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88048,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79557,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115068,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 29794,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119691,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102351,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 148876,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57887,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 208902,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272199,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 17460,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21277,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56942,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38637,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11536,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 128714,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 113779,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1115182,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36078,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9520,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 909150,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 4373,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6694,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 46633,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 56072,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71062,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 103348,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109516,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 212561,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15832,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99186,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62356,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 44477,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44422,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6508,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39026,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 684443,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285967,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7173,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 112794,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63301,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 205626,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 583857,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95683,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58716,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 730335,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1043829,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63523,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 825784,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42749,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 200379,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1019743,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 60129,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 501465,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88049,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9978,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10278,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 329077,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 385871,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 125233,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 329338,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58648,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68393,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96024,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54721,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27147,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 51720,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289338,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126980,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4713,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 49107,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 66201,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73223,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56568,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133987,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9820,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 787294,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30487,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116612,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92305,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 96118,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36816,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 220694,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 316786,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 140046,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62951,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 322579,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69011,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 711968,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 300290,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7093,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313323,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3967,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58143,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6190,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 247594,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 60689,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24333,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18156,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 106958,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93878,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87061,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 86802,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77601,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5899,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17293,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81843,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 300882,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27569,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61866,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19996,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7948,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 131961,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85181,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 121432,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 57683,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41523,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 42831,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 71667,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64545,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57179,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4712,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82548,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59572,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71877,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 231400,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255469,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38519,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5346,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55399,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16082,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274997,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 116136,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43177,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 2993,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63309,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1568714,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69199,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 63425,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103672,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297611,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14026,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118921,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125991,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112613,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 52794,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 243912,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55762,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5075,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11678,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 25805,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 735808,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23337,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56819,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129942,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10120,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 195375,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61733,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5697,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82950,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20333,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7271,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29634,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 429752,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11175,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276413,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23206,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4760,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7193,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9449,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 336410,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9363,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 188792,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 177077,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99295,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87132,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66763,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5102,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 56245,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9829,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71479,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 205627,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108039,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63165,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86899,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 213312,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 106993,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83670,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 252235,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54619,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 218637,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 106323,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 135543,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 254578,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80736,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19319,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 116143,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 63084,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5123,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 323013,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270875,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 34735,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55063,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313338,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59182,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68732,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79339,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 118910,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 105104,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 53477,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 81159,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 139141,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313157,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324170,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106571,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 708106,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 774893,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1014208,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97403,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 166614,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96215,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26610,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67178,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62346,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60409,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59951,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 220881,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88235,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103135,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 115692,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24011,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 343708,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82750,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 176147,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 371945,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7017,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 26358,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 522046,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75147,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61761,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10286,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83953,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120854,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58819,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 314387,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 422927,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 202293,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15978,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70263,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62422,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80714,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66385,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4825,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73209,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 231605,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 333709,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 182755,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 250600,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 42834,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 62062,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 34553,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43992,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20338,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 50749,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38918,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70853,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57583,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143185,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17221,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 141133,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70126,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 187258,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61336,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15121,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 927705,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58332,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6187,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3498,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73706,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120609,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55358,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 154969,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105740,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79021,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40019,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58672,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123316,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8467,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321421,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 375186,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4961,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12948,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89800,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58944,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84254,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2677,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309952,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1200896,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112980,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 160271,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 140951,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 208923,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1116174,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 83218,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 138866,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76958,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60992,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122886,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 241747,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42963,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64974,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142394,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60917,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 326392,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58915,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67405,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8301,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19490,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76966,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 81617,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65529,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81723,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31472,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115271,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81149,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8208,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90867,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 250638,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 113514,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66015,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83497,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4680,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63387,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105437,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13583,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78387,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54952,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 89867,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15968,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163137,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57869,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 28369,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85240,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17252,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84990,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 760592,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 104681,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56068,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 27139,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91264,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42716,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60035,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43348,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 23254,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 354627,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61373,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65968,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6005,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15516,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 211328,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63799,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12232,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23402,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 58752,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 60406,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312325,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88930,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 33895,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54555,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43868,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82149,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 56591,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 590574,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310087,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134580,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54912,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 85691,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14873,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80368,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281401,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 746351,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8232,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14801,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 29867,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7442,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44262,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 188032,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18582,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41184,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60464,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78685,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13664,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 603613,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 238263,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 640261,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65200,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 188188,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 75978,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140737,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 91200,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 24306,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9029,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64109,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 38671,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 173691,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55693,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9625,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 29081,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 173309,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18043,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12313,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17974,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 106318,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 801198,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 47835,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 389613,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81042,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 838109,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 409185,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54664,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 678862,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66780,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 487594,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69727,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 30346,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 100680,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 793652,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 430787,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55031,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 837855,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8623,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40796,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 15496,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 322811,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100153,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 127336,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 78403,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 674922,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142351,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3649,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5478,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 902057,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 144293,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110111,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60012,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58103,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65887,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290315,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92186,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 24915,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 136101,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81232,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67757,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 322747,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65762,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66104,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 79909,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45669,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 99634,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66617,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42534,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56939,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 819032,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61520,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5553,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 250273,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 551164,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86136,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5353,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 77917,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263892,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115476,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270464,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6041,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60401,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 26962,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 42750,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 46344,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22992,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76275,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 228555,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70832,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 109730,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89499,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324895,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59410,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 720890,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285981,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 485943,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81194,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 295918,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 53645,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 93565,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36304,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 97269,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 452015,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17780,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89554,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4720,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94025,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 680889,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 188494,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1266857,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77722,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6211,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74009,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61204,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59417,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35399,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 109326,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6816,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1330767,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9647,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61010,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80047,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 504809,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68331,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87477,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293008,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 141639,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 459181,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62922,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40042,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37845,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41972,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 318320,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39746,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89623,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 181176,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 367357,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 55253,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80417,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9538,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100719,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 706633,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128012,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14894,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104884,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95625,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8568,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286742,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66783,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70926,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 800076,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 166509,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270018,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7166,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313345,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63229,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74928,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 330771,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 71549,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87268,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 32106,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90539,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311629,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6087,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3260,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 343945,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 478802,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 346603,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63582,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4801,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5092,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 19931,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38847,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84234,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73741,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 76190,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91733,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35634,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12187,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4710,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5094,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14014,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8337,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 123546,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7908,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 143223,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 78945,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70577,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 220284,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116591,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34617,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15115,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 245464,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83765,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288687,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81026,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 101954,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82364,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7229,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 170693,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 157894,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9876,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270257,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76471,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60453,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 181067,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 344561,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1071719,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 361474,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82992,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263559,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54843,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 124663,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 13765,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 24701,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 83195,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 36567,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67783,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64884,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 121451,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8439,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76833,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 732347,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14476,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 200958,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59763,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12563,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130824,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98047,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 51561,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122068,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 373452,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98025,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55980,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40056,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 71682,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 36505,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 377156,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59924,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 104036,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54661,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7105,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55437,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6471,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80217,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 122745,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301204,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61060,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292136,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77275,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 187675,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17849,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41890,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63099,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86907,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 132320,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 18681,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118918,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 23756,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16293,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15509,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 141948,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 109235,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5466,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 846501,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 296671,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7915,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5651,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85994,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21167,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 120888,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14397,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 101514,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 30230,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76459,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 167325,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21234,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55129,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7434,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 316177,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71766,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 242817,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18631,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1100330,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74330,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62366,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75785,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 99510,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78166,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57492,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38725,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 63326,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15059,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 81577,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1425372,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 522579,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 175348,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62157,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14115,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71078,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 208606,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107431,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76090,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258607,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 169293,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33296,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 377541,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 117416,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 14781,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41379,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39906,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 264022,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89289,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36541,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 323485,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 47546,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61273,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 105992,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40193,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263137,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106980,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7532,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7701,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 591117,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73326,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 711499,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54528,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8412,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12668,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 164085,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 315584,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263015,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 22734,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302956,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 43779,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58835,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 567298,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73534,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40641,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 56698,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 167475,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91601,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4003,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74392,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 177122,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77330,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6575,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5400,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 338517,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7620,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68044,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 299916,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6956,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 131262,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6600,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 28413,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38572,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312730,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12293,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 336219,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1431217,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85720,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96495,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60419,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82918,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320430,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 332352,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66263,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14101,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165425,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67340,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9504,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271319,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73383,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 140879,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56397,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7843,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63520,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81197,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24092,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136365,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257164,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37324,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 55187,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65488,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59028,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64654,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136340,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 383273,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8633,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85303,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 552558,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 171062,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17111,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 160592,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8028,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72763,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 194171,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22427,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 816982,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6582,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96675,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67970,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291797,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6101,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10942,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82166,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8312,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 106420,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 135019,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68128,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 621469,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40419,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309964,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86654,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273554,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279591,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 602569,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66332,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118538,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70369,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5816,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 119847,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77378,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15291,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42007,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62055,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42672,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63459,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 61221,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 44345,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 722867,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65978,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72087,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 108653,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70080,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 214198,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 330543,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 59454,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 34427,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57812,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 491090,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 85612,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 88398,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64386,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63200,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81608,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 613283,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 125017,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 305415,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68086,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 76324,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 106412,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14960,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7837,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 25586,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106164,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5968,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12897,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56874,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 125866,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 41778,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62053,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41557,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286767,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77123,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6944,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114220,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9119,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 45801,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21762,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25615,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37180,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 184889,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 144119,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73744,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89089,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 72552,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 96552,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65238,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82966,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267352,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38355,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82238,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 20908,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 47587,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12410,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 76791,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80635,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89981,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82117,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56162,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16682,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 96480,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 76624,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 524646,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 40145,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 322511,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6220,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286956,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 175434,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15906,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80331,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 31884,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60197,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35001,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 61476,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 57517,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 716744,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328599,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90264,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36275,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282286,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 162912,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56378,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 141963,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 60677,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 26941,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23393,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101867,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128118,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9078,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276680,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 189317,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16436,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36342,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 32575,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8377,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57225,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 55547,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 802085,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58141,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276741,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1259898,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18263,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79222,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37130,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 719427,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 340518,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 25904,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290880,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58929,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7379,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61282,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 100635,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36488,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 43093,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260055,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66227,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85417,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 25976,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 198842,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81852,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 29883,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80841,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56063,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10986,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 340717,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61620,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 27237,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 86920,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58545,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312349,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 30152,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100497,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58017,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99190,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70199,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 32406,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57232,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84021,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76501,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63930,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35553,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318327,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17299,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300543,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23187,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22828,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134840,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78677,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8076,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72555,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 160467,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101789,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 904498,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 224997,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 175071,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11965,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43856,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7746,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98835,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 838843,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 32433,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2900,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 202584,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 269209,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7322,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118705,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 105102,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 32536,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65621,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10868,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 254697,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 113194,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 61785,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6406,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8627,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75833,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33963,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126283,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 180913,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61097,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14503,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 56603,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8008,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 71975,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 356142,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 61507,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 340876,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 25836,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6818,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 663289,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9088,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 105014,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274323,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 837887,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 37039,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79961,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10186,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 413502,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55549,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4854,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19216,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66171,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9238,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42820,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 138677,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6476,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 260074,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43902,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85168,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78670,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 656158,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59873,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39306,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 102463,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128949,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 149960,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 72705,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99301,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 110973,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 783500,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57074,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5856,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 971459,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9456,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 358824,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 249898,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 59499,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1563797,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1122614,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 82295,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 340567,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55298,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61667,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 337181,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94971,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88757,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 183812,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 958791,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40404,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133933,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 737193,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 147266,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55005,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 99103,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 37668,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70229,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 889264,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60126,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71698,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7471,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78059,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126626,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139028,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108544,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 203675,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13820,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12510,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1233681,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 325110,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6259,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 29216,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130108,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1027160,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8813,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12351,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 208515,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1545850,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39416,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82315,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 39924,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54729,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275204,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8500,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21486,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55105,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19447,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 28385,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 132058,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 730027,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3205,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 407418,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161981,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128166,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 378411,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 28901,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60542,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50268,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89939,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 140351,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55014,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9390,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112358,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23109,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95840,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4661,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6362,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 72009,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 845768,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56944,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94364,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74388,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14643,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 583017,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 593980,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293946,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 20224,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57510,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20218,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82459,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74247,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 631768,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 303529,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 50918,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83489,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110942,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54877,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 33042,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143456,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6363,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 417346,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7809,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15397,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 696217,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91665,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35478,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8440,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18898,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5519,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260581,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 233099,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165984,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5694,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 127116,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118179,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91108,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 101617,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 97026,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37874,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70750,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43500,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 182979,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14158,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5950,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82274,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81200,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 107500,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73357,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1328138,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66779,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9172,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67496,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17658,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 379890,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101126,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63413,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 714281,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68268,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 747325,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277208,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8852,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1422525,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 133174,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56105,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121440,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 294842,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1259782,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 82232,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57988,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97371,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 561170,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64500,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101020,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 697007,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57340,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259420,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85293,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111614,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 306572,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 38168,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 90399,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 97239,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5129,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 107388,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71377,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99728,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281046,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57586,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7393,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70420,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 229394,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26788,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104030,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58703,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 174679,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320013,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 151879,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 709844,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36774,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 327506,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4657,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 25375,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289872,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 821126,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 64389,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 103877,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 425907,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57433,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16014,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69164,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58653,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1607759,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38280,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24190,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82357,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 39341,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27034,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6094,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 896021,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1020827,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 340764,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35493,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 317517,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56418,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98619,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 221112,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 834131,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19525,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58231,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274081,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59073,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5284,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 239476,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87808,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78384,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91110,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 334399,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77213,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 129312,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140436,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44473,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 42287,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99459,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 643259,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62772,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86248,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68244,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6136,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10947,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77321,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 89617,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3101,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42506,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60386,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99416,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80643,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107132,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105106,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21443,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79321,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102205,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59733,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85321,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 37951,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 116681,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 942947,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281679,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 923407,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55519,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 182738,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59893,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83597,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73193,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 141545,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41700,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19105,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134904,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12818,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 240835,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290814,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 91891,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320430,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60023,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54860,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15644,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 124109,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 325756,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 16500,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 109678,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11795,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11539,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30941,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23392,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40235,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1278828,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87252,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64840,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 569375,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276569,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66418,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17261,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 82608,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9276,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84139,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83964,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67457,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311316,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 141954,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7512,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 76027,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 346478,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55744,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 50487,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8245,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55132,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255885,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56791,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87983,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 142251,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 55934,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 114063,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18925,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10996,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 343333,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 37692,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72573,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69337,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289984,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82597,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 363457,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 51664,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 157852,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89049,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 599094,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 488460,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58750,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 536941,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64140,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 378270,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 39845,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37721,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5747,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1216727,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 814048,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1002101,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19313,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136216,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19999,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78244,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 604883,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 130444,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77058,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9942,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 901517,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11749,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 158932,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 321907,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90197,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71604,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6501,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26124,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10937,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96033,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 64629,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37121,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12367,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7222,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71198,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65433,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70726,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4965,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6110,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 278241,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 197645,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9668,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79469,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12550,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18550,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 170178,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 352811,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 727100,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 47157,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 484565,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76735,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61979,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115481,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75972,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 854481,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94042,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126790,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125883,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 666210,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10150,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 35905,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55277,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90343,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 221107,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68490,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94293,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15621,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136573,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30514,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13509,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324326,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89746,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56271,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43040,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106498,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 163165,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87382,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11097,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 701198,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 563327,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30064,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87523,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 198977,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6275,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42963,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58569,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 116041,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20926,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106037,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280754,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 75204,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57790,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126116,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 179277,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11067,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97060,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71383,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92494,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 394755,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 537819,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13273,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75763,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 133386,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 61728,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37860,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56277,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15738,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38051,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80069,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103967,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8696,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56188,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 49005,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25177,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 65269,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49992,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90448,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280878,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58241,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4131,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5170,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90138,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70417,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91130,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70647,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4998,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80905,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 25024,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5246,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56383,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 175775,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85826,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73633,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 114887,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 176958,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 176441,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130086,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60014,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297340,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 106147,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 13985,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 33050,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17967,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110942,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57248,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58398,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10501,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 200876,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57943,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 778084,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58472,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 309409,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78567,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98156,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91688,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81623,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13401,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 174839,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 327827,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 130632,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88308,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58227,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1685005,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64561,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63744,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14017,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70953,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 24567,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38144,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 746858,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73120,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56551,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3072,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16566,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 228911,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 260390,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97806,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8210,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139857,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 312262,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19074,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 141889,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107443,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 75715,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 216459,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62476,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59886,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101935,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 29334,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 731347,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98797,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11277,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4883,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 162652,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296994,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 142531,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67730,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111336,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 387683,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90275,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 82541,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11206,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 28462,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87528,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 78633,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 248425,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 785992,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55708,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56294,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 550806,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 587302,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100438,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5530,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 79505,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258992,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 42017,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119766,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140304,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65381,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 160706,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5058,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 264265,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 362868,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4693,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128333,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83206,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79109,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 91468,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 56511,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54758,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68632,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310996,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7822,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 235946,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 760366,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56533,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139329,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23849,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10181,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6976,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 65369,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 25607,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119581,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 220242,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 896699,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288026,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 93196,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83990,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75584,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38889,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37773,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 155628,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 118493,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 919007,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 132023,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 140117,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5638,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22930,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88525,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56233,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 821986,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10230,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67533,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18497,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 64890,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5491,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 836519,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65184,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 490683,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9061,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276859,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 64456,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36668,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 178965,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50417,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 214848,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125356,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19923,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 179970,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 450892,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16748,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 21760,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92117,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 18090,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66960,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 87896,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121647,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 31666,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 49502,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37673,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6258,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111666,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 451076,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 341235,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42084,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66840,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 939388,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40234,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60200,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1215587,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259746,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 142912,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10162,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 274866,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25906,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31270,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 142794,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27147,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19832,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56176,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 162961,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12608,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 151366,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 400853,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 193208,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282044,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60532,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 577051,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 891095,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95118,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70467,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6013,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16618,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56500,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 63905,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 373590,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11687,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73391,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263022,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30616,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4804,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39240,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5916,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1000935,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 428736,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 815282,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63559,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67744,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83782,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297544,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269242,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 786499,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25558,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 915649,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 99491,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3325,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 210022,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16695,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 191088,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 73418,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19911,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97646,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 65041,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101088,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19040,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273183,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76567,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85194,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56438,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41397,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79768,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68984,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 71043,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7848,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 102113,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 18389,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 473972,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 924683,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35609,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62265,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 34126,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42870,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65277,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55782,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62433,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289638,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 884307,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90749,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291536,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 132196,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61336,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 336398,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65209,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56720,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1319584,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 141117,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6131,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 212043,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5370,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 202372,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6078,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58487,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 105082,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 215782,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4608,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 109232,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59372,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56127,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93218,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60869,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259666,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 61077,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38867,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55547,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56422,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 249162,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9523,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9620,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 128598,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121732,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29799,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 46421,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59768,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6991,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9447,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269707,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60001,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 265284,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 91077,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118363,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296278,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 634200,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 636615,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69295,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13491,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81608,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1610799,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 603034,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 199804,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 177791,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258891,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 132310,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 37949,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76556,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106943,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93822,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 85975,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17520,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5098,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94158,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16627,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77579,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112643,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328126,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55970,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259383,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11790,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59208,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 176238,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36983,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40609,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 76367,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11351,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56376,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 193314,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15070,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6381,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291223,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74004,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10083,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6755,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302167,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12147,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88192,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 989764,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 862459,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99205,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 46054,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 211078,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35623,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41998,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 86879,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 115389,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2686,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 93075,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14568,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62566,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6009,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 145432,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60807,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 682039,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86469,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64088,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 648186,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5029,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33309,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4828,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 250281,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309195,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 178421,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 295373,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40106,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8858,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71031,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55145,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80096,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 896710,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10042,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 565896,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14969,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9871,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 203630,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56593,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97477,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6467,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55167,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13435,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 299542,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86107,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59246,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70132,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 790192,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 108314,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 217339,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 58952,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22537,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 48293,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60704,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6862,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 112668,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57576,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 43831,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 64028,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62700,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286736,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 36571,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 101459,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5761,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 71941,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87858,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78060,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75648,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298024,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23771,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 900944,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70543,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65726,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87964,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20992,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1061178,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10443,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64693,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55212,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7082,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 31254,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 52766,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4076,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 187899,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133435,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70511,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9869,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59091,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25733,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83055,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58376,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 116028,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 140178,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291101,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97219,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88417,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 93664,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100300,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56532,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56019,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5049,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38791,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10010,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 607888,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87823,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272786,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 43792,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66731,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128161,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63774,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5032,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139429,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312514,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 208325,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42036,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37812,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68523,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60054,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2798,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5079,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69233,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258759,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71982,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82788,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43008,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5299,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40217,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5194,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92620,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104991,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70268,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17443,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 412357,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 154524,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68523,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1337272,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76508,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63592,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14763,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5977,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5363,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77447,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82382,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60360,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7602,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 102685,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 939822,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 117647,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 713804,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1407807,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 80898,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 40265,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55606,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23456,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56542,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 30257,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36110,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130751,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 23902,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104795,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66934,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68226,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10208,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64644,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259118,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65615,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273805,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 677035,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82107,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 164446,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69593,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8384,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 713162,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103783,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79748,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5355,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 313486,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5649,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9210,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 264641,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 28761,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6822,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 883132,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 36261,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 102334,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30566,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75498,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 344292,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 121800,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15635,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97378,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55177,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60070,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269603,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1252246,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98827,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 307194,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73572,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42308,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 154623,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16297,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 206729,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72049,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100555,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 60958,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 36604,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127277,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262266,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78731,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77232,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88401,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7537,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59730,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 728416,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 38935,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57672,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291127,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74630,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 89926,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40276,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 120381,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13197,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40339,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68754,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9489,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 648900,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60837,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67603,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73234,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270460,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 41081,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58558,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42751,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77279,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 227005,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1316396,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68525,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7071,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4741,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62687,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4785,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66044,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63221,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54811,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260091,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73100,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 40568,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 714191,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70241,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 330904,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 59494,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57986,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17308,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 80557,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321248,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130243,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65370,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4810,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65023,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82300,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134849,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9116,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33047,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 174117,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24070,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 446118,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 26324,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78970,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58543,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44103,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40892,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 78524,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 326291,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1432307,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59864,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42698,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2566,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4041,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 401083,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21329,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4560,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260942,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90365,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23143,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15506,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 533519,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24599,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9731,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72906,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 317051,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139234,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55129,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69240,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6470,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8910,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4770,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30720,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5142,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78308,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 751688,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10379,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 620623,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 514419,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55179,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61646,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110506,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107327,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5348,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5860,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10131,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 88994,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71665,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 180169,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22743,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95737,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 76294,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 967448,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58719,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 77884,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70855,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111208,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5076,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310458,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 180071,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72544,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 23979,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64801,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16659,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61198,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42627,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73042,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45200,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107811,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12776,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58408,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64601,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55313,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 308343,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 72794,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7719,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59280,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10669,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11563,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 22972,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59462,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 26167,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69689,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6364,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 31419,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 32008,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88325,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7231,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 189670,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25970,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79312,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9486,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 176265,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73965,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285800,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135458,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 616811,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 106847,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 315706,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41476,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59628,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 957117,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 28221,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5297,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256868,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107734,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 34461,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 149442,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 166785,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56214,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44237,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19817,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 27904,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 595494,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131771,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57117,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14129,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61522,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67300,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79039,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91435,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 81712,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58202,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45747,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61963,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 143483,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 117655,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 60014,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37284,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4712,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100342,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 146861,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59098,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65270,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 879465,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 331492,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86467,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68714,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55141,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3349,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58567,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 859523,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 85607,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56057,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111517,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103470,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67041,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79269,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61983,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54715,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 455149,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60170,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 917983,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4752,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 84568,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 53372,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 54109,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69586,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 58932,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117832,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91818,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 193971,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19643,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60072,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7978,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 84528,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 60221,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 83413,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8854,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12567,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123356,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77514,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 821352,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11611,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 72693,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 76961,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 207733,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 308671,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 235923,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41763,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57409,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 846931,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 367262,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7266,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 998694,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54904,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18740,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42968,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11800,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55853,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 157977,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321260,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7281,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137446,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 29948,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134067,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106304,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71383,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290516,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6563,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89705,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 126364,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74223,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 818228,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6955,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8486,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 695315,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 581563,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85153,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89407,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6918,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40582,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82593,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77503,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 159414,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6822,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57130,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89400,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70573,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 16507,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83206,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55524,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40743,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13671,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321475,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 85280,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61899,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19287,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79816,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15776,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55887,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 63405,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 466914,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80189,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72880,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54562,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 60348,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 114267,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138610,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 28236,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57012,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 736038,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20060,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123978,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 175215,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75463,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 714907,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70417,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 178774,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61499,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91478,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19478,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55944,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 33788,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92192,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120178,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77779,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18460,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1644473,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 548107,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8695,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 36775,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14268,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 122745,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 660602,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7244,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271936,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128909,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 118620,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 373310,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 415406,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 445210,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16872,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 24665,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77428,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61680,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1112591,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 120592,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321968,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 805817,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54666,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 81161,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 33553,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57012,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110352,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89472,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 229309,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 27984,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 379567,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 192652,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67756,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 863081,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 598940,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69591,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 40874,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 158921,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22255,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58655,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37259,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3224,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9172,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71628,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7675,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55621,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42457,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257225,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40336,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70494,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80320,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39486,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6572,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60739,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 795598,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 209438,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54989,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 305839,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 704713,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 35303,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3470,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95739,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 448063,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 116442,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 130311,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88020,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58424,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111673,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115527,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55072,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 24859,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15001,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58141,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 61672,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35848,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13730,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 149481,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60342,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61028,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40469,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84198,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1230724,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 805676,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84493,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22769,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57669,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 395838,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 340385,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 59197,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38771,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 129845,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44423,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62745,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11602,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31194,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82659,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 114105,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6040,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 891669,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17127,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102034,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298862,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55435,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165005,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80167,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100636,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17930,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56398,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59027,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8370,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43734,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1036370,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88496,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139101,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6123,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37040,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 52544,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20507,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40322,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9192,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70531,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 602846,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33883,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96964,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1162447,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26910,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17920,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 169129,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12559,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 791272,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37581,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 66739,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79031,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 145316,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19400,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58807,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17236,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11407,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54571,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86734,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41111,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 40610,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62907,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57241,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106761,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4979,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88787,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87153,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27790,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8925,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 143327,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 101895,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13698,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1382867,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65849,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92871,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56318,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17611,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78485,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90157,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9036,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14122,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84032,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7166,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5480,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 672967,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57271,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60954,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77385,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57573,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20776,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309327,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100885,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90758,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 196027,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59183,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86216,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 180473,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 110630,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 25025,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 156232,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 512336,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15759,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8429,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 265669,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307754,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 60050,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5619,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59134,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43436,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11254,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 421736,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 760121,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42508,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 332365,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 821427,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 113207,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35009,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20544,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63317,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4673,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10801,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 213837,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14729,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85352,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65274,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107314,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 188445,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59459,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 59505,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107755,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13770,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 959160,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54770,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20194,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77358,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64002,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 158894,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 138787,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94019,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37786,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83024,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2686,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 153710,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57257,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5560,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 266819,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286744,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 340877,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59035,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4588,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280875,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 841281,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27557,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 363302,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 183468,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 542353,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 234620,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 30087,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10614,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 32554,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59749,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 115750,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119880,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35049,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 37864,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55881,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19300,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139369,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66456,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 133492,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83020,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60989,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261178,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 369453,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108552,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280361,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19491,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90152,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15379,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256115,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129106,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10045,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20827,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58183,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62966,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6295,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 199473,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62280,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 175376,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55330,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84210,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7906,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62995,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79953,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12877,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81027,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 582559,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 54290,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15438,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42707,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121834,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129038,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17037,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10968,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8586,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58225,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57481,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60877,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59247,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77792,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79375,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 746229,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76568,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54585,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24539,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 94417,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 95186,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7098,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19813,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10114,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71203,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 122953,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 579940,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 42707,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 72183,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27505,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 213763,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114443,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 713961,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 761231,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36672,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 34893,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 211558,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68119,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9810,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43029,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165690,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54950,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 951850,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62417,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1280265,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8892,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 538488,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 135569,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 43626,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61616,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 242637,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82994,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 68643,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89444,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60352,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5944,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55740,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89171,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62391,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58364,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 86717,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 40189,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66026,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 215064,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8064,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62965,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 57931,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71840,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260997,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79207,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39557,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 596230,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 803855,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17538,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35586,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 86424,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11016,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18028,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54977,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4786,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 83130,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37941,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 60764,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 43876,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110805,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 91930,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 71844,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 177043,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 382188,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36948,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 322281,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58767,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 52838,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43098,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12781,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301660,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 358857,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30548,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67757,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 58734,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 116884,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94178,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 88952,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44486,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 323853,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58379,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94352,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 184014,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6244,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54805,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61547,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57665,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116145,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81818,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15524,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6109,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82078,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73758,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 741201,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1212449,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5072,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64279,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 112599,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302822,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42638,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 133143,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283074,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54644,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41584,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18817,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70857,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18043,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 432531,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1298297,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 555394,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62676,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55365,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25709,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55592,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 43515,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 19775,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 51345,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 19549,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9627,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 114064,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 91731,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275398,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 265596,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86267,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 588339,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19887,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43264,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74438,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 76557,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13708,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22846,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313281,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65066,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 51920,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 184083,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69020,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1401445,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38919,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54763,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 961346,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113996,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93261,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4885,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 362298,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 20182,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70653,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 746206,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42774,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 180021,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55821,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142805,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20148,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57671,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 162091,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 778355,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59369,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 140957,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27978,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88045,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70702,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56291,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 743068,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 118367,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115229,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26610,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 340861,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 36338,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22533,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17119,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57871,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7946,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 151006,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 409351,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23337,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19266,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 417476,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33829,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73508,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55872,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 872369,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1296462,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93297,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7188,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 415555,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67317,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75338,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67841,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58363,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66861,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44253,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19476,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134494,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 140681,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8323,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64399,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7045,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17392,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17238,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62852,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 94414,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 72669,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 41247,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 244060,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99197,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 374562,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5423,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1016641,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59927,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98398,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86717,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63526,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 127693,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69579,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93852,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125217,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20213,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 872057,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97870,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6429,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76487,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70924,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55288,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10772,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40033,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27141,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80710,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 238132,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56819,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104047,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 433295,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 107462,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10070,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72812,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6821,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66205,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313275,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5298,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 110285,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108614,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55516,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9301,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63268,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 171843,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5180,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63164,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129459,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55239,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6536,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79989,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21543,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55206,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 147761,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 143796,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 78742,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84187,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78889,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3182,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 182265,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126527,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 187255,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 35255,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79553,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7353,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 143881,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15681,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12100,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5621,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 124598,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43664,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37821,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62473,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 973810,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4788,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110633,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55650,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59113,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 28546,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 94778,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84353,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79090,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61376,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59057,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4841,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83036,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63564,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 42892,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66136,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 739786,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55244,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59590,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 338505,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4331,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42551,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60167,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 403114,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64182,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 198655,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 40492,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7548,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36030,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55363,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 331543,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9317,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4602,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 76665,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73149,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135284,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6476,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 287138,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 159338,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1565363,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58034,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 927973,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8309,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 343690,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99563,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63774,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58688,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301706,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 74071,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81606,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97113,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 137950,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111486,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 723913,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57123,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 113376,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5036,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24373,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8109,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126034,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 204727,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 254985,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58220,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 30798,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 435473,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 207614,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6574,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 60527,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 314564,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85381,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 148156,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7554,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 98665,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18809,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60948,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 123274,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 203386,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82571,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 836831,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 132032,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 303809,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 694630,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 776707,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5263,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124933,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 932255,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 81329,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38121,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 515695,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88545,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 25331,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58903,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 63688,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 759668,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 158080,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 24993,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69590,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110486,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12684,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6965,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 314535,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65332,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 112832,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68551,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 176915,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125232,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 658183,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59933,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7478,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96579,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31390,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57345,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 176601,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6359,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 42829,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17367,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68411,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 72390,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5372,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 170099,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66665,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74035,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 299668,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262549,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61536,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72140,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62923,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14093,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 224835,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260253,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78233,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1126001,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 75362,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268157,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73142,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11225,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293851,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 96347,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262722,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 255521,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 643451,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58065,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 186471,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 376643,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 321726,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36512,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39490,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104223,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73357,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58620,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5962,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16388,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20761,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 128633,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 625885,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62387,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59256,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 532273,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74270,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10077,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57128,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 656014,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 710472,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132597,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91141,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59782,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 187191,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 829956,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106220,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21012,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20455,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 45645,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 674169,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58353,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59446,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5017,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 41754,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63646,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 86587,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9005,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 221025,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33054,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66565,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17733,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84411,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60486,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 685321,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70659,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 169764,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64939,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124973,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78359,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7098,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 76728,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12046,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103520,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117515,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 122094,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 203196,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 23609,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75251,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70085,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 166337,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278243,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52160,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24773,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 238971,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96695,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96233,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143009,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68945,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77361,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 40420,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79295,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89174,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 54746,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5936,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8039,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23671,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 272313,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 295036,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84250,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76463,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 141868,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72215,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59774,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142500,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100911,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60845,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60859,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85662,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59469,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92086,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85587,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62149,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107362,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 188001,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 431133,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103768,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121616,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15255,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18515,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9102,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 64607,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103786,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 186004,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85004,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63054,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82893,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 201567,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39455,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98547,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10853,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31701,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324344,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 102703,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 561689,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 86512,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77523,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75207,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262202,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 72742,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 198547,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 35165,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 240562,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11597,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60785,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 203377,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43418,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39234,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 290696,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 577852,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 172820,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22166,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58981,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56245,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60508,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71573,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56512,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 177902,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136579,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15866,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21919,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129169,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273113,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10815,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129548,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80207,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57176,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263312,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63847,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 560694,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60347,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 605154,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 180378,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37491,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 54802,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75052,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72332,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74025,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 137336,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87247,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 177992,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43192,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58437,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6955,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70376,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11257,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41603,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 785562,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 329629,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 175824,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107131,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74166,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57149,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76284,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309028,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16894,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 142633,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4304,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 739005,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82126,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70123,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 141799,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1207507,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87051,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86537,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66927,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11427,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255940,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8148,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8812,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 316821,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5481,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8700,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54568,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 264530,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41628,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6393,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5846,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 430264,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 201408,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4639,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 89563,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55174,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57480,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1004006,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97378,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 65868,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 795304,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 500019,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55463,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 18809,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39401,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 127449,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4922,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8633,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 31076,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8029,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92694,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 121082,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26804,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82642,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67272,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57554,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83074,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64133,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 43091,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58242,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 176657,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 326713,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61147,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63432,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58215,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76359,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62212,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8557,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 130044,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56500,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64843,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 66833,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62555,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58278,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121287,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139493,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14725,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57068,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40556,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 159588,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10082,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40666,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7335,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 42826,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19199,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6193,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68263,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 213928,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91370,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 776879,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84219,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10915,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16839,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59908,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73046,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55117,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 584658,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66253,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 106590,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19573,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 243241,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 572660,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24147,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14021,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42390,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54696,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 191937,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72256,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10432,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5067,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73335,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105746,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1080109,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58755,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8043,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99094,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65723,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87822,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55384,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 81529,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270237,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17083,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10857,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40729,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 36393,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16315,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1426827,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14247,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36091,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274654,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64265,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 106795,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 226276,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77728,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18585,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1488319,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80925,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61939,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81251,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96113,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 112063,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 154655,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91851,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267902,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43743,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 155132,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37692,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73561,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17471,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 702555,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42708,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64305,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8455,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83528,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260995,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2965,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60495,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 870974,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73665,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 260687,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 130689,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 71868,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11750,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 677550,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59947,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66413,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57014,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 94135,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261945,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65877,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83054,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14077,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 225931,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74496,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 681122,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304358,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78329,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69870,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 213908,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22137,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6161,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59564,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9198,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70889,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 156716,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 105905,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4873,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5475,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6422,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112735,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64403,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12538,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60069,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8249,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 134508,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56444,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 975092,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91960,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20189,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 468060,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 678258,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 169456,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7724,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41425,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37120,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66310,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9219,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 401781,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 158797,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11247,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90308,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75419,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133066,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15346,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 80075,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4763,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58728,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104753,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109558,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5607,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 636198,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 147613,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 2478509,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15851,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275058,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7174,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68358,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41994,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258231,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289902,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86833,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10465,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16089,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 714293,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 35441,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 336210,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270865,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4650,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89718,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4169,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67558,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76128,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35926,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 75001,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 211511,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 114369,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 340255,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7037,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8356,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38952,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110216,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 195441,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 116009,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 167258,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15973,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16127,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 84509,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91786,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 226415,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14617,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38157,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 56848,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 110870,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8330,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64056,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17867,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 152232,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26160,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117384,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14360,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55987,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267039,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5569,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35687,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135422,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260422,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 387118,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76701,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56546,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61601,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 337548,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 273017,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92052,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91216,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262654,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55558,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1027696,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268651,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258072,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41741,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 643837,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7675,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94258,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 111180,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5546,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302361,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76339,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262548,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88579,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 147406,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284982,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9866,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 339056,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5744,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36582,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92558,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73276,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 593380,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 458257,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68969,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 280568,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7636,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2689,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 166289,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 32476,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1365824,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57225,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16489,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5538,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75267,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84307,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 658857,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10699,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 778680,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138967,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 208706,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92828,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 41182,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64960,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1122789,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101313,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55825,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161746,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71100,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1924313,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55135,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7051,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 104352,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35180,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292399,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 69327,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84956,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22354,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99767,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 588759,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 341497,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92101,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70002,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100522,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313136,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61825,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 202923,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 441564,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 886527,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 28764,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83087,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 206732,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 31912,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 397154,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16677,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88956,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259872,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59580,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 654578,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 624515,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9727,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84497,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 420218,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55692,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 416509,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5499,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42666,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 501058,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6926,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72923,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 720601,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43601,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41882,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38722,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 213409,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280925,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 44542,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65818,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 702718,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 106031,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83944,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5245,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 133714,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38095,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 34122,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8500,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76195,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306943,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 112223,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 641744,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 144978,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12577,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69739,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111570,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9970,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59089,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63653,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7001,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1018323,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5153,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70068,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 550699,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7100,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10217,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307230,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90089,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18732,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13632,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 158217,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96361,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 40133,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38397,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 78314,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60398,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76657,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61783,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 201214,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 37858,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6838,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61709,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69671,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65586,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 61100,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 102816,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55621,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95178,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 666698,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65561,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78307,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 554120,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288551,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 49584,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79301,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 28737,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136141,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57431,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71734,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77680,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82269,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6498,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6763,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70345,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109261,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8128,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79002,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56630,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60961,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270302,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79362,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17672,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 38646,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 178354,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 463303,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63824,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92772,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 338407,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 604636,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87084,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313453,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57827,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60886,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94966,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 32634,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66127,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 935584,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68331,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132624,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9407,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 658359,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14967,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307153,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 449469,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 289507,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42205,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59928,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 209930,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 135121,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 70207,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1033957,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 858473,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6711,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 148355,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44293,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5490,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16415,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22214,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 77042,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60209,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 85024,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117236,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65088,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7467,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 708482,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81702,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74713,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99304,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 64952,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59514,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 864291,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44786,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69027,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 348035,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63115,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57998,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65620,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81477,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66971,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97117,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77560,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66832,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103649,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120556,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79906,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55444,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 138204,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14652,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 437587,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3500,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161771,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68401,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101615,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75913,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88450,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 140112,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59462,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 227934,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 815229,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57716,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86782,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101763,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 217772,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1056741,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8082,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5162,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134342,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 60901,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 63135,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6130,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 192724,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 76187,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 25757,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14124,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 18442,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9280,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 53853,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85438,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61242,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103066,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109461,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64919,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7327,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95263,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 345842,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255544,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 133722,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 711512,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127948,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86913,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 704872,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50896,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259005,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60580,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125564,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 584300,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83065,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 308529,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 159678,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118961,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67091,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70593,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7119,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38140,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126738,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12845,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 77714,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 173578,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15012,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5229,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 62713,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56165,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292324,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11164,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5502,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 30081,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 351116,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80268,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 221712,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5530,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 37264,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 34848,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69798,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68376,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134464,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75457,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81043,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7744,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56854,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58893,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73050,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 105996,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 595588,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 26055,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 365935,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 213740,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 168878,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135849,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7541,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 45632,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 72765,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 159768,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 110148,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273590,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 337655,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60073,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77439,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 362227,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11491,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14952,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123456,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93075,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268921,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5805,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 327799,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67941,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111110,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 108855,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1239845,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40918,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136749,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 989187,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69335,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 25055,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14962,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57535,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 475461,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 51074,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 132680,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 728675,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86393,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133167,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1630722,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55102,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 738035,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5713,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101688,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7590,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59142,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54929,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 226837,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60370,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 136799,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99507,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 303486,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1030875,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39402,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8267,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82567,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10027,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142887,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 249304,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 31228,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88220,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 377381,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45560,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6683,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8906,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55418,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 15664,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 231003,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79064,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93722,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 229544,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 158122,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 59445,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132482,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89010,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 160430,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 77225,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 785892,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89571,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99559,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113354,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79085,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7989,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 216039,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 392599,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1184692,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70037,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96383,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 232912,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 346129,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 88270,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39525,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 317784,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 62142,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271353,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16531,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112081,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108342,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103465,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58692,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82772,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1277826,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 29376,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 60623,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59485,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 721593,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58993,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18669,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1284934,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61671,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66945,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126148,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64474,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56080,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95903,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57728,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 34650,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 384940,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289668,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57848,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 117742,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70500,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281513,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33847,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 496180,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18246,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69093,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34739,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62894,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 110711,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35878,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 185353,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 99995,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 136127,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10394,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307245,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102131,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 920478,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 372503,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83097,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143883,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 134380,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41240,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69376,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63958,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9550,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4744,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 719462,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123827,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20136,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11634,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55008,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 102964,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138792,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55733,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 582912,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 888185,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 45189,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8902,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39145,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 914103,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 424893,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70996,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8667,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 229637,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68194,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 121043,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 32933,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52478,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 129273,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23134,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 281685,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74658,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99460,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 314025,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286134,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 764107,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30254,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6762,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 34482,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59970,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 177864,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60347,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277978,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14253,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108205,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 209836,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43231,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106260,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 98256,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41854,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57101,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74456,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81489,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61427,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43170,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11866,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276605,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 122285,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 584492,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 190102,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 27321,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59318,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64586,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 72458,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70623,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 671045,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56044,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85623,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 35059,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 184915,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61186,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94286,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21021,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6924,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6261,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60078,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 673222,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42034,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 315963,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73060,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263339,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8607,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6504,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 55891,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 487956,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83536,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111443,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 217291,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73311,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17985,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67063,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70275,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 56218,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106393,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11915,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116563,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 978348,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99648,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12024,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105890,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76055,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21869,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 57681,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55273,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1646444,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38613,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68940,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 367941,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1070018,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55486,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77377,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 79846,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 227105,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 79440,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60584,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 757743,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 64546,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 196057,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60253,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116347,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9419,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101245,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74270,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12602,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6351,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 499104,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96501,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 156854,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 595116,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 361973,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59560,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23372,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5094,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 160862,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 105347,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63617,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 744803,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123814,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68134,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38678,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114869,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 92741,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5447,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40273,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12569,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1195785,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 543686,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 156179,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 153633,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86034,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78104,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70804,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6287,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83058,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 126561,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5275,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 64655,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 991752,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69910,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 771434,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31249,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56218,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14803,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10824,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 15883,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 25055,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 43476,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 199179,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6690,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20841,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94401,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63988,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5200,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57208,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59465,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1076587,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 23076,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6162,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 834597,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79278,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 383100,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 80654,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 3495,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56529,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67928,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72329,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286575,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97811,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42640,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260485,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 36388,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5800,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9578,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 233735,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 697720,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7316,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67519,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69939,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10910,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7327,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72308,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5597,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8379,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70045,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88802,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55397,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93507,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6997,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82654,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273283,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62035,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126082,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89848,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 184361,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 784964,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 178306,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 49394,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66336,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24331,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57809,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 38167,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 17358,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 515261,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42326,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7588,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 135936,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58680,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89181,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8161,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5700,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5331,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6876,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 51323,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1001926,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57272,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 441453,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8072,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31549,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65671,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143670,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10411,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 127232,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65720,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114480,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63495,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 84105,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124978,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6526,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81536,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 25377,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95337,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83072,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8511,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 177915,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 196932,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 87165,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 661013,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56778,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1023966,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30135,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 253509,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165424,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56488,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69648,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 29961,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318317,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13551,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1023836,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57733,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119933,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81608,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6955,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 294455,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111976,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5006,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115186,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55256,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8299,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10542,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 227819,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8623,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142923,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 772470,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 178061,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118808,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116823,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15582,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 25020,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 821673,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 160506,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5785,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56074,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5228,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 193306,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57764,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30090,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 153639,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5704,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1126878,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127758,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 161433,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123404,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 303316,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 658426,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 528064,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64991,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61448,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11183,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5030,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 25920,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57018,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 167439,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55270,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8420,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118156,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 139973,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 388575,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75536,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 67172,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6024,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 214773,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 42591,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17351,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63119,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 592751,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13497,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 386571,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62148,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 317933,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98666,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85994,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121653,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 103422,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267226,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38632,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 52267,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62119,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65829,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161815,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11409,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 238830,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61271,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3013,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102376,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54516,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82799,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98101,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 471142,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 818366,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 126930,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57857,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41666,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 144002,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7536,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 227758,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63775,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 125914,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70009,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 206560,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 359407,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 81370,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66815,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 709755,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5187,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58784,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 197152,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90839,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36706,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 101847,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56404,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79244,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 39827,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68089,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98197,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4708,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54804,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129256,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70542,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 18888,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 167301,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12910,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21267,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63752,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6109,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 77316,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7490,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10269,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90338,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 55808,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 233455,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92705,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 64607,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58049,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256804,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4042,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 331242,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101855,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89047,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66947,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5571,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 221654,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 727483,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 988247,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12050,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8816,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106382,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102409,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84524,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121683,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 101264,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64824,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 130588,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 103073,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324801,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126614,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5485,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5996,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16257,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20663,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 36361,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94375,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 57384,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 79354,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 108313,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80075,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136226,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 263695,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19142,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 305613,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55055,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 168820,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 714480,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6201,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63078,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79808,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57428,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58985,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87446,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67861,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 130278,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70353,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93919,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1029361,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7076,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138101,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 713291,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86339,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86475,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10352,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 153156,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6197,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71890,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71903,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 466401,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45782,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101323,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10602,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93928,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103090,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 472810,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87962,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131728,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93907,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 128494,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61824,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17491,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108277,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63495,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60363,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 424305,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27014,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121777,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 429598,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3654,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 101248,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7782,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 602792,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56196,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30240,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7422,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4950,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19057,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 144381,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5273,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108339,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55088,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 475072,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79941,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 56890,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 756639,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97138,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83091,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89044,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37766,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 651056,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 804546,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87445,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 379815,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 23403,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94326,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 642385,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 305004,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33237,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7516,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 144434,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73147,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55503,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69111,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12755,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 541159,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 98744,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4706,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3587,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4433,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6133,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 32300,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15939,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75290,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 359640,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 209221,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 64320,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70500,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 290484,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 119530,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34882,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40268,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75134,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80168,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108965,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11078,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 124844,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128197,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21649,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 340216,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 71372,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7868,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8204,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98802,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91688,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76601,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 92894,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69730,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21223,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 264516,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25546,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65624,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 359909,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 52688,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45519,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284579,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261296,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43997,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289868,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55915,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4579,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 662291,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23114,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41505,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111524,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7936,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66111,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7335,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 49801,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 166103,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15743,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102519,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43221,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8593,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 85975,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6844,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25700,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5104,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 23330,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9472,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65430,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 231007,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7092,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 265938,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5727,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 28415,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54566,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278145,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5262,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6002,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60530,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127529,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 113567,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63481,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 62403,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70396,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5413,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5287,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38059,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 98764,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85230,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 497849,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 143308,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 160477,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 44461,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69311,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320620,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129952,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 314270,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64846,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 105819,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 317538,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1044892,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 116723,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 393029,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70240,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87916,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16446,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57991,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139516,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6252,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66337,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58673,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55503,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 502205,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83188,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 176514,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 133363,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121072,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 125909,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1188188,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54767,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16083,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 22931,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93017,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123433,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107383,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 445200,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140561,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5828,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 206921,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 18399,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69788,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 40325,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98821,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1539054,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 339709,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57607,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92123,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81040,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58069,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83416,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 340633,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 672065,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263616,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58643,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4700,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97713,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65442,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17013,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108079,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79153,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22666,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 50379,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11105,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 710823,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72542,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10274,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 37194,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15860,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36560,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91262,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 636889,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76165,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12371,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15904,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 191119,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111144,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43649,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 200080,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4898,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113444,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 261927,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136699,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78919,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 860165,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 193074,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 203432,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77076,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 62686,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65605,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 54809,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57057,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 976942,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 329625,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 39008,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78285,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102665,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 769579,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92339,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1189942,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77514,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111408,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27148,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65176,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39532,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 166162,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43796,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137709,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 30717,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 549803,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60292,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 220542,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69424,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109325,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56390,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 204016,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127929,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 130138,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 380891,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 582457,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 410525,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 86555,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278443,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83781,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 101919,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8305,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 31358,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 626952,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20687,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11678,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275456,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61223,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7624,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 377826,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 107849,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 95518,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6541,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 380726,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7331,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73321,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73126,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57758,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4530,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 228508,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58788,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30748,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27099,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120095,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60057,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 246486,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62546,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8695,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 87934,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285465,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6157,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19898,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119867,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 68265,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77115,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 32894,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101764,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85383,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105509,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72943,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92026,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4948,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59470,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103153,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 114143,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 62268,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 104205,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67455,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58422,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 441148,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4830,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37269,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 486465,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 474500,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 441186,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42081,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 20416,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 168579,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98323,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 122784,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106298,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78211,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61775,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28760,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71115,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87517,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52917,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 433203,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63861,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14067,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 3547,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66390,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 49182,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11713,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20498,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44084,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13895,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55773,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 56747,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 686002,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96193,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114419,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 75502,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17734,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67704,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 584159,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 310307,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258741,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14802,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113234,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 196965,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127685,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10177,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 62045,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18881,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 50535,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16463,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 81367,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 329982,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33626,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 168689,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6654,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95077,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 38263,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70342,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135363,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60771,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9169,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 408545,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37553,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4707,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55458,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4073,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 884144,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56410,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 59699,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70264,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40900,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54554,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14581,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115620,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35990,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62233,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 117015,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 63913,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84779,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25837,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 423984,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278818,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67535,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65394,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39905,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57659,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63602,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 644419,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 75532,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286163,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56327,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 200092,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 314161,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301372,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5679,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76173,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7258,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6773,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 28328,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 112829,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7617,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83135,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6255,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 122867,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81626,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66870,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77320,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75317,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 651407,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143052,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56306,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35658,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 81770,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 23387,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77167,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 250470,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119889,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 425328,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86287,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58035,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93081,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6743,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83780,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 317764,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 278521,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 502755,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 181517,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60924,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163896,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20467,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 3873,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26927,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 70339,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1122431,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64930,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 96152,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9969,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 197608,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 96315,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 724673,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 71454,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123203,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7358,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1207046,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61047,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 142357,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82702,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302545,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 28017,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6887,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5177,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81413,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60057,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 108710,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39754,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58330,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57888,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12776,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34965,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76181,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31552,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1625600,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58480,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57517,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 355030,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 465284,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111687,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98142,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 521731,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143096,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73682,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 48340,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 932843,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57489,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42836,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 93220,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90329,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 319758,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67305,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61900,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302242,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110555,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 646752,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 344419,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60950,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54609,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 514367,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4986,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67803,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59956,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56873,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92236,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1202962,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56105,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9811,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 387314,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135850,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94627,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10224,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 43566,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293788,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57048,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61907,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67468,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318086,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 413828,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 19874,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4397,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2712,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 188159,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69112,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 40623,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 176107,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100191,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67107,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76798,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37523,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69038,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261871,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112752,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10963,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4987,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35147,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9576,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65143,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10045,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283174,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307266,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14769,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9493,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 110698,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5865,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121507,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 31537,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33082,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 106016,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55651,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 99778,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11046,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281573,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 247300,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 357092,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18336,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58365,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15572,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35627,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 274381,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320029,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57418,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291215,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59409,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55968,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85063,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65853,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74911,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5063,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11511,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 706388,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 355471,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71994,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6253,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296391,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 86926,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142134,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 199178,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115842,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9338,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115082,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7936,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7928,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15110,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17052,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86504,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259190,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61973,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75548,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49076,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298429,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63209,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 875869,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 131047,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81236,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 880419,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18041,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61030,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88351,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19263,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10498,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7062,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66037,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58691,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 878998,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70190,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 33756,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103341,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123778,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67189,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65430,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 242772,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101434,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40425,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86717,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 264393,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 150777,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 33905,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101548,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 214785,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296401,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15494,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4536,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 751629,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111769,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59106,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270740,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318899,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 131394,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54024,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25809,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57858,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93164,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98775,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 744903,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 394579,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103155,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37942,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 18911,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9192,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290865,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 425615,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 22945,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 190307,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 176061,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 183946,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4887,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6339,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 51149,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 109509,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92102,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56822,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7194,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17205,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 77868,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 98255,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85455,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44030,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115981,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 50825,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131951,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86285,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 532221,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 753708,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 93073,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 369683,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4696,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276294,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 329932,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 58387,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45634,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38159,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37754,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39229,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126779,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 133100,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86895,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58935,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21701,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86439,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87189,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92500,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 176218,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7973,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58320,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58430,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296552,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22279,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68252,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11934,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 43572,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15478,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58003,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129233,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 53485,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 168578,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63431,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 127843,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5985,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 29526,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79511,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124217,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61368,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88797,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 157567,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1021974,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290558,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133981,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88669,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12206,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87668,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66016,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5500,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57827,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9646,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 93816,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71351,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 48626,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38920,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52151,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133579,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19941,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54604,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77425,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54661,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4930,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34754,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58074,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15009,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22529,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42408,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 130816,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62562,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58585,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80829,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 158875,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72941,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4714,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29488,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109274,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 113764,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102567,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55078,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267290,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67246,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23273,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 134877,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89772,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55557,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42554,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78092,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15758,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263405,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14068,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26345,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1076999,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70274,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37474,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 62275,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28539,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86410,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 79801,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88966,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88609,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55256,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13144,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9480,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60334,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42129,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15383,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 889716,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 25636,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 224086,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 963764,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 30764,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 527877,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 111517,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63643,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74811,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4798,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68433,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 39873,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61500,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143322,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 89587,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81580,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 139984,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 643932,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95797,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 62205,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6119,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260972,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 86355,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60006,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16046,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73304,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62234,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 125073,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298521,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56403,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 467898,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10005,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42990,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71075,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98507,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79564,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68744,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43605,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292506,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65336,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22918,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 566387,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58009,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 872495,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76275,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312321,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61552,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65696,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6352,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110390,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20787,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83249,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 326999,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5061,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57301,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 477965,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 996455,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300873,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90040,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54990,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70142,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4670,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101710,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 164011,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 539288,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 334565,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61134,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66480,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 69842,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 126138,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 671077,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12376,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 338585,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18487,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83511,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 490163,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 429661,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85726,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 98252,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13324,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114348,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269828,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 29784,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 56419,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70908,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62038,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5237,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 843826,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85043,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10427,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5419,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18575,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 142357,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 94928,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 120772,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92150,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 80809,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42266,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 185330,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 633493,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62633,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 50987,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9991,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40378,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259413,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 130041,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61525,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58632,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89766,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275516,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82977,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 58980,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318739,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67351,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 199234,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70928,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 122083,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 40918,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 223473,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84848,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 71592,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 91171,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 56623,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 55353,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68912,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99814,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70264,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14966,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69806,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15662,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92235,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7888,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11383,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 410504,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 701696,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4953,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71789,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36068,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 310667,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 699205,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 29177,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 278981,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73145,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 580607,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7446,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61682,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6166,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 126316,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 113739,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278040,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59956,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1126350,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6837,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 636661,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55652,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29840,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58874,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112666,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62308,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120108,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103899,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61425,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290086,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8189,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104407,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2959,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21162,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 113340,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118464,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59591,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65388,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 192165,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282440,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 242459,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37150,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 242449,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23558,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19927,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 104378,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23895,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 72904,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 407089,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6089,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61061,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 56624,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62478,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137852,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93556,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18229,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10526,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10615,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23689,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67084,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 35578,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 103354,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 154612,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114653,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70481,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66583,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8749,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 218082,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68672,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56058,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55835,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102123,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 61750,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 115510,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64256,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 224639,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263913,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 505679,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70927,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 586029,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86249,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 102163,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 141966,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40357,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4045,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93680,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5187,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67433,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 522761,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 72796,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9713,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8351,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 777186,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68325,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58118,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6696,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1093723,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16754,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9760,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280926,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63364,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 932479,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136592,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98513,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 98867,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54591,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109252,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 78129,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120764,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 339863,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4787,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90704,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79998,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 45675,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87308,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85684,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 39100,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312542,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57215,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85592,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 113350,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87827,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11714,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6847,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 156755,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 135802,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 181584,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136079,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 45039,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94832,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98750,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9622,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 663863,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99306,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69764,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98789,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71932,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7443,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20550,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5802,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20015,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 172820,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58098,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5186,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92723,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9263,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61341,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99983,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61083,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9955,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57063,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56117,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17339,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58964,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56583,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 24501,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86607,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55319,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 116415,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 30458,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 72667,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14871,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4211,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83549,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21753,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6402,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 371109,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133088,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312386,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108109,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83204,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91140,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56043,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 352663,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60071,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66586,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 98311,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59377,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54691,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55887,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12840,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55209,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12157,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 240823,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 120510,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12487,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6006,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 709055,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64692,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29937,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137577,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9518,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 184532,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 126353,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93215,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 68927,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55284,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107252,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 701002,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65927,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 256586,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7619,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111850,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42526,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 157321,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64922,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 368953,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57432,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5909,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8426,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 418597,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80213,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5184,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 73641,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18394,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5163,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58085,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57661,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122551,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 680210,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14481,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56896,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86981,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84481,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67282,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10450,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103534,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302719,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82397,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26742,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42953,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 167829,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73412,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60315,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6565,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136461,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60561,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74539,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4775,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78499,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 177388,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86582,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 147707,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66949,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 22187,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 623460,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68177,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 848230,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9721,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 191941,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 322158,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142757,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118178,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54929,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9837,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284039,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 110058,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5941,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 88482,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14299,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 877845,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 121383,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61599,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116289,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 915212,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84956,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60659,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 812816,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114333,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 72710,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38266,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38019,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58062,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7957,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95268,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20637,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318072,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 154662,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56244,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7384,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 124930,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 28974,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258436,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 625653,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 22927,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 77814,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 116818,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 159702,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14928,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7349,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 33227,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55010,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55638,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 294240,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61020,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 89786,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65602,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1461614,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9591,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 155695,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142567,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59846,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12063,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 164791,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 388315,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64789,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56558,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 722609,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5966,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72364,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267492,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61992,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 654771,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 909292,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43100,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19317,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40845,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10118,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 343424,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39635,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 25601,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110093,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40792,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74195,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 25919,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67691,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64907,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 230893,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 22257,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10681,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66908,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20016,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76782,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109500,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62567,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 127680,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112927,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 18792,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 64761,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 62622,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103075,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8803,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 165759,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109722,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63897,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80425,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110815,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 141131,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80002,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 379711,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15763,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 58544,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 633901,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7631,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15589,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5227,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 61956,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 153264,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55117,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16807,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1161413,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 28734,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 627859,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5220,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 139173,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 87349,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68065,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 772505,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 44545,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66974,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 379751,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68146,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17673,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 322843,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69461,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77031,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70037,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18632,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10105,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 23998,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82682,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62086,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68494,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56950,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92528,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65976,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54698,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121194,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 197137,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 101979,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8604,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98499,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 102465,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 228587,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 76717,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320496,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56340,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10938,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272897,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71829,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10397,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86685,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11952,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79600,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 691428,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 181696,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58864,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 406255,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76613,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115143,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283834,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288615,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12179,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 218921,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43734,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 21928,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 101837,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86204,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 203627,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13829,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 131548,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38093,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74373,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11279,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 573196,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10477,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103430,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84719,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 417436,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77821,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81491,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 170584,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 163846,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 97166,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 30842,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97942,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31849,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 38448,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11210,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85542,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59266,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100887,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 159897,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14725,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 20819,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61793,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 116983,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56007,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9388,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 25333,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 14965,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 341485,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309164,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136262,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 335821,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70125,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22040,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20969,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101705,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 62487,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81347,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300776,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23389,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20471,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3689,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6676,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 127199,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7087,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95867,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41835,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 483724,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 184518,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8425,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 111163,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90006,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116256,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78526,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 149788,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80294,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88573,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62335,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 230418,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300267,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1350322,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 202477,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69941,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 407446,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 142506,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 136948,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 573875,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66392,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82983,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57727,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33069,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97756,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 71001,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270394,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 961175,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7324,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9441,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 903856,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 926447,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 21479,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 846110,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30757,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62930,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120793,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15831,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35265,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 203965,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59078,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85554,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6911,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80885,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63678,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13495,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 44498,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 97289,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4582,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 860649,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5123,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 83748,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58674,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66444,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65017,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58003,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9514,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 164264,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 449689,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 64911,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 341372,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7611,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70813,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98566,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 162140,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65551,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 110925,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67143,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54779,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59980,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270941,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9738,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 833924,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3959,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6320,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 335536,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71259,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 433335,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 361400,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41854,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8437,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92972,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23718,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 100764,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38110,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 342012,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 317920,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 863864,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 877377,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116566,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 130142,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87709,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304094,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6459,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 308621,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 112863,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8427,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 112795,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 181892,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60958,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5224,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 122364,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 171958,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6848,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6337,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57765,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16117,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 344973,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 28506,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123354,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99413,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 87944,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278838,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6368,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 113887,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81297,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119920,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79438,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 235721,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15809,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 131559,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114197,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91747,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 383953,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4012,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56783,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95022,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 299392,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 207982,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23763,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60887,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8168,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 277768,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 93918,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 30177,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10581,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87969,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43216,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62723,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19904,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10008,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63170,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72406,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 322373,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60442,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138565,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 13984,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298242,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45401,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12524,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 56494,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77361,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90920,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83426,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 84681,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 159085,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59341,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 222410,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55107,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 192029,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56514,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259972,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 56088,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313374,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67779,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5674,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 30130,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 63648,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 68996,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56037,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31364,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 276942,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96141,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25193,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7473,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 113451,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8070,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13698,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 294911,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 133794,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74204,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 125147,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15843,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 223303,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59668,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104616,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 553596,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289954,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61950,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85915,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10536,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58930,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84530,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20167,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110821,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18413,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60413,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 55474,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11855,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59311,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268984,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 182686,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92713,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40602,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 70150,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82601,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126131,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42102,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55883,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16870,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72352,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 326428,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 205835,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65672,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 842574,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8627,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6214,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76776,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 130570,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11633,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5150,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 91911,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64138,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86445,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66105,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 162522,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78293,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84122,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 116705,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 58093,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9167,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 30962,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55927,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4825,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 197618,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14748,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 159561,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 494483,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114534,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17256,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59841,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290400,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 341475,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 621886,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 59297,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 95954,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 85285,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66707,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 424130,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56040,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 96770,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63404,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7664,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 86544,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 482191,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 129379,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98898,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 109594,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95897,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297036,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6800,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76387,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137092,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76031,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70361,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130017,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35113,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57509,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 213738,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44499,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 184546,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119762,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55874,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 422500,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 499839,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 157869,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76856,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66943,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35735,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83602,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59449,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55251,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87062,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69128,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63823,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40223,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23648,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93684,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4918,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55182,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62182,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 907253,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1033067,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304206,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63848,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 185438,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77230,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66648,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 38370,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8847,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 97764,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 629848,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9234,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17970,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42289,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92153,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 35720,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57250,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136956,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 180233,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 507511,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55255,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70999,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273047,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7227,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 59815,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88111,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281430,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109153,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10806,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68386,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86639,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71270,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 169443,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163325,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23130,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27950,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288236,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55713,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69178,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106660,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 59381,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77136,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60343,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119345,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55509,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15692,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 829126,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 32453,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7745,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6945,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 4679,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125495,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5807,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50853,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 62576,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42486,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104696,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67561,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6925,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74687,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 38031,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 29997,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9465,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 424396,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11118,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273188,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 139894,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66174,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8249,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 366946,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55401,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 169801,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109623,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 106917,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 216791,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56431,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8408,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106936,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306375,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66152,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8979,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20726,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 159070,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55974,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62956,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92912,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63761,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83683,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 13956,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55641,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18117,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 744246,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118744,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71350,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58631,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129278,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62623,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 19411,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 219427,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 685231,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 184183,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96463,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70978,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67200,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 214731,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5810,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 849883,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1012705,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10068,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 908906,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74538,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56677,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 888283,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288041,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 97636,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120674,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 600621,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65449,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 87390,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100249,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77500,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 623387,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 126032,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126382,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 60767,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 393411,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11437,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11705,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 316890,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84181,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4642,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16687,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 105559,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 158138,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57760,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62263,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 26165,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40191,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7844,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11411,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 409588,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86547,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44316,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 39797,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 56756,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 838463,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6645,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 34855,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4579,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90555,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 363367,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268090,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64009,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7758,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69302,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139941,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 75131,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69821,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21365,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 407308,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14842,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63747,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18398,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18190,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39850,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 26353,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 802807,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43927,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60762,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 98018,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 72194,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57145,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5748,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 139226,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57943,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 78988,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66767,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 339418,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293402,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 174061,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65885,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24468,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 925680,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 453099,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13154,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111981,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 506680,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60115,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67787,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 464387,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 175220,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24009,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5084,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126018,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104577,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 48082,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 177139,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80680,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95010,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 192275,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 363336,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42697,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7312,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 408324,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 240563,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42991,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82215,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7026,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15338,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 344297,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73386,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14030,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87175,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320745,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 60337,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 89004,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 485962,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 597463,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73387,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55480,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256614,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102931,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37815,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 112248,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 43776,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90896,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81212,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7025,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 48895,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18631,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81621,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8778,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43514,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93900,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45347,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5336,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54791,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255821,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6145,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66917,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 117489,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80607,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5077,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95044,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79484,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27208,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3084,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 32596,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69892,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276266,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 43598,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16526,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 596111,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40586,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76563,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 294962,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5753,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119264,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78243,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 900166,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29443,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 174921,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59621,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69313,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64425,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 30237,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79775,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101627,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91168,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117040,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36347,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63563,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70433,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 130654,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 409582,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 87048,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 400104,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 41158,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90743,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273622,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 470016,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4603,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69563,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272311,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 337575,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66047,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54924,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161246,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70372,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55769,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69422,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75436,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 196810,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121743,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70909,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 54899,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 233333,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98978,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 677529,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18434,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 53467,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 90265,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37108,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 753495,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106597,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13145,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93899,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 342887,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93266,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55467,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 62635,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5207,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 27832,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6845,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 383254,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 845662,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35313,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6225,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 655798,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4783,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87057,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 119505,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6690,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37119,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 52844,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9923,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11084,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54705,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73885,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58073,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 51765,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8061,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 909875,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 59182,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292581,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57129,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 381913,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18351,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68854,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36224,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4507,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 216132,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55768,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78910,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54684,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8411,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7078,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 316633,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43529,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64924,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 56354,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101034,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7175,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280228,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 406693,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 136075,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 515958,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 378232,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 96372,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7762,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 346592,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88506,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16821,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 230493,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67057,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84662,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8567,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60452,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 733043,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55118,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42621,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62970,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10409,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11269,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10205,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78796,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 78452,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262004,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70546,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272807,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81497,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 739139,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59096,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 919546,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103051,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 92075,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30413,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 57958,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109279,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67153,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5298,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 204003,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 181952,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 253422,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78447,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1048938,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20694,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21304,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8004,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 182055,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43386,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54147,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34638,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121952,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 75236,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 176342,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58939,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 36960,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 35805,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106200,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63230,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13643,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278242,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9986,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76761,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40603,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74594,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19139,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61839,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 67450,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 101360,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 665349,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 332843,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24356,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59445,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 220433,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 93340,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19228,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 254750,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40403,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66024,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7609,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12024,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67841,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55781,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 308364,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 74434,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84676,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21709,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57701,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75017,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 125240,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97577,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69481,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39844,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40428,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86295,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 896508,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 220231,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 365538,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83089,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 40538,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 161035,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70970,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59787,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 205291,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 180984,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80397,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36943,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56938,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13444,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 314436,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 155949,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58948,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16295,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 94572,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71002,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165924,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 87361,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57002,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79527,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82484,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2654,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 109305,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60803,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15987,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97674,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79251,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 39393,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79577,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 71836,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105374,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 425304,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104493,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17096,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78909,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 113991,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 39605,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 355178,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118810,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 693237,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 218886,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34287,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85631,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 687101,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 22310,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 664630,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 326491,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 490276,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24612,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272788,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8923,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 137091,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 335429,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88192,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15222,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38052,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289171,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70977,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 75450,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274789,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 117518,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75504,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 66096,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30558,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 192195,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92088,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 80218,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 87359,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 95056,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54572,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34669,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24031,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106326,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 329493,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 319172,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 261991,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58105,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56058,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87771,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 43045,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290726,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88676,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15458,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 204336,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 695085,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 133046,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54822,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80576,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8342,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123609,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 124418,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 483035,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90005,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 189106,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289009,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40270,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 324186,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7811,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 774430,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6952,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 113811,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55603,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91299,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39587,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64164,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92148,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256601,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13326,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58675,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41744,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285112,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 182837,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88227,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85308,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1061112,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 26695,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117500,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 39418,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6391,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116530,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 53828,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9405,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65574,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34619,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 20553,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11174,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30830,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81379,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 933160,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5207,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13514,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272423,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 118568,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76398,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 19719,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83496,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9541,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128726,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4648,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122853,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68528,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 259871,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68269,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 92137,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5062,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 135903,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75730,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57166,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 330573,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63445,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125050,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7121,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1119270,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304470,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102430,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65241,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5450,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 858589,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15552,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98100,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43443,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54493,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21290,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7514,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39750,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 110318,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2794,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 158285,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4742,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 64243,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58938,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74459,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1572390,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 26917,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 614749,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58465,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 31764,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274394,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108349,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67333,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18803,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9812,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8330,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59963,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136228,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 454649,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 34098,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19042,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15292,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 207041,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22675,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1049752,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10081,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54565,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 39952,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5862,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56809,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65615,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 58263,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9508,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36687,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 202822,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65610,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 788284,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 72259,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41931,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127180,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63136,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 812847,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 92183,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 523567,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 109341,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 185624,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8158,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278020,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18149,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 37483,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16618,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5295,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76806,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 784415,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 872120,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16836,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6619,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70370,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68635,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 36726,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 83979,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 48031,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 691427,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 755150,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 759323,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 58550,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256963,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73178,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77229,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5260,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75846,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 352930,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54601,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284991,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 660026,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 32183,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104201,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94332,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15956,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91945,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 360088,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17446,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54660,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307745,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92619,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75920,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5408,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61597,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13044,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64359,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 934694,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36669,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59322,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4686,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 410488,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 907519,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76114,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88873,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 162144,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 74153,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15041,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8555,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12626,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 476225,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11464,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11965,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6356,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58686,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 884979,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9641,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 162027,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 647107,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273794,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 42429,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57120,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66577,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 108165,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 179351,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 331026,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293109,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64481,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 84100,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111551,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 846297,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9810,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58046,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5649,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 35416,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84074,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15187,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20778,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101395,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 319802,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63541,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143169,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132376,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 196692,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59082,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 143401,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 586877,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7295,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 105722,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 191640,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57706,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 142220,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15411,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58281,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31427,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 590043,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24691,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14082,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 997072,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76293,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84128,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68490,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8636,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 81261,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18624,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102820,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 294196,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 790734,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6437,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283985,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 149609,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59001,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 818127,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 230352,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93094,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60896,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261430,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 523675,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 179150,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5436,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8857,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92949,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306981,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11118,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9463,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 188440,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13426,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72487,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288631,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44499,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3639,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 475256,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70437,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54534,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89397,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55546,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 102630,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165081,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 843805,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17838,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59773,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 529234,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71968,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 670022,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 4597,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 211565,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35358,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79934,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 59808,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11468,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300963,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 294858,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18926,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117994,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67242,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59185,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 252883,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 181418,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70740,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69020,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70330,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57149,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73705,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91790,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43572,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70600,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102309,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71549,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94752,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42766,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 36293,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 53739,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21424,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 334398,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117139,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1000685,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7959,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 57697,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67087,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12956,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 930097,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23340,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62577,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79214,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 248592,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306671,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 610512,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59470,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5377,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 564636,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57350,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 155081,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36510,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5751,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 216519,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55915,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61942,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10844,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130912,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15353,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24180,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55490,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84832,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6027,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 220375,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 28822,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41348,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80616,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11262,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 173868,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40937,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 314887,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17030,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91366,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 790814,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 131765,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 229185,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111052,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98559,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 506638,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56039,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9161,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58921,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 333033,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60100,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121955,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18610,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 719566,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 167905,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9735,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 76222,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92099,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76829,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57191,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67098,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20740,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96537,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56003,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 66148,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61169,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69262,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11740,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79640,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55819,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11643,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13004,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 42974,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 264960,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96415,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 711342,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5568,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93014,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80148,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80903,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72572,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15630,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 187869,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60137,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310634,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 613424,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56694,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63836,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67159,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5809,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127565,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8947,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6637,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1100051,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35064,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 161743,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59416,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 308157,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 120167,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 56075,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 598697,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 129553,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 200792,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68189,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4793,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 47843,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313618,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11890,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127318,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26213,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17822,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 100921,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269950,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 554641,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100832,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 604742,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 128849,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62915,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77868,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83837,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 905582,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280899,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61170,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54690,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 316285,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7470,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91807,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85017,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85198,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 154571,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83598,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77745,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 66340,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81755,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56038,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1219822,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10447,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 264247,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 156125,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81994,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43656,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87878,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3063,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74432,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63992,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18102,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 273380,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 184208,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61707,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 185173,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88435,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 140749,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128777,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 911408,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76876,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256328,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 394318,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12426,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 176040,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5292,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5227,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31282,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16071,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 922546,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 987986,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133815,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 50821,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89469,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304646,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36767,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105301,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64554,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 132875,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76315,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 731074,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68644,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6300,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1020056,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 219759,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87135,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 56359,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79892,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118759,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 213458,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126615,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296893,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 80577,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 160384,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 98630,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312228,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71901,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 25591,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 22044,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 42014,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61618,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 76402,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81777,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 876985,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35079,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3461,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57745,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13903,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5129,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 52263,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 92146,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86676,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 123082,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 26193,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4697,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6230,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 98619,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75994,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15816,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67538,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22120,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275996,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 192821,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 51681,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 125817,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58796,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5377,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 668376,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 50262,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36726,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33660,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262387,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59880,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44054,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 101541,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79121,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136137,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 341074,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18130,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9588,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 543779,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23078,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5072,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1189243,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91417,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17753,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285340,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 898303,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 206534,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106331,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271930,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40588,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 846380,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11011,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55664,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23031,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100985,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52487,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 373154,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64277,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54566,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 125270,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76839,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 195856,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 179795,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11609,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 41620,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 90404,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 95027,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9838,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82817,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18078,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282737,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 43421,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 183121,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54853,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 71097,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63951,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5965,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15830,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5913,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8887,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88317,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75917,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142227,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65451,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8443,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43292,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131835,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6314,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 568297,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134424,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90102,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 411450,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8230,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 241288,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127367,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274388,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 137542,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 107230,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6926,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9042,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 43913,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122579,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70506,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127433,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 128387,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273428,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62708,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84945,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1173193,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14144,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 100850,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 162192,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 616388,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59942,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39296,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89441,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 58565,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87503,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91097,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 20455,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 41907,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 567646,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5148,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 664759,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66558,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89547,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24755,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 188614,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64986,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99421,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7671,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 192310,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 608013,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 305889,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9264,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 41926,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68405,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1193639,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298723,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 791763,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304493,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3851,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16143,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14759,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 170622,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88821,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 659872,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28863,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 308304,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5665,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103998,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 442784,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 577794,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 629398,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 182533,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80499,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 34786,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121317,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5639,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106836,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61705,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 95320,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 549468,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66192,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55467,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 44048,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 227456,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 121103,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55255,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13618,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62376,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1016363,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66308,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273788,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 174043,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16773,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74375,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 627036,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62788,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 224791,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 95663,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6114,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83195,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 62584,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134535,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 144188,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9428,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56790,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70051,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40430,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 223531,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42931,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13495,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29781,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 815947,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39110,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11011,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1031668,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86525,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 33732,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102392,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104126,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11733,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 375226,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36885,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63949,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6735,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56351,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 474748,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56053,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142223,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36404,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 175422,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21693,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4954,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63918,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81205,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10643,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6237,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 52778,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 62183,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5180,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36690,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7423,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 121558,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 154618,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124941,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 56238,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20689,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 102659,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62670,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55074,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18273,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14957,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297337,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 2031530,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4960,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74171,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63414,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306329,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328434,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 299835,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8121,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109833,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77312,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82399,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66342,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 67524,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52782,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35993,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36386,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5755,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87714,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 102787,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4804,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78188,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41554,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101045,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62038,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1342574,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43730,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 176840,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43164,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 97579,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96010,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120199,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74309,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67869,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59622,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36975,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11755,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 658057,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 314056,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 72493,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 24294,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73391,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 761710,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100611,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 592107,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69020,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11524,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 124904,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 44398,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 108570,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 51064,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90255,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86836,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20453,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79618,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 265903,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67275,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1187939,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 130800,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6085,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 759382,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 58831,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 716458,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271004,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62989,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58355,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19345,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 541780,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109652,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 84107,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78163,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57416,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55138,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8721,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129940,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69946,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10438,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73486,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 89501,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14978,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59207,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 69878,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65999,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 40235,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71618,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 91213,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76509,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56272,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43836,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 835202,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68140,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60622,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75842,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61471,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74360,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59409,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5812,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 482799,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 19541,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1125010,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 393927,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79563,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82547,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 84187,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 79402,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 159633,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 26197,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 329665,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14346,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43210,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11931,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56610,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321273,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 48054,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 83374,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 766909,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59805,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 299352,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93557,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309334,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 33874,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66049,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55365,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65566,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76653,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8029,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6116,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6090,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31700,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291338,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20610,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16651,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 414532,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 898465,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34708,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71240,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31421,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 203143,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75637,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 514238,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61195,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5168,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269540,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92768,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70243,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8760,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8003,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69413,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122388,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86507,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25342,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 41026,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260295,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321014,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 830127,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 138576,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70609,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279046,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9408,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137750,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59372,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79355,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 544851,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279759,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 58014,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 125029,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103555,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 155362,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 421459,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38511,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87064,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54664,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 45413,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41500,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 715154,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130342,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 104311,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 334168,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96376,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 3966,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57077,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 712101,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 436669,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 719923,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 89662,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 84952,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56167,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 881122,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70662,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4550,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127064,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36738,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5924,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67282,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 193742,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42680,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1330503,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79185,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 42504,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58261,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 509238,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 344665,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279151,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90171,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22608,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 59773,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59019,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68807,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 58246,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 241438,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36099,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281377,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39707,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93482,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 102996,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58431,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 104537,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135982,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77993,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 239925,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302501,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56193,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123206,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88453,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 174560,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 775858,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 897173,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 598543,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10198,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91089,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56982,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 663359,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7605,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278063,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 77047,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4977,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58544,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10233,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 319019,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76693,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114094,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261893,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 381948,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 34602,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35449,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38944,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277829,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112059,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89370,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71992,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77671,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 3230187,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26056,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5531,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 424472,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19103,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37828,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106413,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 675778,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74863,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20241,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57103,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 694249,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 114694,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16964,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 92611,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132993,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5402,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5979,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127553,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 609752,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87530,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106169,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 126199,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23318,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86871,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59221,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59400,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 54061,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5336,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55982,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 878985,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 224594,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59943,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14619,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 294820,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40759,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12467,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56348,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 34582,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90093,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81133,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 107502,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77742,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69448,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56734,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70496,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 86712,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 143540,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63607,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 20084,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 121708,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 13318,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82605,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 116509,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 84803,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61453,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37568,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81652,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58216,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57478,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89122,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289021,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139613,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2853,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 193584,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95915,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6419,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60044,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6819,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 25773,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57312,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 88877,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57226,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 42450,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137004,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 156058,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 316999,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 37773,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38357,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 413220,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67587,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 797226,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55494,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21741,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58920,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21077,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 349116,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3414,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59122,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1341978,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 189475,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60029,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 443784,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321864,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8476,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6333,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 329426,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62372,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40338,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 923709,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6270,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30542,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 206653,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35394,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 67512,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7105,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85185,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 3838,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5178,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58490,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75311,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60749,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 558009,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 97027,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79414,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 375544,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 2105907,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70417,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60544,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98752,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7449,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 340883,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54939,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 69841,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100632,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 43992,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320959,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280730,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59558,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56093,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6882,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67410,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 108826,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15289,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 126605,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82800,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5628,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77317,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67858,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 380438,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71137,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 56862,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60026,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57890,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62950,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129890,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92746,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 43437,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9640,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57722,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79427,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 131964,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7353,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4944,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 53558,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77504,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58612,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67360,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42828,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71768,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300048,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74304,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114874,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65291,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 112340,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133732,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126896,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58814,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6744,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 67253,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 141502,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 84973,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91701,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63878,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27376,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92448,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83697,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 588429,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10956,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17092,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 355656,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59061,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306322,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 200554,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60052,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311782,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 56152,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58410,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76806,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101829,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301589,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116339,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41224,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298807,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39548,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12433,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77936,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65356,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 354325,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7581,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 95303,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 187756,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6290,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74581,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63879,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 86394,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60396,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1050728,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70710,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16161,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71730,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271860,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87402,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 265076,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66236,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68943,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66140,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 13487,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15172,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101397,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 72321,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 2328073,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 167929,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70589,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56598,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101315,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5112,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 41169,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 32610,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309379,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 172621,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87666,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75735,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5399,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91342,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 28004,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60287,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 18482,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 175819,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 777591,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43838,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 54676,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56215,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5007,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 94828,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55895,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 115772,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23116,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 100359,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 102338,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276365,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3216,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1052684,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58035,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 57879,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76047,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101575,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8796,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 140659,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 368065,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273001,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 92927,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74550,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91343,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15161,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 131061,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34872,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120620,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121400,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 555221,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55476,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 271691,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 417019,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7964,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5002,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 41194,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 179257,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42593,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85966,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13824,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38924,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59473,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142066,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268776,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 153327,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 830400,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65799,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83149,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66671,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65732,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57164,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1034494,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 53371,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 460836,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10252,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 238718,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132285,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124322,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80199,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30952,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 28947,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 76862,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 214044,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 794094,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 209785,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307466,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 55248,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15205,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90057,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 52292,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123979,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98467,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74023,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 122147,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 204141,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279535,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 144473,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 138174,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21379,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 112337,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5819,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66142,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 96326,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64975,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 19745,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42966,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7543,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115580,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108279,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88064,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 222448,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60651,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73480,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 26241,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272521,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7180,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67046,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 85469,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 42131,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64165,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5949,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92015,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 238417,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40124,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19083,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 637812,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59881,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324998,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20390,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18102,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 168004,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90357,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 43581,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 47340,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137031,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66022,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71346,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 377197,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21538,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 392082,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 230682,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19041,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57594,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19167,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 906772,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 179474,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82701,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 305434,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136277,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76505,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43383,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 26220,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 166320,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17215,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99731,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 422451,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91774,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43549,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81156,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68962,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 58038,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1224762,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78454,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21511,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126400,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 217665,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 110161,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 358372,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15206,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 141860,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112157,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 713434,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71509,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6258,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 525689,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1025498,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 595980,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 72410,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6148,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 424426,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26361,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39787,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9649,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 683103,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70970,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98845,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62017,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10159,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9807,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 129592,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69790,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73230,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5286,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8976,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8515,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79702,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 153953,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116322,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6097,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 494921,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 75731,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24965,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 716902,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59172,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 47755,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18959,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 34661,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71772,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 93857,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 478412,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286764,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 95396,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62842,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135706,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81867,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16954,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 277558,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14864,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73103,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14707,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79085,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8963,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 229734,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6238,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 79016,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41617,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66310,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 273065,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21446,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 40174,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27746,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60920,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 35778,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 718275,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60949,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80917,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 197605,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41717,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 22412,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 488204,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 592599,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117250,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 269491,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 365293,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8734,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15761,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138348,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68617,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281199,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80845,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76680,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259219,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65455,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12822,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 463442,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 804926,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13648,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34896,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42756,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 72153,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120998,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59011,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113617,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 150485,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273291,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277887,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120381,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 54878,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 51967,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286694,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77053,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 691325,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262360,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87383,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8602,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 330727,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11339,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72988,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 187952,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 491878,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12295,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79192,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7415,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 307929,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118434,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36949,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8896,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 356184,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 454293,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80991,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88089,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19829,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71991,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58983,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7279,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90018,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35823,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30029,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 168264,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 311603,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 975068,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1184481,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30735,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 388560,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90865,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 189117,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56264,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 501630,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114232,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10519,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 91449,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73934,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109417,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302377,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 102721,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43539,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61669,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43870,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 126883,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82465,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99856,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 148022,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 122097,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 71239,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5411,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60834,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284378,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 118250,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128884,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 334406,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97276,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38662,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 669365,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11420,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127365,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 110537,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 84193,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104493,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 32946,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 40751,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 125419,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9925,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11494,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12108,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 130897,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130923,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 58092,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84002,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81952,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 570383,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 99186,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17526,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 378789,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79242,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77276,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40030,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39816,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69347,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55537,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5503,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 99170,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70130,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 580263,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 360201,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12601,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1167266,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 54601,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65563,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 315363,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 455482,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68006,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9746,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65973,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6025,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65066,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 825591,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 45845,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90287,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4615,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19785,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 48787,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64309,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75820,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119282,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 89421,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 132802,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 32591,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309591,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55227,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 979289,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5843,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62351,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92793,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4992,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 564872,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17470,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10734,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105686,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55555,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105157,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34941,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43384,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15990,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 200660,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81741,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57822,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31927,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8077,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18480,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 104294,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267140,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 45785,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71806,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85021,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96704,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293630,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98197,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12864,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5104,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 105848,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 80659,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 143094,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18758,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63392,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42589,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 389641,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38680,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165070,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79354,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 132039,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257060,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90826,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 78117,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 715686,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 266974,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4601,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57278,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4676,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9237,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56733,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62122,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 217601,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 79165,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 62756,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 272837,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21850,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49101,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42017,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 852618,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310824,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 94872,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5549,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 136966,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 52301,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58523,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 40358,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57483,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87346,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 445626,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 105586,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56811,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 178257,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88299,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13321,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56801,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 137207,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64598,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7001,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8575,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64142,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23259,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86620,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1001213,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71390,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88835,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 375306,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7225,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 132779,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23606,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20693,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6580,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6710,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100995,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 196058,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17028,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 95845,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 498400,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19679,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75515,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 81372,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138968,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131522,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 717520,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 356203,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 194671,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68102,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88240,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60412,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 803171,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 653246,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61174,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 329605,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270214,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8805,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5261,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71166,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 114382,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40974,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68264,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70265,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60498,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69872,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 898865,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91183,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280811,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106131,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 616546,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 173424,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57096,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4999,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 198335,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1145030,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 266320,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82086,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54555,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 392015,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28362,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 130123,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 218482,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54884,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23815,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86994,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 38814,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76525,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40104,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62905,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38004,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 448332,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117216,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82896,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304675,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 98544,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26033,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1157103,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 33547,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 177961,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 142553,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41440,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85536,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 117016,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13252,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 194472,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 131177,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6381,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60338,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 17320,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 723616,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5171,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 32602,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117639,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16927,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 68146,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102040,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 61388,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66907,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5884,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65739,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 85183,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 25563,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60799,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21812,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19751,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63144,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 58422,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73370,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4182,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 56669,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 130181,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 138129,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127616,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 789802,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321517,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83501,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262893,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55780,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 844252,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 553153,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58858,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4640,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4933,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55025,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56645,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 747365,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66468,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9927,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274679,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98181,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 191053,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81048,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 203113,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 78536,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275881,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83333,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12772,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64076,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74398,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 35731,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 31333,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 64555,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 51635,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75043,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 174001,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 121034,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92813,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37097,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27004,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5690,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118567,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105003,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291243,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256085,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 132901,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1064612,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52748,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13519,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36757,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 559328,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296458,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 728162,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 605598,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 75188,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 113127,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 182228,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4936,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 315598,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 367965,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 317992,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 369815,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 927266,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55778,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86392,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96451,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15592,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15583,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 358537,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 174171,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268252,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1091694,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7023,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43058,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 270888,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 200346,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 797296,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 480980,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28957,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279901,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288074,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143564,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 63910,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17875,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50750,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127297,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91184,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80025,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6578,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34931,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95705,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88543,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6296,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12080,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65009,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56960,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 328786,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277020,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60647,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 756345,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 31569,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 72575,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68106,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61904,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132801,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67324,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102084,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73667,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112430,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 430569,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21683,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69622,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22274,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64346,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 623111,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67424,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255323,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 110439,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 194933,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84724,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60506,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 109334,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114309,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18511,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 201380,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 170852,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257980,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 65894,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81731,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41205,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15147,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5960,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 617474,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38806,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65098,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260214,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13375,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1034703,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9493,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78393,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5242,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 190694,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 43198,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107915,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12387,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65152,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 206841,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88118,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54321,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 35928,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42626,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 834104,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 144385,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 50393,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66422,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16108,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273617,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267413,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4691,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79667,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 414153,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 67564,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 20664,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 355417,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16928,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 62143,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 93094,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7098,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9283,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 18176,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 112192,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10356,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 31704,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62401,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89526,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 500669,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119283,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 194490,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71828,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 110922,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68708,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54653,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 184277,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18714,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 798812,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 383074,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67781,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39001,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 489680,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70508,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89610,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73552,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8272,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 13036,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82104,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59473,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 813235,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 144406,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 180282,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44580,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83746,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54409,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8777,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 35459,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 3658,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62077,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277037,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 784112,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 113115,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38457,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62838,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 287169,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89449,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 956499,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133985,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23326,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75982,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 419514,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 34551,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81873,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60943,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74105,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72076,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 100075,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84805,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54980,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 105944,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1080175,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 169388,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58481,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43559,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78153,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10585,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 25329,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6098,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68150,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 768541,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 420970,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 29541,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26269,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 143711,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 191338,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283960,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324883,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3102,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 29818,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44918,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 681118,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 242889,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62795,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63103,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50673,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5810,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71788,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11779,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21536,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 223887,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61685,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 322186,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3625,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58315,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83250,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70927,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5174,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 94301,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72816,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57938,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71610,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 706164,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7728,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52213,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115837,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 217369,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112105,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 92355,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 3148,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4893,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43884,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70150,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7027,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 78621,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6037,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82465,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111847,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11780,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6594,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19642,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56993,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11447,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79305,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79663,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 810094,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66526,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69073,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64456,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49621,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39191,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 241464,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 56684,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6233,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10834,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38258,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89704,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15168,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74921,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 118172,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 128354,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30213,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35599,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110774,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18498,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 112151,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6971,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 360834,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68983,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 336402,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4513,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41337,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73767,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 160918,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28019,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10130,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61104,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 744073,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 299576,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5721,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 382853,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5195,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 160216,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20843,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4954,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300922,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4173,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 129375,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22490,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1165235,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109566,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 962177,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66664,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5986,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 28072,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272762,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 379385,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 22963,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25053,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91342,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66534,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60623,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27108,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65998,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 124223,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 377484,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18715,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5776,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68763,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57775,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8157,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259271,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122643,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41355,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91093,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12171,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25936,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42923,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 382442,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 55176,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19307,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20179,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161131,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122063,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81508,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 125757,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 285861,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17871,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89611,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 23565,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65783,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44238,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 110861,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 147372,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 133532,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7987,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69122,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43104,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 311294,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 317370,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 116374,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67517,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281432,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7507,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 110462,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 355876,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67931,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 53210,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1447820,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 32811,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40319,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4808,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 790337,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 294105,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 218263,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91338,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73452,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10420,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90112,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61645,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77661,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 72215,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84445,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75616,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 335453,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82548,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63317,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100869,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55869,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59608,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 401021,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 336863,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5822,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61220,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25590,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282582,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74626,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1494706,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311385,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90518,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66377,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57109,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 72753,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 169836,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75011,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94807,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70389,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114055,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120075,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57457,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 113224,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117880,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 28598,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 509183,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 832316,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 110962,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9803,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 134563,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 77282,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 106534,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71046,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 394542,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 60292,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92311,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 791457,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99766,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5852,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 108910,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93892,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82143,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66056,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55044,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 71298,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36678,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 312443,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 112150,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97980,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15265,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62129,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 867528,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70660,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2565,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71991,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54509,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285290,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8838,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36778,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 65481,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42894,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9621,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97630,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22857,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6951,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87430,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78845,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70884,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 237866,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3818,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89502,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110463,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 69268,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298843,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 129251,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4878,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68927,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86550,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29296,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286555,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66444,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64743,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5308,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 122095,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42515,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262555,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38696,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 56697,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279696,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 196593,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55657,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7292,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21239,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3672,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87960,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 775702,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 17869,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 303454,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 179396,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74757,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11552,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54100,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58674,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 76927,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 18052,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 635218,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 369351,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 40695,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 567751,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270259,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122771,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10879,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 898529,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 317503,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 141209,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60373,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64189,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 108558,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1064535,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67379,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4557,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120456,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 656723,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80604,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257049,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 131720,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19638,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95402,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33788,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 92282,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 28095,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 76237,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 27449,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 906393,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 315108,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55120,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91569,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60227,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88680,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96406,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 22074,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62119,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10289,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 397914,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 568257,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60729,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54870,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76390,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85485,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37687,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 421153,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55467,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44125,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41001,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 140469,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59906,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 105323,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74542,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126081,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5135,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18892,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68338,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 322756,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 42482,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58837,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6383,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 533224,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55369,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1314239,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132368,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103911,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256335,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 29547,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79355,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60234,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13467,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15903,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68620,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65183,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107484,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 128827,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6835,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 59350,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10927,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 265091,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3223,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2891,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 108455,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65751,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5379,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40055,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42826,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 48047,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4506,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 160561,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17755,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121375,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64033,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 101867,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36148,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5948,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76442,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64891,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74748,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 164310,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 139435,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 507282,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55428,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24625,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20250,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 120427,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57578,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6617,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39345,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 473995,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 140272,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 37680,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276050,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122475,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56219,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 631444,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67395,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 120045,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 47100,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62707,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 181998,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65810,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 141751,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14973,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79976,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63974,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61670,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59737,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70960,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 24697,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 679980,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9764,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 39470,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70309,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70009,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69179,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 43791,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85771,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18199,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 525985,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9251,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 13285,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137976,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133975,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69650,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278919,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54749,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 405947,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 129169,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 30908,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 155189,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 121948,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31890,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 77412,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94099,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 240270,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11712,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 379826,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 387930,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74384,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 34960,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17061,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75838,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 238086,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 48693,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7444,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12157,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 626354,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 89737,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 195634,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 596648,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83999,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66650,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18106,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 50018,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 881531,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76886,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99994,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91403,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310497,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 159107,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255797,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2632,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 145380,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 256215,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58304,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85738,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17445,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86506,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85679,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 259158,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70533,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320738,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7546,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290856,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83915,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276134,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 235360,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 112996,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5583,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 398213,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 111105,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92605,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83885,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36138,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313117,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 344382,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 295990,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 31003,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6551,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 266670,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84443,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43468,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23035,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4823,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 155292,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 793662,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272880,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55849,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 596740,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18186,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26900,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99693,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96989,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 986640,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93959,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58089,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101694,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6460,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75860,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93424,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163648,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83382,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1434234,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83264,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6352,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143767,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62068,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9264,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6092,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 223043,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 536782,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 79302,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 3838,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 824581,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5960,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75147,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59298,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306676,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 49805,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 793442,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68146,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 205977,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58127,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 51637,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1043130,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 909695,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 144086,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 30721,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140830,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 992268,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 410255,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64071,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24744,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88045,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313972,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115194,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 199414,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 57999,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10941,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298943,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60618,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63209,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17374,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54682,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17998,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320096,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9477,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19681,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 103371,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165724,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 90840,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85435,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11604,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 26636,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 83811,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4915,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 667173,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 235490,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 66287,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63449,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83659,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 432289,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26949,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11865,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 403017,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 141250,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30965,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 342779,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1192229,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39561,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30996,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55909,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10620,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16791,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 156939,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8428,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 336683,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135891,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 97919,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56629,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68655,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8013,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 80988,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 107877,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98885,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75661,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34659,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 27443,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63101,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58343,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 25660,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 83002,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33036,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 976538,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 29311,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1466386,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6762,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54586,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 670488,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 59446,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288916,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 287972,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3149,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320343,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 182344,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57703,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 41564,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64620,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68103,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44443,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 195203,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 142489,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69414,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13382,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7539,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61191,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 230946,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 123661,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73353,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 377286,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 43093,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5119,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 209695,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14873,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79500,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17425,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 180493,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 396376,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 238244,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 33575,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34588,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 34784,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72787,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4920,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9799,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 24967,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56136,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92754,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36909,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 595615,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100870,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 158149,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296488,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21065,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61416,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91958,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 679711,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 141688,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102276,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20891,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11755,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135479,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37902,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76596,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301808,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54988,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 336057,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14214,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260968,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11516,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3382,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5837,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18588,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 212690,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54633,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109998,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7414,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74412,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111894,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 699605,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74769,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10292,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5237,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22207,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 496173,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21661,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 217997,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282581,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 81175,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 4757,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78665,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98708,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 457242,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 478743,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10389,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8045,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 945313,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9697,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87951,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 198985,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93142,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 178602,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16015,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 294778,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54802,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73478,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58367,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21391,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77997,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73932,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 67561,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60374,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23887,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 503171,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73948,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 182689,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12157,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 110167,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62959,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5482,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 243419,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24830,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90284,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 45223,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59516,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66492,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 116166,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108819,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8944,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42755,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15772,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90944,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4587,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95452,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63936,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 196053,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18849,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6080,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71085,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 159907,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 339395,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 41791,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38791,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8226,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 608651,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 3685,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20339,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55081,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142220,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 438062,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14059,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58813,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 224908,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7987,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6833,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54700,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 397659,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63485,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 810037,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94240,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35809,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 825719,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 228090,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88800,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84812,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281937,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 94829,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61494,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 368971,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92218,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59266,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64810,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 230076,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113859,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102115,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135793,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73288,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 33935,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139590,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 162782,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 534116,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281637,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8750,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15043,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309541,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66132,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121939,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1285295,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 26323,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68861,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23103,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 177055,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77453,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 196546,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67605,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 912413,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75691,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 331135,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54768,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59803,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115205,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 914648,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79628,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97523,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97306,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 116874,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 338827,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 611789,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11939,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1135679,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 712792,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 131787,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59436,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 64429,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24457,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 108103,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67831,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93243,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7004,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 558439,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56295,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55807,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5231,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71708,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 193361,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273610,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111833,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67498,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 192144,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67197,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255106,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122461,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 107389,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 176385,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52039,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1094422,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 307802,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 136757,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7356,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 41885,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 57241,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 43443,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 845805,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 754291,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62774,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 75314,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 525018,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70007,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83613,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278090,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 56707,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 769459,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55924,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54521,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4380,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1055908,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 607745,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 275762,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55228,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84001,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78220,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136447,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142270,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77257,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 36294,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 249048,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12356,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54873,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6837,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55508,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57345,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15062,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8168,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14678,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5039,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 200353,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 305786,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6781,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71161,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 26311,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300054,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41167,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68925,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 372515,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310765,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64258,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 840659,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120704,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 185590,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75326,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67546,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8098,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58888,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 22407,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1062830,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80910,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74572,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5317,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40527,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1560835,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1276572,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10371,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7040,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282137,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 227362,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59371,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8097,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 36516,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99420,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259567,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4762,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 227248,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82069,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285512,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25122,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7538,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 356351,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 211934,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 55835,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 178602,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10755,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8175,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 20590,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 68705,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55633,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91142,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8853,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9952,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57224,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263691,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 622622,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100554,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41998,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64393,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75942,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 363484,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91987,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98581,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63366,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43941,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15365,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102833,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9610,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75862,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 912960,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 739543,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 314119,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1295445,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6923,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39147,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 708558,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7333,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42674,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 796331,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55860,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14133,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84977,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 372980,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101679,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31957,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78876,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321506,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7855,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8137,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 132766,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139086,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69894,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36170,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86811,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123190,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 13811,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7443,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 359759,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 174853,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 25234,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 542233,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 24090,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 163902,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107215,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1381161,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75791,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68866,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5068,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62815,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 896583,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58382,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22889,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70400,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40288,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 64041,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 523760,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 481726,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18075,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328103,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293897,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 195783,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59140,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 167306,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 410464,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 592698,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 51910,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 461640,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67507,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 86828,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6451,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4910,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 141539,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304544,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55598,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 979798,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67391,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 724609,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 142327,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87672,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86951,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57195,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43825,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 126134,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9274,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55989,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 32958,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 159927,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80379,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67785,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 79835,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100397,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59206,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 52400,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 230072,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 105401,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 104202,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3266,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 594953,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 424020,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 555250,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111410,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73061,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 559137,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93704,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23104,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19764,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89862,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 774383,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 345824,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 662505,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 38962,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22184,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88823,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5713,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 144423,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44247,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 362325,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70507,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114408,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10427,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 594292,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 475887,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40212,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 217538,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36555,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24927,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62676,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12952,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 187084,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57485,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 249395,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 25140,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9250,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102797,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 106968,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 123233,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 22606,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 53864,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60469,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 100443,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 49801,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 73525,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 190703,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90220,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104832,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76321,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71405,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7007,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6340,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60605,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272638,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 83876,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16603,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88988,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 960304,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 44249,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57779,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1107471,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256377,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39492,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 81254,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58865,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 41295,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1127115,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94386,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25261,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 230661,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62740,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 226981,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 834223,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55978,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60308,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18902,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 56972,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 314274,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63312,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64626,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8257,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73359,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255367,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81508,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292797,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44104,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6996,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63392,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57265,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12132,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20424,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 37693,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 60438,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 446517,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10415,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30264,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 538264,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66878,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94736,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40855,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 34906,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25448,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36055,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106954,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 342681,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 80008,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 134258,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10361,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25711,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10005,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21285,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 199577,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324789,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8993,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 46891,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17328,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85856,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96337,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 590151,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6228,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 55539,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6698,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22690,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112203,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57056,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 197611,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73960,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61366,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 509258,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98663,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1100220,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61979,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 226942,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289263,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 223612,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7436,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93420,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 200022,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278926,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6907,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 103355,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 129627,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20818,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7897,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 233990,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 617979,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81377,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87124,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 83342,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70693,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66982,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4729,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 862505,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10587,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282681,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61731,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 39713,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57910,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93102,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55712,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 4743,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 931768,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83378,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16354,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90866,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 329627,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 641428,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 254576,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15087,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 251199,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80901,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 124058,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63868,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58351,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83304,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 194964,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57155,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73506,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24538,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 743437,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 627146,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59999,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 122002,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15460,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90364,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39737,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55307,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59821,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19796,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 28976,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37206,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3862,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 114310,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 715339,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 113419,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 55900,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 458954,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 53174,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114232,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10962,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6455,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91389,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6878,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5453,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 100532,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45901,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114456,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71316,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 216624,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70015,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9153,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97791,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 333501,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18571,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 210577,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55703,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 210194,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 847015,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 174857,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 136887,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 58342,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 135674,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4738,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40848,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 127424,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5411,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 105351,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12330,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 706710,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68142,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 94340,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130706,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56328,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5335,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70845,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 71746,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30615,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84011,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 182544,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82113,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297193,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61568,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84388,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54570,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4719,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6673,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134568,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 61189,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67935,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62341,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67540,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89609,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75746,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274911,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130544,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57574,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 609448,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61308,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35608,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86690,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 237783,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 158159,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 170363,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81915,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116362,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 479378,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9085,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 456702,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11474,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17376,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71867,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 325489,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 171548,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 93958,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277300,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62812,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 435015,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12342,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12220,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 880363,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100773,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64160,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83234,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64964,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80834,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5678,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100934,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 915102,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 854843,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40322,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18894,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6289,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 156354,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 884300,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2975,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 55258,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 287130,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 35639,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 42960,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10758,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57950,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77713,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 104338,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85740,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95687,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117125,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21743,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56070,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12137,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9374,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69972,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105872,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20359,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298027,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 94254,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 57614,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98694,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13088,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68524,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57523,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43326,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10095,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97480,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13669,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65168,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79141,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 269390,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56519,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 48743,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300652,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 923798,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 438240,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8553,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 392047,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3388,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 81324,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 438221,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54719,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54874,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10928,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70175,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35672,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94439,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60676,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70476,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37933,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58341,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87634,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 650605,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108937,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71858,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2822,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57629,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 387083,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13363,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 168025,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 138870,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15309,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36139,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79017,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 950301,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4850,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121035,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 928126,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57361,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96121,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105818,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58467,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56134,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302083,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58549,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56013,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10883,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14999,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4804,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 71223,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70067,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 222633,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70726,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12575,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 331146,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9283,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101291,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115545,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74008,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55823,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73050,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 602758,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121618,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 314159,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1087984,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 113061,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 72008,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65721,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17962,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19398,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 76105,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72963,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59125,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 142199,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66094,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 26794,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85813,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4744,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 93987,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22699,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 142061,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9193,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 114659,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52158,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259067,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 121450,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61176,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61531,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18418,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 266836,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8590,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61150,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 336378,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290191,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84572,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11694,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 52057,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87659,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 806365,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68807,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58954,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 563532,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 880575,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74252,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69259,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 109112,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61502,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58845,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66113,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81920,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9315,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37819,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16481,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36158,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 315496,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88098,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114284,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10143,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20725,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5509,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9020,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285275,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16863,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14739,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18649,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142669,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14560,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61387,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85914,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 338594,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 134832,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 41303,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 90133,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57992,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 153394,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54695,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58876,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13685,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275512,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 632497,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5564,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 110034,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284074,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 176225,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67930,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90841,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8633,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68965,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22342,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40266,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163395,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88574,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68713,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 823016,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30573,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1425935,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79565,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286964,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 406409,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67920,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55285,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87872,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11972,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3102,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58119,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290036,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5494,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7941,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 50050,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61549,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 78160,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86583,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5027,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 767512,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62143,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 331116,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285895,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85813,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 963749,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94658,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38425,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136266,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63264,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 326487,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 162495,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65585,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126684,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57134,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85678,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13257,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4770,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65844,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5883,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9291,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 503574,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 391678,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1203377,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65358,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6025,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117358,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85311,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 28581,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118468,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 223649,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11856,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55166,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 40667,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57871,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 65893,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58728,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55422,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 587871,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66644,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 516821,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22413,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5484,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66021,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59545,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82761,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34434,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5502,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 95151,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106028,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55079,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42161,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 50314,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 78483,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84916,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43690,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 373762,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 622496,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2599,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165925,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71194,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72356,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 72295,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 170775,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9223,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95356,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62874,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4999,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135368,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282839,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117779,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107034,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61544,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58808,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256870,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86329,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70834,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33363,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64294,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 234731,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1256997,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 186755,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 230470,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 20510,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6105,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77384,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318753,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72274,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41186,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1255668,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 278593,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7002,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 616007,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71066,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 38801,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 580788,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93019,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7362,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 190342,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45627,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 116706,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87151,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76789,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82435,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121597,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 28345,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 63933,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 113933,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312222,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 37609,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 551393,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6605,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70337,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6527,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 644161,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67895,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 287822,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64033,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111754,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 323048,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7747,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 189489,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59750,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 578464,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57837,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 183391,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10375,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108902,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 123931,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 93943,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 180962,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75412,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94696,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 31217,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76676,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57661,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7050,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 357808,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 230139,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14140,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81770,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14006,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60805,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35505,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16312,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86662,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 732963,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61073,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 136383,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92829,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14037,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 264701,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307413,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109127,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112024,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 615017,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 252706,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6428,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44666,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39113,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 444130,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 89224,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38599,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106462,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57834,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 517795,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11068,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17840,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94167,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68271,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 924395,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12395,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 668750,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66284,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43799,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14466,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101142,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37951,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14155,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73361,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58653,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60801,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57558,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283920,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99407,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50758,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92848,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 92414,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61539,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17110,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58923,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70860,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66243,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11345,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 140661,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 28170,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 156695,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 767995,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3672,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1158095,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289606,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 100803,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 124057,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56136,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 515037,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269733,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161199,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 75038,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 23166,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92976,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7725,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 665317,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 197737,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59720,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143076,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1266185,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114471,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 64149,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121488,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104691,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123194,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 768469,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 525788,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93938,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61299,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103601,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 28228,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292444,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 326386,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1251053,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57340,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 543239,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9132,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68519,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6195,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119991,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27602,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 76961,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 151174,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67459,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3410,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2536,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6309,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76682,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9802,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 38552,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318737,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 165894,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7564,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101971,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7322,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12307,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54543,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55623,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75866,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73423,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58945,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76978,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307393,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61703,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1066331,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65312,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 616255,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 712172,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 18696,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292695,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127398,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37082,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59081,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19502,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41444,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6027,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38133,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65135,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91222,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 98543,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 266473,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 181635,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4780,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284749,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67931,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 134014,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61050,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121546,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312918,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4984,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55614,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 210888,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55480,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11383,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108804,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1279341,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6874,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85850,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281191,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83954,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76377,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6041,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7205,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7511,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 496207,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22925,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40668,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 88051,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 858609,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34932,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 94907,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 56684,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11871,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 118623,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106089,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 26859,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 881926,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 725897,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 678657,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312004,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45674,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39390,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78253,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55634,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70991,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 43533,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 31998,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 196365,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 32909,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 285766,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 740174,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 103804,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85330,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 80890,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68915,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102240,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24156,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 83974,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58267,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 63094,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9608,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65856,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292140,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8526,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 169302,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 984084,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8503,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 50716,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87850,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 76530,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24202,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 369876,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38810,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61342,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58187,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 60625,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73816,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112237,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96890,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 192834,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3392,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70846,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78422,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87083,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 107303,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12389,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 51200,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55893,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 160568,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 118706,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55758,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5096,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 104699,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116227,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14802,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 388128,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84587,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123056,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1645729,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 69553,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83678,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60484,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163573,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142124,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11840,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6351,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104536,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80831,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35183,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5718,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 93609,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120778,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 96607,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321206,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137405,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6362,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 229348,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 91361,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 34296,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120872,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56461,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88021,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 223091,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 185821,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268579,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69850,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12684,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94682,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100112,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17542,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56770,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 116225,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73456,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36029,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 117384,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77191,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133960,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87771,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70317,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128590,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6333,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 112033,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83465,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 332347,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24866,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115802,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56787,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 41314,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42223,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91873,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 319663,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8689,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10355,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43931,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65775,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41712,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58509,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60750,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54606,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115122,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 54408,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75886,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 124306,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7503,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75997,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 177566,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 403496,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68108,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21339,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6091,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6957,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 504171,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 104367,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 968385,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 72862,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73398,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103899,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72590,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8514,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8823,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71756,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 774527,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14553,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 41395,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90783,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17172,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 153055,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 34440,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6552,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 74595,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83688,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 102722,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108793,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 50681,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55739,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 159543,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 195037,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18168,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21074,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 29498,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21080,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103055,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66079,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55806,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99102,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78814,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55984,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290463,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7168,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9895,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18909,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15733,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55850,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74286,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 108268,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56991,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 96891,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 44424,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85260,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 265443,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75554,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67332,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 25886,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 922589,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83123,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76875,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 537168,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54917,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 27918,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78160,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11779,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71512,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54729,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 43362,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15760,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93500,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 43245,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20235,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2982,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70942,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 133921,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11034,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1142069,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126567,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7234,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5328,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14413,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 295171,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84345,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56703,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 132283,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 659487,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 110603,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30902,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 112769,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 170834,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21982,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123318,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 350973,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136019,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 3496,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 60176,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 197221,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 637498,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 43819,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7614,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 53877,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73495,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85274,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 59276,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 82418,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 560517,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 58964,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8060,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 18243,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10872,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69974,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 377504,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5014,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100738,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123610,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1000636,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103420,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58158,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272884,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272170,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41849,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73742,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41342,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60373,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16160,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21289,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94945,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102261,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11289,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122736,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 414669,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17646,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89522,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 78807,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1340095,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 137316,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102953,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14140,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50402,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 229747,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 220138,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 52262,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 570833,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89574,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16876,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97825,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20840,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 541753,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 635987,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68386,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 331523,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 773584,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71038,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55729,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57169,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55418,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118121,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82407,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 119496,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36089,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6025,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 768187,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138943,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117454,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59011,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 129088,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16654,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86305,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 330242,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59573,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81067,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 85668,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4411,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9417,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9259,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 29149,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38303,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 958606,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67048,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 305471,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87528,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23510,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127592,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23636,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 25162,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275422,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 141622,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 362888,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 367328,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86083,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126817,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 45739,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110242,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291014,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 397880,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58768,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108302,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 26174,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108337,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98825,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64090,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 339922,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286966,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7853,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79274,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24292,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10754,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1173310,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 114992,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 113120,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 430299,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83302,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290277,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 131239,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2795,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 77111,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12681,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73242,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63159,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20623,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25613,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56643,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87069,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20249,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28305,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 37190,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76134,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8228,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18296,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 41975,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17067,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 986878,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8036,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13123,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22549,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42529,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84860,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 342248,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63760,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 73080,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 103943,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101124,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280619,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8073,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62665,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 121290,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 693783,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36190,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130851,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65808,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328284,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 340771,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 329314,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 186794,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1046489,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23796,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 103533,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99330,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107198,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5885,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 121921,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 226326,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140805,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60164,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60840,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14050,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277608,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13824,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 96262,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 35234,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 955161,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 71248,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67861,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8258,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 51430,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41567,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109585,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12120,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122657,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 77784,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 206758,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 47250,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36394,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93226,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 489426,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95734,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10338,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38648,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 182206,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4684,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 24211,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27231,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 847220,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89152,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5435,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 157342,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22404,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88058,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276237,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 235866,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 4260633,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37475,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 502868,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57167,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9303,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 43502,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78170,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8803,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72724,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 211938,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21693,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61802,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5804,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 142505,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 138889,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69576,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1005979,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 13248,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 107012,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11561,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43836,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 144435,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7884,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 81869,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112723,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 362221,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64891,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54784,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108627,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71392,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60201,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275407,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275550,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 79883,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262362,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 308061,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 38209,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59587,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 56580,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92888,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97673,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94997,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 612790,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108922,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 561993,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36705,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9614,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22155,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 612650,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 299806,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41044,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82078,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 131974,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11217,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69434,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 317610,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 230606,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 67263,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67569,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 168129,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 31063,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288333,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 159975,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143296,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1136921,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 93695,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270614,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20670,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256620,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 539729,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65919,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 129480,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134308,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 75782,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 141303,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72456,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5861,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83428,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 133610,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 303087,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92079,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 157010,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13085,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7375,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102513,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125129,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8942,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23739,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8922,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 707196,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71994,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 112737,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118983,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59437,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5314,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6183,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60394,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14958,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 66771,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12652,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320803,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84356,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110996,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6597,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 197674,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42918,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 35653,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7849,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 254660,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 57747,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17180,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 418282,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 340684,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85631,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60807,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 31296,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1091729,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7119,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75270,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9100,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44256,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68989,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297854,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97860,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11233,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62591,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 357488,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54963,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55397,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54501,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7012,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4700,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 76214,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17957,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 325852,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62297,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324538,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 35979,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16169,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114415,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 551576,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36599,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56862,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40845,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 680492,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9818,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84274,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24281,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80447,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 954971,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61053,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55013,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88079,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 597563,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 32642,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55067,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18662,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 85134,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10046,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74184,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 33536,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73416,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 180072,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36329,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6283,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86885,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1635983,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5521,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4973,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 75508,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64765,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92749,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70282,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 379954,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117611,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41488,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 877337,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 885533,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140094,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14956,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56177,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39304,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63433,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1047542,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 156755,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15395,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55446,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13356,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90896,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70828,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61849,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17286,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 126617,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42102,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 193565,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69234,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22035,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 239125,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 971870,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100557,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59985,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 315412,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54971,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65210,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 253774,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15055,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67377,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83088,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50899,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 922427,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 77073,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87807,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 872740,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 858323,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59348,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 20104,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 889554,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84169,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19372,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2656,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58671,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 360347,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43618,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42601,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 294643,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9110,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 102821,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24139,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 231944,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83177,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 240797,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67728,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1086343,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59255,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61043,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70317,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291713,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9067,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70646,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44013,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 78296,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5569,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5614,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80547,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 112462,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90909,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56933,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41156,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 85851,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 169582,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23222,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 373630,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 209601,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257926,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43056,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1853028,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69781,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107599,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39882,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 323167,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 93483,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 29702,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39473,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256290,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107687,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4820,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54835,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75588,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13990,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11336,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302211,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 42363,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87475,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90491,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10676,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75436,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10141,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109611,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75207,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 197990,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84195,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9463,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11004,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79791,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12785,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9151,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79547,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293537,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 377909,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79128,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 72611,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7189,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 51312,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3664,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 169512,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 189699,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139110,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20833,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 762843,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76176,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56490,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 776670,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86752,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38675,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102075,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75533,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 137428,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69741,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37090,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22846,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7494,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68257,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64203,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80313,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 53126,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65012,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4668,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 889830,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280634,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77542,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4974,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81849,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61911,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 155833,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7703,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69869,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 109319,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 728609,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 733780,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5328,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90634,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 113638,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 34638,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56497,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111590,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20505,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75627,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38245,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5882,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13412,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136675,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77614,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 61195,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 30069,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7018,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86601,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301362,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74534,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115058,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44008,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43796,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 33148,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7396,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 139564,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1093582,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5220,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58172,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7302,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5115,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99796,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 167737,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 105910,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126616,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 34709,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7200,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43278,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71382,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17677,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57420,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 709709,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81203,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55722,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1035695,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14835,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138255,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 317369,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75653,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58482,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80810,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 190779,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56634,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79143,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 332067,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100392,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60797,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73724,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9217,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37738,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 138146,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10863,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60609,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 107525,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36206,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77223,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55872,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7721,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 59115,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 64928,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76869,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 268424,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 198127,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38519,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 434898,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 332999,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 30533,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 369510,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142216,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11338,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56832,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95493,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58172,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4966,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7838,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 304725,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 196358,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 458045,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 63624,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 108517,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64527,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 266752,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2699,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10392,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59654,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284916,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74405,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278912,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 38783,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54739,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 32765,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 580098,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18149,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34712,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64726,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69344,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301819,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104412,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99084,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 196838,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55933,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1791198,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 109436,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10023,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37349,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 125145,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 136394,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135144,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19446,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 37825,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106840,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 134075,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104015,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63831,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1273033,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114349,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10596,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17627,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 51138,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300348,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 27479,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38199,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118410,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39609,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5044,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259687,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 177038,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5841,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15282,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97022,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15323,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 53351,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24542,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 231619,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4089,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 142385,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76977,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70653,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 179483,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67655,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54644,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 168102,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262311,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74985,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57591,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57133,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74591,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 18295,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 202483,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 48438,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289470,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105267,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55462,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80921,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272901,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 193772,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60359,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61471,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18476,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10386,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16083,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 159385,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 139484,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 824559,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 85272,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69891,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76060,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63893,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5544,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 489685,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 123618,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 222119,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11969,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 304661,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 121118,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309600,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5583,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5097,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 299713,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124726,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 104527,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 190770,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 405377,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63976,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 26054,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135712,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4684,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18376,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97127,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 40592,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298941,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8089,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56624,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312412,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77481,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 102397,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 19693,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6676,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58431,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289705,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76768,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92731,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104165,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 132353,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21663,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7108,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13290,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15847,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132577,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 49057,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20266,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 373192,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109566,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7955,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296825,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 115440,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131328,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55543,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41025,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61395,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55250,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84985,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79178,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57537,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 376862,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101599,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 357939,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263294,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56754,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 115990,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61906,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137966,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1519498,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11719,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1021849,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 95758,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5665,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55011,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 56610,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 86585,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307598,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 642461,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39592,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 18341,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 29258,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37902,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59938,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272569,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 470039,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 76927,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7772,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5294,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64144,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85964,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65435,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101932,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67612,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91702,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57339,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 341059,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21734,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5500,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12398,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4271,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79159,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42360,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124161,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17855,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328505,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6467,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9537,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 187775,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 156409,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 160243,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5321,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24454,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 567739,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55239,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 93625,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 48061,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 28683,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60204,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 130442,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 146165,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52705,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 34519,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90281,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3005,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75724,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73078,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97070,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278367,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36227,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6613,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49468,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 78073,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 316882,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313657,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71467,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282707,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1027458,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64345,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6081,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263717,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 932688,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33616,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 32460,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70677,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72996,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61406,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6955,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104885,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95848,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57425,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43535,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76486,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 445331,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104105,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16322,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 40543,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124826,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1470970,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74167,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 196725,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82466,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29867,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 94421,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 380398,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70381,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26111,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 807998,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40685,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8032,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 946395,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61488,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7520,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96806,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 97585,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 383229,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 228891,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7966,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 57096,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3458,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5012,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 109615,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54635,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56521,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62424,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19908,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57284,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86767,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 51624,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 577697,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307436,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 222913,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135868,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 545287,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 660260,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5675,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68358,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77307,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 173493,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78143,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76220,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50943,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 107073,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318838,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 113989,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69966,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68341,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 491473,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 119316,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9288,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 56190,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280221,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69060,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70404,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54702,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 92685,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 119311,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58465,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66621,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 212476,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288213,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70725,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67767,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 81874,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 542397,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85644,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73356,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 158419,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87588,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 180552,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56053,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79324,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42101,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37712,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103103,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256042,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25351,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 191427,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 206582,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 155163,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 366147,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37980,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49979,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12077,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 77450,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1131908,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1356461,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 90900,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 107046,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63382,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 32374,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6765,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62836,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67062,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284304,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33248,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1741188,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60196,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6256,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12839,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33969,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65228,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 166184,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72977,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40036,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163689,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6929,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34680,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 32848,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8627,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69039,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142433,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 28448,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58054,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104286,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 668243,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 77632,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34827,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43264,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138414,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94514,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288226,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 636168,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121845,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104100,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 755470,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27956,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 48741,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125524,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 72392,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 384657,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128066,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55555,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98029,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40935,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10314,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38704,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61132,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280813,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3023,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80049,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21637,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 343461,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 182074,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58359,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78720,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66646,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14705,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6694,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55766,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89367,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 116157,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15441,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 637934,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 58052,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 140938,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 369489,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 725762,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105591,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92258,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13139,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6500,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82073,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41326,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 36620,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64158,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62957,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1041662,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5715,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103005,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 507818,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57883,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11085,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108941,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59863,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257498,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 536514,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 27601,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74339,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42683,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 360016,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74936,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 136861,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85309,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 382409,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 379105,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103265,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93422,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78660,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9072,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96196,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 503311,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25899,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72072,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108799,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5060,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71905,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70745,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1058639,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60980,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55080,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115943,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 70433,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70242,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80595,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 450370,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 323836,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 49616,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 41606,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 186534,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 963764,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68479,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 53874,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62967,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128255,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5101,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23636,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76959,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 77868,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 164482,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59559,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127429,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21413,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55056,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 343637,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 731501,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289663,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57312,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43448,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10910,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98219,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291740,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 101918,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 341885,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 317434,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67358,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9160,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89532,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 746787,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63592,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1002228,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321899,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 133391,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 190027,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 51792,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57395,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69083,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 564143,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78432,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 231246,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57799,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61258,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 180592,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 962385,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101189,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 70237,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85922,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94381,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92754,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87815,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 549150,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80643,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 200091,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74905,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 598487,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 513755,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14199,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101142,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72447,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5658,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79676,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111170,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 188333,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 187002,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45042,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 41409,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57692,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 155872,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62728,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27622,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17294,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36846,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 384486,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6221,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 195345,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75294,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6542,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62734,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5885,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70858,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5003,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 119605,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86963,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22558,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 125444,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 166628,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62746,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65637,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 131791,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17738,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72817,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 708296,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 228962,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62056,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45940,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135127,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72907,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62944,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68468,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 59407,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296427,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 95256,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260708,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 879612,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87286,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9016,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1095054,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56568,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120267,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27019,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57716,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108339,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82598,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 141416,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 105128,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6652,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20196,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 151655,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78805,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 135222,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25038,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 157664,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42814,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 336441,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10505,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10811,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 46072,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 810582,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 519541,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 572995,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 95382,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81140,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 410647,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 540456,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54862,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99236,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 792519,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30241,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102532,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267625,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62311,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16312,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15537,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 122623,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271416,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4944,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36113,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 305463,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 556050,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 142297,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85710,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 434660,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 707897,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18449,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8628,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55425,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41113,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63102,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118687,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59732,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 90382,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97955,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82733,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311062,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70922,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 921450,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309765,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87372,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10415,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 154648,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35106,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 348675,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74854,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 209581,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41569,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59180,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10239,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89241,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5423,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6797,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4707,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5692,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71214,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 172128,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83924,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309659,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92211,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115271,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87868,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4495,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55131,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55968,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 44288,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 591766,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119278,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4941,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4850,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112212,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 231819,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58498,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28653,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 27420,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68664,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 769379,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24411,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17083,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84069,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 100237,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5580,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 866593,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55599,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 396082,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87415,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57988,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91422,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263013,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42457,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58064,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 103207,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115762,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 40803,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 694885,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49074,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 35693,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58254,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 28883,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69408,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55541,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 336540,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 104211,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55520,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94165,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61977,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99518,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20430,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 215390,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65796,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17891,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120734,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 874183,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68154,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 32070,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 116102,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37241,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2573,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4566,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55325,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70541,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 32066,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140978,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 375356,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 921434,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7438,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12009,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 338209,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 254639,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 399262,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87032,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 32258,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79685,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 75843,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58700,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142759,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71653,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 110964,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93406,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 193482,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 185716,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14541,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114114,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 58908,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 618635,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8139,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 596684,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131228,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111510,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89267,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 20419,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134433,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 102781,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 865330,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 831117,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12195,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70603,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 160330,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56388,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 413301,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 112012,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 294291,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6716,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 470632,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111123,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63265,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 34778,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306558,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 499580,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 136706,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66868,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 807508,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 265334,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 384473,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 201669,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68279,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128289,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 45595,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5004,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2724,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280757,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84485,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115524,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82768,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86160,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57129,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59944,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1405810,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1343534,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9405,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 155371,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103863,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 508632,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 594165,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 2631,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57521,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18521,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8056,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5148,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74026,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6751,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38617,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13714,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8565,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7491,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16959,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6944,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17066,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 44336,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67140,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4724,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 193951,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93584,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18725,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 175532,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7476,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81970,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 286920,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28445,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 46687,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 161813,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 387811,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40307,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79814,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21676,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9266,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 198658,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 232759,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 323753,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 35668,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3353,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 97010,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306549,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56738,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56316,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93911,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4706,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92591,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 98620,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12226,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27552,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 899523,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 557479,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 126227,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19668,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42364,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101411,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100140,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 103945,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12081,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73125,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66915,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44310,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36422,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23220,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4782,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92648,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5126,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 527859,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100458,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5657,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289440,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1597473,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18876,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6847,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19116,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 92535,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70517,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 413818,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 17705,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 622015,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57404,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24293,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 173663,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 116520,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20908,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293467,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18100,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279344,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 97536,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 152988,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11104,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35149,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77135,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74753,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80719,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55991,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116645,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100680,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 442807,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77263,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263149,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67033,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7709,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291926,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71506,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 33259,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17457,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 309358,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135563,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80216,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55072,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 264836,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60780,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105627,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 99459,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95239,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5619,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 831098,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61859,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 58473,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18840,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 261119,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 335646,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 97537,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 359710,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 407638,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103115,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20312,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18597,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 976809,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 917682,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7161,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 882208,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 81575,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 959006,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69466,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64407,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58409,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57936,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65355,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5046,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110046,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 115556,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60854,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57482,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13947,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307507,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73551,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54518,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55667,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9727,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 800551,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129818,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96932,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39671,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5238,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114746,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 332583,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277967,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62421,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68557,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 32712,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135849,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16642,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 688457,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 180428,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 156912,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1087764,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64170,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 231191,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15771,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9809,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8507,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 79530,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61138,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 38477,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274478,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 143021,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79369,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257775,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 191896,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 171847,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 556924,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83328,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65029,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123155,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 231428,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42508,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 81026,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86888,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5572,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57121,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57767,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39812,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6829,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9095,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105978,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 76535,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 165739,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70071,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72157,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 43051,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 140627,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35312,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 314451,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 99156,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82107,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 486418,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2949,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288819,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7413,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7961,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55949,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7963,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69010,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5970,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 137621,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26448,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292025,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43770,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8822,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139363,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73484,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68261,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 428053,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97611,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55533,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85927,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 224293,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 156398,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49075,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77123,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55162,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6183,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 981500,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54519,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80812,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292229,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9813,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22606,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 164966,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80464,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 181783,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 567639,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85370,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21203,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81851,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90567,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 28483,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 72108,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87803,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40368,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33142,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96074,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10457,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 331607,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 218760,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119387,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 39859,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6810,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1069964,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111097,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 32497,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 770751,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 23111,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87246,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 219202,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125345,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77519,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75530,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 209284,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 501794,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 198308,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 767675,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 72791,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 307956,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55302,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 374665,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44739,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 272120,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1598559,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11738,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101572,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132569,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6049,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83138,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68308,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16540,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 29225,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 22217,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 84570,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 336835,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17238,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269742,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 133437,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 38733,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7748,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55966,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6014,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 654707,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 85272,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 29674,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 418977,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58299,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 169987,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11225,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54954,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280435,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92416,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 153072,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58209,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58554,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8470,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286540,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 656368,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5107,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77840,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80436,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55220,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56194,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57133,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9649,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 91885,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59224,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5557,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59645,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71331,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16583,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61200,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69326,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41763,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61528,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73820,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 358884,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73792,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37311,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85547,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6481,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1167185,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20320,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55270,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 315076,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163961,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 39099,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 317381,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36439,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1075586,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 28338,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60522,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114561,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8623,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328947,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 25143,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 57891,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 104265,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58826,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 89006,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56254,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72461,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 482660,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 32285,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 118511,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65748,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 887591,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 212234,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41225,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 244404,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 113007,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 47107,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70660,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71792,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4911,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 918849,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120287,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 236056,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57337,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11277,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80828,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1440325,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82751,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 575602,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52858,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89436,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136924,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 111354,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23729,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14915,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302005,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11473,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6412,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96431,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 79962,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 643039,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61064,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 86843,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94009,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4424,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 266361,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 71684,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69912,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95286,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75280,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35591,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16504,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4502,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86367,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55440,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 135607,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59292,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11351,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43218,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 40344,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8590,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61497,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 19865,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 546436,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89280,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 170576,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9603,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12031,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56863,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 72523,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44102,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 616499,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76491,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1029508,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 451300,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 534896,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106614,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 25851,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4516,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74301,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27672,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1037784,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 19966,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79665,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8418,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 231825,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9243,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50280,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 375250,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7604,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 423628,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 206258,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5823,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13776,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114610,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74434,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128393,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75523,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92434,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16562,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2873,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 42444,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61177,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1149263,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91592,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40066,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7869,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69692,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 345853,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 617186,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260099,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110514,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61413,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24736,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118468,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 214104,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 93950,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18285,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22794,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15774,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 812384,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90956,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52373,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 35717,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59968,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 22415,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54503,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99068,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99898,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 56703,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57510,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112832,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 80885,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 732831,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 197233,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 327727,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 28903,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63450,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 20474,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6276,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274564,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99097,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67754,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 397479,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82416,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21068,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 249596,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8852,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118471,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110439,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 220932,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 748610,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62112,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72362,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93942,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121067,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9593,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 93746,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 270777,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 886872,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55168,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92658,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 303450,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 161607,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258400,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 58422,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74705,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 99372,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87686,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71560,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 219020,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42556,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 43639,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101823,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96175,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62986,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58889,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97052,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69376,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 264584,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118705,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 54414,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 338467,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 308416,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84035,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56355,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137901,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61895,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 72457,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40313,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279403,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 29368,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 551885,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296660,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64550,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71338,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 80988,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58206,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 126606,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9413,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58681,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 315239,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118342,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88515,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26334,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62843,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 612672,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5312,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43101,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 39802,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58012,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6465,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1087389,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 707887,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 165073,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324362,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16353,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 60452,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55783,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5082,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72465,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2518,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36795,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58277,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 318253,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35722,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63746,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41462,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 906538,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107789,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6123,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54833,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 501039,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118255,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313621,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 202813,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 51002,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40846,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115157,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114442,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26578,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 44002,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 193228,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85159,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112511,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82071,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 474154,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22303,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73263,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 28645,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106978,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 138009,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79627,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55615,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 19555,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311139,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1229797,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5894,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30968,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71816,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14869,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22980,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5094,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81098,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86507,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93825,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 155731,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57586,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81295,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 316534,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81057,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67820,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6488,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57371,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5803,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 361433,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272212,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16147,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 362478,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83517,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81105,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11907,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123220,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16426,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16308,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10399,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 93065,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92756,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 2225189,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20072,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284493,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89406,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56023,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84971,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 195381,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 25370,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38307,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 81122,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120791,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16230,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6025,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67831,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5435,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55551,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 156674,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63765,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4897,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10419,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84362,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74842,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15390,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122722,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 122245,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133791,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 158605,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 848970,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84526,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 25301,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55903,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 40037,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3473,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 62440,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17702,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 31163,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1242773,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11545,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 78709,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27794,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 103741,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 325938,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30860,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261112,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 31799,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79489,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 994951,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55526,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12117,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49967,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56394,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 48616,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64897,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108714,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39846,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55946,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56901,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86214,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9425,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 193922,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82770,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66861,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127595,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60378,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40895,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 473199,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64526,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112066,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77095,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 646764,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57463,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80846,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4895,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 549618,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37484,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8866,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57349,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21501,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36680,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1014986,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125698,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 920450,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22083,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 58557,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 535254,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7408,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91446,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 26055,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67735,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5464,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5778,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27612,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 213130,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77587,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 328598,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40493,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56935,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12396,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 222672,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104132,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 98877,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36036,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 145688,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21133,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 776151,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83155,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 164403,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 60911,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5474,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89535,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73139,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61706,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81086,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6976,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 115901,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6774,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133326,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5606,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9400,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 110313,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21500,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 88379,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55172,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6186,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124607,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 74880,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60167,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26793,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11918,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65072,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 103551,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104553,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61454,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286943,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16384,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23861,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 23200,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121150,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4975,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 228782,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 153944,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39491,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105015,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5615,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68668,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 359599,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9475,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5228,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58557,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 126156,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 151926,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129289,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 215532,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42934,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112484,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 335453,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107707,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 235540,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65097,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7059,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40518,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85577,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12343,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108135,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 66823,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114082,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 157773,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 173444,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 981471,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 376625,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 25798,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 691938,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93371,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80952,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 380786,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60587,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5270,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 419163,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280150,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 275067,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 342976,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9040,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 28368,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 91114,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5058,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18449,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 254641,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84912,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29222,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1759488,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96789,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55584,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1057515,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 543880,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20068,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296749,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128254,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62168,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92709,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106019,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 57995,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54605,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298515,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40848,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 455042,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55557,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62814,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66011,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 287501,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 236243,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16261,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 441073,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68276,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 26728,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6834,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313179,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69109,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64082,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63557,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 74749,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54998,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63386,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56923,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 171481,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3558,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 45032,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56474,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12530,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58038,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 144380,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284384,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8481,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1045601,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 112213,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 333470,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65171,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87434,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6468,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 18243,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79714,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10539,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 220062,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129825,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11395,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61536,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321489,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 121512,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290502,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 645366,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11958,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 83427,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89790,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 189965,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 81608,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27517,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9780,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 918872,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127869,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14202,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83594,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16256,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 105785,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22763,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70206,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21697,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 529007,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60943,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87583,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42105,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76761,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 171451,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40705,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1202353,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3768,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21629,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 126463,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138827,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73643,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 68167,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 44012,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65990,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 170968,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 944074,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98357,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 719854,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13947,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11337,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 561241,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82015,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262996,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63740,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5594,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 250591,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54923,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101657,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 31118,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 492946,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110418,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6799,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6917,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 76814,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5803,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65776,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 129696,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4794,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92092,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59332,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65003,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275304,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 100788,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8492,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 46147,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273306,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 482370,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 326358,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73215,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89192,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 92843,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 40919,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63534,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9682,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271751,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 457158,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260271,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21071,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54858,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 458989,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69526,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1018741,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72198,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7782,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99513,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8766,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8779,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16744,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312111,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1532276,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 261591,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 20997,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56970,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65427,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82116,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57300,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97899,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 447597,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18324,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 157967,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 316170,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 702748,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3957,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12475,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7760,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16153,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 112248,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 106799,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102673,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279824,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 57633,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55288,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286459,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 708712,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 580375,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 536955,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16991,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 25409,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81276,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28655,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55382,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73675,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73161,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 110195,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9292,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 783161,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12569,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59180,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86833,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 34276,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65518,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 181933,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 26170,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 61091,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11022,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 130399,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55072,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67961,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58435,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 61399,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7724,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 100346,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5435,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55724,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72322,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 112431,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39750,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 216023,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57139,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4999,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 322885,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43297,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44144,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 681346,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298193,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262781,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309777,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 581270,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 114387,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 630715,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3785,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 894225,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63060,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8759,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 114424,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1168772,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 120701,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 856092,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 699394,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273326,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131938,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 63867,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6214,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 348906,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66851,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4976,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18350,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89189,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19646,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68996,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63989,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 503586,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59743,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 183036,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56614,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104147,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 665400,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 72631,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69378,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66997,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293225,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27346,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 93838,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6489,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 648271,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43488,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72556,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 168339,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69911,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99916,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10166,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 102103,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68287,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259813,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 790827,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94778,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54977,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 242253,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 224323,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5793,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54612,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 746626,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38490,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19220,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 29492,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55385,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60384,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42687,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 291809,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300053,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99472,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 567013,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23633,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13830,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7565,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 4933,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17830,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58029,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58821,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85848,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38567,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 778523,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278815,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 138339,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16391,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 22586,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67503,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11713,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4630,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 188729,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56795,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82082,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63837,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 28961,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19758,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 505207,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67090,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70252,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 41252,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267506,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1105504,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7541,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5666,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121828,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86214,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60168,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57344,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69125,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 26023,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82516,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75185,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 71123,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39450,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 681802,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 360942,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6935,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60585,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23532,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 638176,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60794,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104076,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99417,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5683,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 20113,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66897,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142674,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55713,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11605,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88355,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1045096,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128544,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8303,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 131297,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66580,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21828,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17040,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97372,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81324,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 39452,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 155749,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7401,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92689,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 327319,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 23903,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 806599,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56816,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 798552,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92102,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69311,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291941,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107684,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318780,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260432,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35372,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 343221,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 371497,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7282,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60680,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11021,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1043270,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67387,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139338,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 193421,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74271,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 381431,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57447,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7938,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15454,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 189856,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 931979,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 141595,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54884,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87467,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302309,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96792,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 162752,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71088,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19823,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80529,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116948,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7686,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56566,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 102139,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105734,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119692,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117240,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302941,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 226105,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 118240,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59112,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109791,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 226794,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15145,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18459,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64037,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6187,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307875,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 27302,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 22208,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 52860,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70607,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8216,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 801512,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12092,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67535,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6533,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39760,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 132719,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 40075,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10873,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89209,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120967,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 323305,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69466,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91209,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 75132,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309979,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283707,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8611,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15371,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 81091,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19654,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55621,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73585,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23711,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102049,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101126,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8577,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43212,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 192617,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 129464,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296222,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7659,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93750,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110350,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18375,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4912,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73643,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 77662,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123779,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38292,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 571676,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 953890,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7727,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 163303,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6050,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7049,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68235,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81990,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12620,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 147379,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 22511,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18143,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 188695,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6571,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 185855,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5077,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5027,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 26773,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16770,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8911,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 325685,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 178869,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1939724,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9976,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 158915,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37893,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101430,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44176,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96837,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94113,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17098,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9432,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12598,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61298,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 213841,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 181930,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61532,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61461,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 184614,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 326934,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73263,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37131,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102772,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108344,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 365057,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283684,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69879,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10191,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77380,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9366,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1321291,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113189,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56647,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63172,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66183,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 31607,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81571,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114785,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 52106,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 99764,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310788,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 789558,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8108,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7805,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 174028,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 158188,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99674,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95914,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 75058,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66565,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64546,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10999,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 326354,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30029,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309339,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73654,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43462,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61384,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17426,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 347704,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 96463,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 337730,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60344,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 104552,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9401,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3580,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4724,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80681,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8514,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92532,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79434,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58515,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10939,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64089,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 32379,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 368809,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58305,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6252,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99287,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55583,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66971,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272689,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 777031,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 43273,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1252715,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116020,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11368,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67397,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23280,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71243,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43333,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56183,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91581,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96725,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 36772,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 127083,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86659,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59241,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78036,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87787,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 123520,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70127,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60578,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76334,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6157,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 372744,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104566,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 289116,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63354,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 419029,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139781,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9467,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94123,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100255,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 265781,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6532,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73504,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 172769,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97608,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4920,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11988,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 130465,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43733,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 116493,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62380,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19891,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65424,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35306,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 191816,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 51093,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61904,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55198,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 29012,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11172,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8332,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60302,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 33319,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 139879,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4811,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 916925,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39172,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118589,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 225467,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81550,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 160303,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69951,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 986727,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 41656,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135631,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65202,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38209,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83764,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12695,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56963,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65118,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121442,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71004,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63889,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12658,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 34845,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65220,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55470,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 985248,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59902,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110996,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 628683,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20330,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70600,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16375,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 107690,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 75289,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 22860,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 654126,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 157050,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78995,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 228146,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18873,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 24814,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107771,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18482,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 840642,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42355,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 287768,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103003,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 763682,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15574,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102366,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 37751,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 97302,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128782,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11432,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 802853,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68838,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56426,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6888,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17736,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 29257,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 543197,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57311,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13698,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 152282,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 68074,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55124,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96174,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59791,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312521,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75023,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54676,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35418,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4596,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5706,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36107,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39050,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58472,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5106,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88917,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7366,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 387042,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 214943,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14198,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 712006,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 136280,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298327,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56978,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 28340,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 181114,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42043,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88192,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85673,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16134,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136846,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 344244,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 84476,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30136,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61174,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 241451,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143745,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55148,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105758,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88357,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7567,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10579,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260744,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 350121,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58378,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82673,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 397518,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82368,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 198265,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9309,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8317,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 74209,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127142,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67236,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49636,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 61608,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 635653,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 702482,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255342,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99175,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98870,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64233,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4636,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 25382,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101660,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78842,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 109167,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64590,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7088,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80680,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 191152,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 495436,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 790545,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102152,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 241292,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89579,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9696,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 91349,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 377917,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 214484,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 199785,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128063,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 631309,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98092,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 208659,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85787,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 218148,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 364805,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55710,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5101,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80904,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6262,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92593,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118183,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 352895,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59130,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8112,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 243218,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 167434,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62300,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55530,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79600,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77666,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 817842,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 188812,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121158,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71315,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40915,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6315,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 34032,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 380563,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 165126,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 98008,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 332498,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1233841,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 115268,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 204105,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 122116,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12278,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86705,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62305,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105124,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11883,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5803,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12436,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 105760,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 559961,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21937,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72711,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81458,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 693317,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256335,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16075,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82147,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95422,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26951,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 161723,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33548,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65787,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 674482,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91472,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8293,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55607,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103570,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 159843,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55821,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65207,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 70877,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3375,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126201,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65351,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76644,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30729,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 23875,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40530,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75080,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65824,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97057,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9806,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22465,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60501,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22049,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89399,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 303248,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56560,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58969,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60171,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 126738,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14852,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55076,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106064,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129244,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34630,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57119,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1062032,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41927,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 838992,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34627,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12711,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61436,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 22655,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 118507,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 82409,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 93689,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12034,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 32004,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66620,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 750998,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113397,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 97911,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6099,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8661,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10041,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102199,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77078,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59234,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40610,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125915,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17548,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39660,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15116,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 162145,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 138265,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63279,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21252,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304689,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61490,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6210,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67562,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 748334,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 945291,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86064,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56172,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90186,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 15288,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9920,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 11902,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9193,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11191,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 175990,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54958,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58162,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4864,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 453971,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72251,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75800,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54618,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 844600,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6091,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39642,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297058,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 782352,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 610444,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 370497,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 308044,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7837,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 49039,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56431,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65191,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90341,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4857,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 25801,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54694,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60473,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 41292,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125736,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 512322,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105951,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21882,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57275,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 528486,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79059,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13432,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 644005,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 99052,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90012,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59693,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 39586,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 381320,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99342,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 105247,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5364,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 180126,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58409,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7468,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65002,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63450,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 175043,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90481,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10268,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36696,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105377,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 98924,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64080,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88512,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 76435,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 786539,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97269,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55831,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 19573,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61406,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55538,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 287608,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 166091,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5459,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4955,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 295201,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61724,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6084,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 13328,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 166536,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71345,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17475,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5822,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 355278,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55289,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59647,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27673,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65307,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7647,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11521,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68176,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15634,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 20235,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 322552,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1014064,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1792029,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102170,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91879,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2712,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59835,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 167447,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 463991,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63799,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 242027,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90614,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 29391,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42011,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57194,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8726,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57418,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83791,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 261255,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38731,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 363003,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4767,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 340051,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78982,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62334,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39624,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97549,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1120195,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23097,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297675,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 41248,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 24153,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43039,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 19329,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302259,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73320,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23795,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 591155,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5590,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 231686,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 204221,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65540,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4847,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1213746,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9972,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74634,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 64475,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 866310,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61266,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 75125,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18594,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68842,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55551,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58830,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6367,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 769380,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 17427,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5074,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62309,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17918,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60355,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75219,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 375176,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139579,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16313,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75953,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22402,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5553,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 26725,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64716,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69034,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 31459,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 170046,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39585,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93604,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74840,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60489,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86197,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26945,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59896,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54619,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1083265,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 129438,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13100,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7189,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70968,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86894,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 101036,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142576,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270005,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5945,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50799,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 251589,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1228554,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 315849,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14592,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 769485,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 197637,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7383,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 910965,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 561058,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15321,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19412,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 873135,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70323,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57870,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6181,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276428,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104397,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69027,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13765,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8919,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61320,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100930,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59001,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65823,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285110,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 194520,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 84987,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82758,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 87520,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77002,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9653,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 39498,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96105,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60032,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68332,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126450,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9647,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89638,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59891,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140347,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7382,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 38150,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23349,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55963,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42564,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5475,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 450100,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1234911,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 161514,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90919,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 100661,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8926,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 225457,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17137,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163635,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1004148,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 125576,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5056,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55919,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301985,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6579,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10436,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68229,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 41279,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 178061,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67584,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106836,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5981,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281716,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110846,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87534,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5884,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8482,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 60762,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80720,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 248395,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7586,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60848,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5360,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 64233,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 54864,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55039,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22116,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 125859,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56468,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57150,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 71754,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39914,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63740,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11444,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 135578,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 61853,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59667,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56777,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11352,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 115612,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67040,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 887127,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123470,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9939,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70046,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98846,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8375,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10916,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41341,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4314,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82205,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55481,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38213,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 156764,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 332655,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 35699,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 97629,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 162257,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 322625,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 236900,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12163,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 839122,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 396091,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54665,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 616150,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38641,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82216,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 864440,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259707,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 50548,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256802,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 119695,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 458100,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39984,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11272,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284594,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17704,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320836,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8762,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59622,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 54685,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 843019,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285438,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21733,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 649872,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23657,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 354042,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 126761,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67266,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60492,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11468,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 672515,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 30436,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6493,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93487,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42591,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 474762,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311262,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142967,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96104,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39414,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261262,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 785827,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276598,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98886,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302614,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72410,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9555,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300752,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19689,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4605,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 574008,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131991,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324789,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10555,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82396,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40916,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65299,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14521,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24759,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66673,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56032,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1739911,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59838,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58040,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5061,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1040111,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4779,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 191226,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278706,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 859522,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69133,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 141844,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72921,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 84071,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101524,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87510,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55228,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 722360,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82471,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4866,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78249,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81487,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62914,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 107946,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57237,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 797363,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 348068,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274866,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 726195,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71406,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38618,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 804027,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76631,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 178429,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58004,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121440,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 42057,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36029,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91730,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 221956,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 594796,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 75576,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57186,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 223662,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34892,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310601,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59499,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 158742,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55491,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17784,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 235955,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17655,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281321,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108077,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 91534,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76832,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74660,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130648,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 230734,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 47611,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67997,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8224,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 28745,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127220,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63798,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81939,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93614,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 394116,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135883,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58754,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 209146,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 50034,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86231,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38359,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9437,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 794174,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 133134,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 167139,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64195,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 630228,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 482962,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7906,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 100308,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 972704,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11506,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 147571,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 110245,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14795,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272624,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13544,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117418,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83696,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 30237,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 63680,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61336,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 123406,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95218,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7362,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 525705,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57101,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 53729,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 36869,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 22464,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140027,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 601863,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121982,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 178727,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 608493,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11699,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99930,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 733163,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 895410,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92471,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5288,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 128663,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 616362,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 365147,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 646364,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81006,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 137397,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 731005,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 104373,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75845,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286627,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66322,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1247490,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91826,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11098,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11732,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143328,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71622,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100433,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25154,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57876,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269102,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 356107,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17230,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10706,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35698,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 204633,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 79708,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85949,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306617,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59703,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 41588,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67678,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 176325,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 787917,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6267,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5671,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33934,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55071,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8803,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85363,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 339880,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 123533,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64121,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4092,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 390008,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88891,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 334355,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87897,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14848,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82760,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 207081,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 88269,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 180016,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38244,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9350,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 13636,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 28161,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19099,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54580,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 331233,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 175269,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14392,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 647362,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61515,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55623,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5727,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131731,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 234172,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71864,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93912,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90423,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85421,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65937,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 368658,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73655,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 96747,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 232976,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62019,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 914264,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61783,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23265,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127377,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8572,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25790,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 37384,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9131,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84815,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 313840,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11442,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81527,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68289,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 37825,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71303,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55931,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 220127,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36123,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6536,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 125498,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4910,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37862,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63167,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 868400,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 131830,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 125388,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5047,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 594933,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7980,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 80434,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62731,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 118596,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 89116,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 46677,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 130641,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 816800,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 243697,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69962,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 332246,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81685,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 116545,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 308892,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18505,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67535,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10338,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65537,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 52058,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12248,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8627,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17060,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65426,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93472,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43624,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 643284,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87145,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118894,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 265489,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9326,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80077,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288960,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78684,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10521,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 929159,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9951,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1060898,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58758,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99254,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26414,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77796,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 160725,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6694,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 240937,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 236905,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5354,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17171,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125041,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35819,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34668,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61197,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83251,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 390303,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42457,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 124870,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114877,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7944,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 338065,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267898,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 642422,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56678,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21735,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 180574,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 132880,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 35476,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142914,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59361,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77044,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49357,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128885,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79332,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70616,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 217786,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71917,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259622,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 412421,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59280,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110790,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12548,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19427,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 62991,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69253,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18248,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82527,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 104445,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61131,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36738,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86527,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41605,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82792,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 573669,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113456,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 808220,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 102671,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 30137,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129880,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 261752,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77835,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 271404,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88617,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 698242,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1021575,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69649,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 42962,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77318,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67710,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6878,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7161,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11436,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79071,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 60303,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 89196,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 739883,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102151,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 31469,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 176605,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58053,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6908,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1104245,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313295,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42005,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 811197,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 189675,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78446,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58857,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73274,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67518,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4638,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 136585,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19812,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 105864,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82655,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89969,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 78731,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328399,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82403,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76164,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70398,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11098,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 384721,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104114,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 51398,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 122266,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67080,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1150623,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85975,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6254,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71724,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38579,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116608,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 731172,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4741,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83025,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42734,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110706,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 786034,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7683,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64976,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 551907,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35514,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61745,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 809049,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 13189,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 493744,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 53177,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111848,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109268,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 833857,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 332552,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68645,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91256,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3306,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13602,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108230,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74445,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 916534,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21855,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21137,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 342738,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 98232,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 101763,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10263,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66932,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 83255,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 245074,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 39282,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 849836,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12660,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62716,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 95560,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290756,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 362488,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30722,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 429978,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65165,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106913,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67534,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82326,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76888,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5820,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85744,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15608,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76743,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83438,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 84278,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89315,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18693,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64184,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66529,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19969,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 571152,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82944,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9409,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 592557,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84620,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57260,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 364838,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117455,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258789,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6143,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40460,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61497,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37145,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103651,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 94459,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8378,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 247953,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68541,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5753,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57003,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 34976,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 266764,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37081,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 353737,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55084,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71685,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4646,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40278,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11470,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 96712,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 383337,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 51249,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15056,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 507370,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92172,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40460,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 524369,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1510117,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65133,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56145,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 32859,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97237,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 134414,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59975,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 133548,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73793,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5135,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 72786,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 418047,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61675,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58738,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 486249,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8157,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 78067,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31060,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 636546,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7303,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25893,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17343,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36590,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6334,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 101004,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16418,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 810258,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54720,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10434,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161213,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8299,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 130507,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56405,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1317955,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71350,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 112343,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16626,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81282,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 91402,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70795,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8681,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6046,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8416,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61378,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57027,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 241391,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108845,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8436,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8006,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41085,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6551,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 489996,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70969,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 331091,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70518,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57810,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79773,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5100,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 78634,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42885,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4868,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84584,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5734,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 309187,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 390716,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66946,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69133,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10537,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59424,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79328,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6227,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65118,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9775,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87369,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 28003,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8670,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77829,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 32240,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3493,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 696116,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38852,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70175,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39767,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22284,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328725,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4580,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 144859,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7101,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40685,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7020,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 100660,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256458,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90970,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 593098,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 287208,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 167274,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90288,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74258,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 326245,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86624,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 98296,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13830,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301334,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79125,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4921,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312694,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55635,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56703,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 741887,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277555,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 35167,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 438920,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14695,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106020,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92901,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21247,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95702,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 116080,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291832,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77633,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 486169,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283239,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 118212,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 101677,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9982,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59610,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1144420,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 547621,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10348,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 61756,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 506423,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9844,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78330,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271352,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40560,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7673,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17520,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92467,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 401666,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42519,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69301,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79136,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64580,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38682,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55814,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55038,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59702,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69586,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 123663,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56107,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 109724,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1533019,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4745,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4636,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 117368,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58259,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69860,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12221,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95176,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87682,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 304446,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 39271,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 95769,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58652,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57746,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 115036,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 203098,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 64788,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307416,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60396,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 132436,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60734,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273037,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 546463,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 127500,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83173,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 403804,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7566,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 656753,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107526,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73474,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 124094,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 132782,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23262,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43569,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 96336,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69226,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 257506,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5337,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 132209,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1167944,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14881,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139016,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87142,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16563,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62001,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57255,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10553,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269923,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5492,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 107370,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55367,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119621,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55966,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10656,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 429781,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73339,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268326,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 157505,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38602,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 85953,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 802141,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95413,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99489,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 119431,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 239446,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 677902,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66336,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 34627,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66559,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14410,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 947988,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91151,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119417,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1076893,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59894,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 221373,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 234062,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 74371,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96963,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84003,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 615579,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 731649,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100847,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104492,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71343,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115374,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 53995,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16875,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101680,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 61918,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 34985,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16637,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 132393,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77732,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8613,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7324,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26556,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 617163,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15733,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56228,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 65700,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302578,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 964588,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269446,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1566834,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 193333,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 65427,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83972,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58019,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80314,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25173,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40652,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62846,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71984,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 127545,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68524,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18381,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 42935,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84203,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 97385,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137612,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12271,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56067,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 181946,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3753,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29214,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64924,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83124,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 628286,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 277706,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64038,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73839,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25167,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58375,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67434,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77967,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311412,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120120,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1235702,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79282,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64048,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 299590,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98470,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 76321,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 28179,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54808,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6724,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 658813,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 154973,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 102753,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59777,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 148303,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79112,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89264,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54985,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12986,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61770,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 698741,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83583,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275582,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10012,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 22354,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41712,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 689698,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 145205,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 18077,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 521226,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71791,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133257,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 18918,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 38018,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71269,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23664,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 210104,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 287897,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 235853,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 95885,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115740,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 115213,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 34728,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 40612,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286912,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 64003,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66589,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10857,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125931,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59474,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 120500,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12724,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67230,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 28034,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 199287,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 167994,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81133,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 32336,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6487,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131186,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71522,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13267,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298549,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 248409,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2657,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57430,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 109105,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97533,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296999,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 325903,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 47951,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9708,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76642,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6922,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9663,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 121753,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 122226,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 116652,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 184934,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55712,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 96670,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 58652,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 464958,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17713,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 115436,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5254,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40160,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61636,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 508127,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73770,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117370,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81002,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69726,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14964,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11001,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56881,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 64142,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7005,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64952,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21406,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 188203,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12190,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 706040,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 539455,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72867,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119739,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16750,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107197,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1126010,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111029,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75790,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 244378,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92936,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76298,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76350,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 197796,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16849,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54508,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21460,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67126,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41429,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72216,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107570,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15264,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 214442,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 184621,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16518,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81306,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137422,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 238046,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3204,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94698,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117554,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5729,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5125,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36948,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23689,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15275,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62291,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 165643,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4436,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5715,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8983,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 623324,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18134,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58814,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43363,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56214,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10747,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 76445,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321357,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300263,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9444,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38888,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 37312,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100395,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 25602,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80334,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23540,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5137,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61725,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 96387,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9555,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 100603,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73801,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39271,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59297,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302471,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20580,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 30252,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 332066,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 41194,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 190751,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60143,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23531,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103681,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 433448,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 56395,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 125943,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 80594,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 63571,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14909,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111944,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75940,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 63379,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74459,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73964,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 224752,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282539,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 117603,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275885,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 724094,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13370,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55926,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104678,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133702,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8698,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57283,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 75108,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 98534,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21895,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9834,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 290252,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56293,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312257,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 108823,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7498,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 156524,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60692,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86305,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1162405,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6108,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 43714,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112538,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6430,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8742,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71485,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42911,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 175141,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 91093,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62628,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12573,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86088,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21214,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5007,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4499,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 168553,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292760,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100491,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 902194,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30462,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 14611,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79064,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 118648,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129535,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62726,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 65512,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80711,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16448,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 184001,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 607060,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 110100,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 35802,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61370,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67277,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40707,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18609,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 28521,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15585,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55299,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58310,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74013,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7211,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74599,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 182523,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297353,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 28132,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 653836,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 119831,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7686,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4655,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 22398,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 86214,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 86495,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 717690,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1347167,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59012,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271273,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125154,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 367673,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 223864,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57231,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 72819,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5681,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 90170,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 36087,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125918,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38093,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 136199,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62712,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85584,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 88259,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59375,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82922,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8657,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4809,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78663,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 34892,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 159415,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 465150,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65392,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 80982,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1155050,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 124145,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27138,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17644,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34760,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84867,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127838,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36626,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92430,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78429,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9239,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67587,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73362,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61633,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82532,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 144318,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62406,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82700,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 364060,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 356234,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 29780,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13779,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 19131,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56289,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21737,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9439,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84122,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 183877,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63342,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38649,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1034964,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62807,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 334736,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5444,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 484404,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90927,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30769,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80162,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50567,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83380,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89863,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 28888,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86641,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4891,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256045,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 139701,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 113211,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80107,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5926,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6160,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68532,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 19713,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 71586,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90534,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43426,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67209,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98616,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 35375,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65436,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104190,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60674,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8123,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302768,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26401,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97931,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87097,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60409,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62081,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57436,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64022,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17347,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 107271,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 539551,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101338,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109651,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37853,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4661,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21463,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19973,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274559,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 176796,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36364,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 79341,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 174561,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92201,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92577,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 482098,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71319,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 732870,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63431,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 329111,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36220,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 88679,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37567,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76540,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 123660,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63285,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104521,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4716,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 166205,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67709,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84438,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19261,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81749,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 56674,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16079,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10595,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79934,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9814,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258301,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 178204,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 130361,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 47284,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73713,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70197,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 219384,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65166,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1257835,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 118814,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 689882,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276550,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118323,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 113318,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 795375,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56704,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1170291,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 29076,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77185,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 795617,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 98390,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 117816,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6244,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57025,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80124,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 616313,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 773044,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7529,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59872,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11817,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54706,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68229,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 419051,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111546,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 23744,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 766156,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 210330,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 224263,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6600,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55372,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94814,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7178,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10852,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 760582,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261329,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 753409,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 32115,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 339841,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301414,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87826,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113667,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 85901,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55283,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 379484,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 84646,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313702,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9724,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 338545,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34755,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 452346,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65500,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 97911,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 18481,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 74151,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 499419,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63689,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274425,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57302,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 213178,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 208608,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 79211,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 132846,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7173,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 141055,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75259,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256777,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60003,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18280,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77289,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 222380,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11819,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 845037,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 48540,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 434899,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 319461,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40896,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 17134,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63729,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 341529,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65182,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 697567,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82551,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1275968,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5500,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 33338,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17110,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17047,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65712,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73760,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60560,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80135,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4503,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3540,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59401,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 119989,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74858,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74763,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39820,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75783,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12299,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8188,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100725,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57772,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 137203,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71243,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63550,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 61036,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41173,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 250035,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60442,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 52066,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 44293,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35454,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87990,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 11209,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 499862,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10280,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 673287,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23052,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 131080,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70668,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57301,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13387,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269716,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289317,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 597256,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34514,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7836,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43066,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9136,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 20967,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21101,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26495,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55651,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81363,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 675328,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 85369,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 157776,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4830,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 771155,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 153709,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76585,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45882,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 882037,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 934722,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 128346,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 120775,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1137769,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 156900,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7794,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 42540,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16524,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68463,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 377993,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40871,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14038,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91523,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 359759,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67867,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23245,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43406,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18809,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8504,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 358617,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41127,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276883,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27654,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 643363,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 117128,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 562719,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67775,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 353872,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10556,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114965,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65547,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9100,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269238,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 124939,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10406,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88591,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 98772,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9634,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 26082,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70222,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77810,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 228183,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 323470,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88869,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56474,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 179557,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56095,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69257,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 240232,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 430270,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62416,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55686,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 406926,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307833,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7058,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42878,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84722,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122465,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 47143,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90320,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79465,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 51131,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63610,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70647,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 156807,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 219405,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111019,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3802,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70651,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 178591,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 835734,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11586,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77874,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50736,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 190742,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 123762,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6111,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 344033,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 408869,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57066,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16583,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41825,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69161,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 895539,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 228371,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68658,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59178,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139339,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5234,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 90933,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88802,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55448,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328346,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5159,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12769,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318937,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 237064,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 43824,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88250,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114278,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 379604,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 853612,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38493,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310539,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291604,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 54825,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165464,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92171,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 823970,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318600,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268478,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9354,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55404,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 340272,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91927,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8801,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126616,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 130577,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6625,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 55298,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 166211,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 50533,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12416,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 51275,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58075,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 384338,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59583,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 28896,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 199303,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 520367,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54851,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 854918,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1123760,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60146,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58568,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72198,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8115,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 118473,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100742,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65756,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 27990,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98385,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 135457,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106870,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91387,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133996,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 961911,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80715,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 265688,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60847,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73963,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55585,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 75358,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65928,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15814,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5888,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270946,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90557,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 25482,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78660,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4805,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 116213,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 182054,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12177,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5477,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8466,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41584,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 783211,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60137,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126979,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74648,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285548,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60226,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11185,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 120072,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 128050,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 547535,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60955,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82541,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79212,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17687,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97614,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4528,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 78448,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12941,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 474803,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 226268,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54816,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17340,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11144,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62713,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40889,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 590766,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 25558,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278868,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256449,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127221,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70796,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 119885,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5692,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8302,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40707,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1302173,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60225,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91367,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 261024,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15125,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86458,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 101243,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1010366,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42934,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19640,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4189,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62875,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119583,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124475,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98408,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 607587,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 146303,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10440,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68735,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81972,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95121,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64797,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 103948,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71118,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69678,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 341123,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 199940,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 564616,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 200209,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67265,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 134782,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 941924,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 69879,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 686369,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 618492,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 158186,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 75398,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 497685,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70026,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78811,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306928,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64341,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55492,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 66234,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9522,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328224,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12708,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 70789,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7199,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70689,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63970,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 337417,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90768,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116525,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 722091,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5130,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20129,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17351,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131491,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62985,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11922,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45058,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76520,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6431,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 465158,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260383,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 142042,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100641,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7835,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 91615,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100687,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60519,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94027,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 86933,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 332664,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 26831,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 287658,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 208280,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 66267,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 357910,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54953,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257382,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5032,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65815,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8669,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39604,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59237,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9835,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 85875,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 822818,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61466,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68910,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1154731,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 33690,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280738,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71150,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42850,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58996,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 132737,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65961,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 57292,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70260,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 112199,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 303680,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56838,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 195327,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37149,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 34623,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 27088,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103795,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 96991,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 182206,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67989,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 212118,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284464,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 41411,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 80182,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291207,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293477,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108040,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7958,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17746,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 159751,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69204,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34518,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 121339,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61295,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 47113,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17509,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 144231,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 34838,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 251358,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 175846,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21058,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4264,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70766,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40118,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68124,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 64834,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88790,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6086,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 72031,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276427,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62324,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61142,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 212940,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77620,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75228,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1193931,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34819,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17958,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1048371,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11449,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 252344,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39372,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57848,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 282469,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78108,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318058,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74599,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55274,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56466,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31731,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273676,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11129,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5954,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38432,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8400,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89092,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 42666,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 191750,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 198763,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87049,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88806,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138428,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9397,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73755,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 180629,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38035,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 349006,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101785,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137101,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74838,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104438,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 93996,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56032,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80712,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1302144,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 221886,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 56122,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 886516,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58129,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99219,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 102267,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1161280,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 39984,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61992,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70480,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115878,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57397,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 116876,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 198368,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58036,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4998,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63325,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134874,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 559890,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80845,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 59876,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22914,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55124,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73231,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58352,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 96226,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278184,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 168556,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 110039,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 179685,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55061,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 325422,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 714292,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275026,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9430,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 956997,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60398,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55171,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 115943,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88117,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 631681,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135573,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73965,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68664,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9461,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311999,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268872,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 169019,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 253174,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4673,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43459,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 17933,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59222,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 619584,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142725,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288133,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 34749,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74861,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70158,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63096,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59294,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286588,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37228,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 34572,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12723,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66014,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71089,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98891,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60991,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288644,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 71092,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 63417,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58772,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73275,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83940,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98065,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4960,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56150,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6001,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281917,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 726729,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 97814,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120681,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 167828,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40192,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75413,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5483,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 494688,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1082973,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55365,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 118080,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 803698,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39196,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21327,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4541,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30411,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 900192,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79967,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165297,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11345,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63860,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42629,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 38532,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84665,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57410,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95308,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6910,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81188,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86828,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 342713,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108780,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74513,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 168918,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63046,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 183021,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 330612,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37715,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 356402,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100932,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12245,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 593297,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44417,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73294,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60859,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43199,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 498488,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15910,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55454,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 30608,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56297,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 821667,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14192,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 872927,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 96515,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 156455,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24075,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165297,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 36694,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 162528,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17267,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282825,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 50050,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100215,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 102057,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 124156,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9422,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18016,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59201,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60644,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78584,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7806,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30928,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91197,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 800303,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5755,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 136068,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 308346,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94683,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 829015,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 295382,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36952,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 222099,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121714,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271624,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56128,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43926,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50807,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 179317,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6184,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 350844,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60504,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 99318,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 102299,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64869,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122046,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55033,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60470,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 276493,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95178,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9304,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 696837,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12142,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290449,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 97208,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9132,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7349,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 222176,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 159537,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103052,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59011,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 606023,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 614523,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123850,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 783396,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 169242,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 982894,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 652317,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42135,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 383360,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15614,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 153075,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19556,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44248,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77768,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4978,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 68657,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119422,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 205740,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115473,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 97579,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 773054,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65137,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57843,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77280,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297005,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58868,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38179,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114504,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 837931,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 809655,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95835,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 340329,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82337,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 533879,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43724,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57376,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 123426,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57470,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 146127,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 482568,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 61958,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2734,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 162354,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13397,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 142236,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88378,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 528992,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 356504,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 63573,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 129156,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67139,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10414,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68638,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37221,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61496,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 34388,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42616,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11060,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90605,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69714,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 220324,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1069799,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 85186,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63895,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54543,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118402,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 26691,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82516,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 26042,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88167,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57592,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78538,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67582,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5282,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62512,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 376760,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 831978,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 76353,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55671,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 416571,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73019,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92330,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 95450,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136147,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138004,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61627,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 77536,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7983,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 89385,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66189,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 131232,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126828,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5877,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73884,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55685,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 319925,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1062939,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 156788,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14210,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297136,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 109268,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82789,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 591160,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 164156,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1138154,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 38635,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 116591,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92713,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20366,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24323,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83559,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 54623,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313182,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62720,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 511453,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5418,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39542,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161235,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 450351,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12342,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 43195,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 90645,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 68195,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70225,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4534,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 399470,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 482850,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 151982,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 511072,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 295853,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 593254,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29417,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 200962,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90436,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79385,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 621145,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68048,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 693171,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 50843,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7867,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5562,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54877,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132206,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79389,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83263,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8573,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76060,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 105797,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 102463,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97239,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10299,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 193395,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 215617,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 514627,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69633,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258918,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92197,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82727,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70861,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1029254,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60100,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 49274,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74906,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62893,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 556203,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 575862,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 83809,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37668,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7655,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 207899,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55659,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115416,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54540,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 38770,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 341167,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 821909,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 60671,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6319,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60549,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79138,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90904,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65456,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 188092,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79665,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278862,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 851223,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 44074,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5044,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 41749,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 472052,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108035,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69409,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55527,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6073,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 234735,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 379114,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16163,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142286,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1033062,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 264686,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8342,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11830,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44077,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 22860,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61623,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 21979,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96054,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73849,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75728,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14629,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5804,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56697,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1227990,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 43828,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22727,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44134,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3019,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54957,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10545,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 195491,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 56311,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 181656,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18930,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72872,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 72120,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 67679,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 106060,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70949,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57679,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 10835,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97469,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 509204,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 24181,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69813,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66540,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7268,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 265078,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22148,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6261,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81942,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 383889,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5736,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5728,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 340931,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281772,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 623253,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99054,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 50913,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110733,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40424,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98571,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67429,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67411,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9247,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 166100,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 204977,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73893,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20200,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11095,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59159,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9379,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42961,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4530,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 217109,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59599,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 93040,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91361,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270131,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 203583,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73523,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36754,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 612650,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 672416,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 388206,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 58765,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80980,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115142,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 656897,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56215,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64268,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101871,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 71375,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161055,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95597,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15601,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93508,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40683,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 177236,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62660,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6063,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117431,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 924397,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14912,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17278,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6491,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 49847,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66641,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57561,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64816,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 159475,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56872,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6392,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 323084,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282587,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42793,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61829,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 84617,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55532,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 775716,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64374,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8077,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71746,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 77012,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38351,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4896,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40130,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 62223,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 221271,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 136296,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93497,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324014,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57382,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 56659,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 438645,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258352,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 46837,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 320104,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18839,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7011,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 656237,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13639,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121369,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 184778,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 317491,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15761,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 467900,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1186442,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98465,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30443,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82020,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5295,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 359828,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57251,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 56730,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18663,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 742772,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66223,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75783,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79475,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23149,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 185501,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9892,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115624,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64253,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6378,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 72420,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38565,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 58524,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 509448,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 331075,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 113900,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 190966,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6678,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 22966,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93366,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 398087,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16944,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 130311,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55885,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65054,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72521,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 71389,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 81038,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5554,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99910,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 127363,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20492,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44360,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 104333,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268994,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74025,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6513,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 25776,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10771,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 170152,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 55824,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74582,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41419,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78732,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64101,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 25355,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94364,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62404,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 67766,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 864086,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80372,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58554,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18743,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82360,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5938,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82259,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1711396,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 342827,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57840,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27513,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77377,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55472,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 193678,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93648,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 556549,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74101,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58172,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 33156,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289073,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 32213,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 223123,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9361,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76184,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 193083,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60460,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1533613,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 132588,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 180304,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6587,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 90833,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 959144,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7724,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94686,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5166,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102004,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 239747,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61431,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 65831,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292733,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 246606,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 344433,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1535015,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 136278,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15314,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15529,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93459,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 191362,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300096,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96341,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104484,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6448,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91036,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77591,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93333,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9773,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63999,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 315139,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 87355,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92727,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18715,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 58005,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 28642,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269686,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 666691,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 199931,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 208855,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4816,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 383031,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26705,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68895,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40198,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89465,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59868,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 92209,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7703,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 200868,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 916307,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59835,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38560,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58378,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73571,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125293,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 59723,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56436,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87966,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54809,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278174,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5459,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 96223,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42431,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 228174,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68345,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92384,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 38490,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 267733,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115463,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 689402,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6927,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119003,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71226,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82368,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 35137,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18983,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 214740,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43537,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 78324,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68543,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 305489,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7617,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 384418,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65788,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64871,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63562,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59990,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72510,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106501,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57061,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13015,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 743689,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6699,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6100,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 76267,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106736,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27544,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 132810,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57351,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 489499,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4703,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 109829,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 710121,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 980628,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57008,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64637,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 331216,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138169,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117334,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24931,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 475311,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76881,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18206,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67428,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139712,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9232,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8012,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12280,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55101,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101856,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 637143,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128270,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 77399,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56469,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5490,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6021,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70458,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95400,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306030,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62369,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 429564,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125189,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 233333,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7036,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 71245,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 317991,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 80747,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70035,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61543,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 340579,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5231,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54532,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59465,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5100,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18961,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 144199,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 383236,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59839,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 149678,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165478,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115412,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83855,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 131288,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135040,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 92134,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59351,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76017,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126706,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82531,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 343272,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105031,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 319533,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8783,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69932,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 48506,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117171,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8868,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324373,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1252692,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84292,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55644,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78782,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6425,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42452,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100054,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74760,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57425,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100680,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41052,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96946,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1457655,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 264378,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293103,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111714,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101484,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58457,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34862,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 789154,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 197776,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 631377,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20522,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132816,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66837,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 100395,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59813,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 642585,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8865,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 191142,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6160,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23219,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61408,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 95452,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261824,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14128,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7455,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59963,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67929,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8933,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 139139,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56586,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 996164,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 25366,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68881,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 319554,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10412,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 84530,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58305,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 30874,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86655,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120879,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 51480,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58812,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 633811,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4644,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71178,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55433,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21838,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15855,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 124744,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80163,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257973,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 268093,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64385,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 26443,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5280,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 69504,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8459,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90594,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 24798,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 583106,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 45139,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 137312,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328551,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 187835,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42870,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 889631,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88040,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65354,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 32772,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136194,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4561,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77645,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80477,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14915,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5333,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277761,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 39108,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 72416,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 358977,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1148780,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1436620,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4777,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 225949,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19349,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16935,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55954,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4506,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115768,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60436,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 53512,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271008,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 918591,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 163563,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 836079,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 79782,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 879301,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58240,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74863,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 555852,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 41229,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57613,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57717,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67022,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21632,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76149,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 696490,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109425,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131749,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63791,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131415,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5108,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 100399,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 599303,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55293,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 209674,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 42475,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86286,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 728051,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69134,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 199109,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18405,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 35899,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17286,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 46560,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97136,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37736,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80917,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 184280,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5195,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109593,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 154254,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 157911,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320296,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10123,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43501,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83842,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 262866,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65770,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14725,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6267,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61415,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90471,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 155813,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 188181,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103942,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 408019,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88332,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56406,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8443,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73994,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5898,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 148509,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20703,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 207338,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91790,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63886,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7763,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 64806,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 145736,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6876,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98939,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80517,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 230569,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 457571,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142388,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49807,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55907,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100980,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5692,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1610605,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71966,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6870,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9624,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9432,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55651,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 53659,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5143,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 56704,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93068,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39403,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27904,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 26878,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59443,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 376421,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61235,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284751,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38958,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94129,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77215,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1001126,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7861,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57990,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 35890,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 53927,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138228,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307427,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8122,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10225,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65414,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101446,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77488,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67016,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62305,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10761,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7987,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 177747,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7853,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101798,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39743,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60432,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80019,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 537770,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 41239,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 235857,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 89540,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1037550,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 580745,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 166938,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 435594,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142909,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70724,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 925267,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37332,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34165,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 232968,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18445,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55547,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 61577,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72624,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84691,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56576,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 489760,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74733,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5227,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66698,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57931,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 198564,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20044,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95368,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 372200,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 327423,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 207160,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 75811,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 141342,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 124793,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 225510,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284527,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4533,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5073,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7472,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99403,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57594,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 142697,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18814,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 56384,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 140924,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 61429,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74834,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 202824,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10469,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 568677,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14601,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255115,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21879,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102738,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39895,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 423695,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39125,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23469,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 19016,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81117,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39433,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278086,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38595,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97076,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86928,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 133559,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57342,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78064,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76514,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117573,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30547,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12314,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9492,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 264066,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70345,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88299,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11131,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60900,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 357435,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324702,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80260,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54998,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25699,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7992,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27805,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 687649,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69100,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18500,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 417594,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 84620,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5800,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67841,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8572,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82227,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21362,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 141290,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 487845,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 863858,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91460,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63513,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68815,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71266,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 143436,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85409,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55013,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 40674,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96370,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80336,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 26921,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43764,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75580,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55496,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 27617,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59970,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38351,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 198637,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 264053,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86765,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78715,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63556,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82452,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75057,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59317,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 96486,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60875,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 194551,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8613,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4982,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89929,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 98091,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58299,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76882,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4701,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 358077,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 739370,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70735,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7859,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 198378,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61182,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5190,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 645943,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7214,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273529,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 35301,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 220962,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 130234,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 632855,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 32452,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10361,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15720,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6078,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 116951,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23707,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 790988,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70881,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 396142,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60659,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 27691,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5928,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14525,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44387,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 164529,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37669,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44217,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105716,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8836,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9250,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6349,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55106,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 228617,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63252,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296665,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71695,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 214006,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111871,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 573578,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24089,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82951,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84546,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 481866,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 202977,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 108194,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23445,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 370556,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1137270,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4954,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68940,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130399,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 29131,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 86102,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 80219,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58778,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18399,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 299886,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 32237,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 187315,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 644647,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 136390,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8234,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60296,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52523,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281312,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138918,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6082,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86751,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43843,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 708352,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54511,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 482788,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71227,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 735633,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 13215,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313452,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13734,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42184,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 115096,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 326250,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4527,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 83092,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 208484,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 71360,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 31710,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75771,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139203,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101284,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17366,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7024,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16812,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55667,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 198333,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15787,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 113419,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85575,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10838,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12793,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89368,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67511,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121300,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86660,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49716,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19720,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84102,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59210,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64334,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108002,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75965,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80863,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5243,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 597777,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 124291,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83885,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73636,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10948,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85390,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318816,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60051,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19108,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1307465,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55157,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63390,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283032,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 301517,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 91062,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112798,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131353,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90307,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68724,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37018,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 140771,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105908,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 35337,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66562,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 206623,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36422,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 97935,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56917,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 144434,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 879455,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 455624,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13153,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1212220,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69937,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20904,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 29219,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12315,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263691,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55317,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6787,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2921,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 429135,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61665,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1010293,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70874,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127575,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5196,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13356,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89812,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60806,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76442,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7901,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 138870,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 864040,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 839310,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 375307,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54502,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64949,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73077,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 543611,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40657,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77680,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 445442,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65426,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18178,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31614,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105502,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11007,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5035,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69769,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101174,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255677,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 414630,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1501196,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12496,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58573,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79658,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 187475,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 836729,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6438,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67368,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5796,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52436,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75147,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 316028,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59527,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 188934,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 31229,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 18303,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7657,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 102349,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 608308,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63562,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 103811,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 460362,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 145697,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30522,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 810312,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 136810,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112691,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59005,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 502911,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17429,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10309,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257462,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76330,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88808,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92979,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55292,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74986,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272070,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 717823,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1034436,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6415,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 250905,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139629,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292023,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88358,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56227,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 317897,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9533,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63517,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281192,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89242,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 848645,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119471,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64230,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 102751,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62094,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18219,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62036,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64551,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40885,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58687,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90092,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6557,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118716,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38778,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54994,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 60775,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55322,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 112395,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105447,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91454,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124753,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5136,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39872,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108258,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60499,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 29124,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115652,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87195,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 294110,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84145,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 56826,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6764,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8455,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65849,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89548,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 238983,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125223,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 154696,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108900,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 208514,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7203,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5379,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 27068,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71207,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1287992,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92185,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38113,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80284,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57935,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 670210,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67672,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 35287,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56786,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58406,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14557,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54680,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 81915,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 174686,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 881484,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 716048,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83199,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7932,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81111,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 815059,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27192,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60616,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77916,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14247,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 209284,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43565,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321783,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9585,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108765,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62580,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75386,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65205,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 242527,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55864,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56497,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5766,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66945,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5031,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96534,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59037,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92019,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66135,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 26456,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5394,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6872,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133958,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296397,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82734,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76641,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9185,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136631,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11790,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63375,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1061452,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 370982,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 88135,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5194,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 698025,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97789,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6208,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 28306,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4717,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69875,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15764,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 632500,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72921,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18488,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111420,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 140311,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56207,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4871,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108054,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 587522,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 396305,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9452,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11087,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306365,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6687,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 246735,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 319487,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142227,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 886657,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41467,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29926,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20250,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 53491,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 92903,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127908,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35521,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72510,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 102666,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 28479,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 896487,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41817,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 338476,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97449,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57021,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9516,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 34580,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82158,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6250,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 50288,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7285,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 606928,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 91306,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44146,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 38666,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62643,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80782,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1187023,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102938,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115615,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 27928,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58634,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41428,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 32901,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101075,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80368,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 32463,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6811,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321154,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 169530,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15630,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38374,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112142,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 162369,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41161,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27255,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22637,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 409543,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60432,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 299836,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1011848,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85342,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137565,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 810260,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7337,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56180,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 703932,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 381560,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63441,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18647,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 573598,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65084,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75536,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64166,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 168781,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1019994,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64466,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 159313,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17937,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73244,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 109351,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 26479,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 25442,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5190,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 21121,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1018607,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 21248,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 29057,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77300,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 418025,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 175471,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318975,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123542,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63830,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 358291,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43962,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78884,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4811,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85868,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28627,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 238785,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 583207,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 169159,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 417006,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 719335,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 132223,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96506,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30257,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55192,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62425,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86285,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58334,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20851,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300818,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62539,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107568,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8754,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114262,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31821,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1265777,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107926,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 66528,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6241,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 292638,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 156792,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1566601,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95338,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36570,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58307,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 171308,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 485380,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72730,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 358783,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 177856,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74469,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10264,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57845,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72368,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85347,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69337,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108679,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4715,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63144,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284470,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41639,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76567,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18617,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13237,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 111679,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8131,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86647,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63366,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73797,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92248,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 338158,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59281,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 105892,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 388310,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5701,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 213005,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42835,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2749,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 215543,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 34514,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71190,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5580,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 96520,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103024,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57736,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70285,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 100404,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 24845,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 500091,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 918398,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 163770,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 3342123,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75733,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 72573,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97833,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 535988,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 343387,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 97522,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 411720,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 156697,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9227,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99070,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 349022,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 36859,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 74045,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 47452,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55360,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 227892,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 621726,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6807,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1678755,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 155844,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90677,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44156,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 103780,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 58886,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285357,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63579,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91739,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 743297,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42079,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 66013,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76831,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7467,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71948,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 39930,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111549,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60961,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10732,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55976,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87827,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9725,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73636,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 542042,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 192841,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5212,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 68435,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79303,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77541,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 267014,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 333160,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6896,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313785,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24162,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24159,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 214015,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 57355,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271850,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16691,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 144276,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 357064,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123077,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 98015,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8603,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9167,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 168950,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100775,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21916,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 164144,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42966,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64613,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307343,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 29378,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39548,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74782,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23318,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80698,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55911,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 385048,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123695,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 295095,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61324,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 96140,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6847,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69536,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 72475,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62394,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 388796,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 37141,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255784,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 644734,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1002268,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 91804,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68554,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83247,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 32871,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65696,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10250,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10616,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 891095,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70189,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 32614,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30083,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 65245,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 345922,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21702,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1137090,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284425,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56403,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7461,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143089,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56440,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 139213,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4969,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 742251,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61907,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 80115,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 97085,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 14964,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 13695,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 196880,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 330453,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300388,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 266608,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 2753,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261529,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98828,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 571029,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107673,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 473572,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 383432,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16427,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57138,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87155,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 203960,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73654,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75771,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7335,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128748,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 157419,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 805160,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 170741,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 212178,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55689,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 378385,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301265,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 581199,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 369458,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 412748,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 308067,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54553,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88406,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69500,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 539911,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23608,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 48710,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 740865,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135024,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 36318,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300691,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 35639,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 96703,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 27626,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 29703,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67097,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94522,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82543,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128672,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 62551,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 599059,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17999,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 93311,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101705,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78451,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73198,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62066,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301137,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7522,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 62871,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 149531,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 27596,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9484,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 141507,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 386883,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70987,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 619108,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9166,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54569,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8743,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 195366,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7469,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10235,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6640,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19993,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 264132,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7550,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 815294,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19398,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60583,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89534,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23373,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 66630,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 372325,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269789,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12240,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55336,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57143,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 130661,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54733,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5251,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72175,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7849,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86758,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 113063,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76132,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 78317,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 44256,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41564,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261363,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 131934,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43931,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273490,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 107565,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57201,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 228650,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5683,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79393,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107787,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9160,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54632,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11008,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73315,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 112773,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 95118,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63138,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 889001,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27405,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38931,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66208,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5437,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77651,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 209309,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 142611,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84263,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88065,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83700,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 797410,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 375139,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 92615,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12892,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 22962,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 253976,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 139938,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 137341,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 48364,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 111401,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7384,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61099,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19743,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75804,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1022605,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55136,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 490326,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58887,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100064,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 820636,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73305,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 186707,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44082,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59530,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58394,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 97869,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74166,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21146,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54928,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 89039,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 25788,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113045,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91582,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10481,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57616,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 140832,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83369,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 823323,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 675863,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 419610,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109627,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 22283,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19683,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56227,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296380,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 51814,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67992,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 319235,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 101652,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109322,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8806,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 163993,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 455145,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72424,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30724,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 646018,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 892172,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 43322,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 314889,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9390,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 91972,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82826,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30392,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23378,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267075,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 38837,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12772,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84946,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9876,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 123312,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 658557,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56750,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86278,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58320,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 622890,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 22788,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 39761,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 825324,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 103510,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 141219,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 167539,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74491,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 465325,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 72507,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85363,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70803,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62600,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7908,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126041,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4817,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6410,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6636,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 45976,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132355,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3572,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 317508,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70325,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 155428,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 169111,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 93599,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269816,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 117548,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 536262,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1006241,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79648,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 799803,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 164588,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80402,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84615,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 964559,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 212151,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42626,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 98285,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63518,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78199,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4455,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21152,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24663,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64270,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 34422,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 209779,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 33391,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81038,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 793392,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12358,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23505,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 38144,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5885,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24505,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89300,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6336,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95518,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302491,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1158200,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63936,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20203,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73104,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 775617,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10159,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12388,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79301,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7009,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58843,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16825,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 88626,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12195,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89608,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73725,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135033,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 757997,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256318,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 116065,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73607,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77459,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 195585,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3189,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15885,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59500,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69072,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75585,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289700,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 125111,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65870,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 646003,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 29533,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8214,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74986,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 107681,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5291,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 98042,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6853,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1077734,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83863,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66698,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6650,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 47234,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 19680,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58632,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21882,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55902,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 34668,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62067,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65394,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6738,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9596,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 218521,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52723,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54929,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 168056,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64082,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70828,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 144883,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21119,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 832426,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132701,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 127248,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288415,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72539,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79824,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20856,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5717,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 415260,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91880,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15721,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18405,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122290,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 515310,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66939,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30022,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5060,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312263,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136506,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 19990,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79392,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70665,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 308251,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38949,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66589,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62854,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 639757,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57400,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 202781,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 237597,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67458,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70853,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58540,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 507479,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 266461,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 203693,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84774,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7172,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66342,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 47157,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6566,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70798,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 128646,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58998,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 136830,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105292,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54097,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 586985,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5471,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134445,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 187408,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109900,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 475931,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97787,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 795690,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 200596,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 158138,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42653,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58162,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56894,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68516,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37655,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 884423,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 675290,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68677,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16839,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 28177,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64645,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 78164,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 29767,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6777,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55749,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81207,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9804,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 782638,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285155,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5035,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 221281,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13608,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62702,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 31580,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10081,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 116003,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64834,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17996,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93246,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74084,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137500,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7374,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127244,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1297524,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 989207,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131108,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21399,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58096,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290592,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10833,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42709,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1021466,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 242348,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 112151,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76592,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96247,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12528,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57403,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69453,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9227,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84777,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 58633,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 223920,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11266,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86280,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67227,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 116654,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 646682,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40040,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302703,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119186,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10840,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277663,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 26755,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300417,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123675,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 592192,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78836,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60334,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44344,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5274,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18494,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73127,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56369,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97329,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 208150,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282118,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 402006,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5089,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 681689,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81433,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 234101,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 50299,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62437,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17986,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6900,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7805,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5591,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85426,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40003,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54929,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 363969,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 230202,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16184,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8009,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 35943,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 19729,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81129,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58441,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 555732,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 143264,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66793,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59264,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78707,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114194,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142878,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12739,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110181,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59915,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 95337,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12408,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90006,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9318,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37164,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121670,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 704812,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58935,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 317444,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6655,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 174431,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 197893,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99844,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 186800,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60977,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78655,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6492,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11977,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 22805,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16218,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63427,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94496,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 488825,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134568,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38182,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8350,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312220,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34667,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6307,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 189476,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 408362,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7215,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69734,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165569,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98814,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59469,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74334,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85137,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 471256,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73173,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55920,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 483148,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 130063,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4939,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 222421,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29160,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40372,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 95827,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82673,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 154217,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20321,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80134,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37237,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 20662,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290643,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83291,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138275,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 93008,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55323,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103681,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7484,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110848,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85500,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61829,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41952,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6734,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 343789,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 395075,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 317941,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95378,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 818121,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 209674,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 497980,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59114,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 126650,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41782,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113628,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77937,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88511,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27201,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 80603,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310881,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10758,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67729,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89528,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60519,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82844,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67513,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 478180,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54854,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1414114,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74428,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10348,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 25922,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 74369,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 154999,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6864,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135241,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40429,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9435,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271044,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83982,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67473,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81917,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142617,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 199395,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55999,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40770,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71116,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59237,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1562208,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13515,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1034711,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267429,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94865,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10753,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 129666,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42232,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127473,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 24085,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 106003,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 156819,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 341734,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80628,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 556189,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 263967,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61988,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 106466,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1612989,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 174698,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6721,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5810,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77569,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71179,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5261,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 239161,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60831,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94225,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 35209,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255577,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 690628,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6868,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79852,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100017,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 129275,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6686,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104954,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 146319,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6712,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1072631,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13503,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311431,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9551,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60155,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 329154,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10087,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58729,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74057,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 265289,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100737,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 488463,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 26325,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66588,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77656,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7253,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58079,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 12059,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14755,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58403,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1091039,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292870,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33917,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 359677,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 808710,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55064,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40689,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 112309,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31095,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9550,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 830766,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89519,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1407908,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 217648,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56558,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85856,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87592,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1492365,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 74688,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43867,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 181862,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 331280,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37283,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3204,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 172488,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 411927,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263977,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5631,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 730851,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83886,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 112784,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104238,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 95451,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57901,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 32158,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57999,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57361,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22706,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 720358,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91323,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 187491,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4736,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60907,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 755051,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6919,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19639,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56711,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121991,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122871,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 34284,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1070248,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69447,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75535,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 28864,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64480,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58554,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21362,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 76399,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65367,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30914,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 132155,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7862,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 658299,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92663,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1147727,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66227,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 295589,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68584,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 113492,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 154835,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35383,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 186542,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 621401,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71880,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99829,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269747,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1040343,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91939,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55958,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63057,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 332149,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76520,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21206,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85940,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56721,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 747580,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6505,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111004,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108365,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 157776,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 698669,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15979,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5435,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 37117,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93935,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68907,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10800,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8245,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275178,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 164359,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 197494,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89887,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9597,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 168896,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82721,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 182716,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92933,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 315473,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8250,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1104925,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 782097,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6481,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30352,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 11322,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98995,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4880,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8753,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 330273,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4469,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65460,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 394650,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55565,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 18632,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12144,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 29795,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 72402,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 83695,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36151,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33832,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5372,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99248,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82899,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18051,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1133605,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 185062,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10304,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55125,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19783,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59833,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85808,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61789,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 116094,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 29470,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96483,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59401,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6617,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290730,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63483,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79596,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6875,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8768,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 187936,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59014,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 493578,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 261100,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76604,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 143385,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6538,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6358,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63815,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 47523,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 94452,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78579,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87353,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30122,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120443,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63229,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116453,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58985,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36289,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92366,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83252,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60398,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 102585,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 220610,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 177898,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68903,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74177,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96361,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118681,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 679529,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12691,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 135012,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1027638,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 311565,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 773223,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277772,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70637,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 317963,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91011,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 26412,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93759,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56661,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62675,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126251,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70739,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6519,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104045,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57600,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 54993,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 62738,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 589084,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38116,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6759,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 266334,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1326128,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41802,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 91658,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 122292,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56729,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84486,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1204659,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57042,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8876,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 221769,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 386008,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 94201,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82465,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8925,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 120302,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20188,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101258,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101229,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 27271,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270938,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7349,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 215904,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42787,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41745,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 361205,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 52860,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 134761,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42935,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 486466,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44064,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86693,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 124530,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36106,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88484,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59010,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 20893,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 52674,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8709,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 543723,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100003,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 659283,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 26449,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270183,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57510,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73054,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69342,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302649,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276453,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60217,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90089,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109314,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 158856,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 512317,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64907,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 667571,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 254605,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1002117,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 76403,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 750405,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76722,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124085,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 668898,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92879,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1009302,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 106218,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126149,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98868,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84420,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38106,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56598,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125374,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 156191,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 180672,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44815,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 38076,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30042,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84108,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65088,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98599,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 397039,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 28504,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21972,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33823,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27216,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 83805,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4300,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18950,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79555,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90742,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3324,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55788,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 337194,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56140,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8601,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74077,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81935,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9618,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82249,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39733,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57550,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69995,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 75753,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 20311,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25263,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16240,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23860,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59176,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23544,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320079,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 670844,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59617,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 121341,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91468,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91716,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58345,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111571,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88011,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 295608,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7323,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289597,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4847,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30518,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54680,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59438,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16363,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63560,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12823,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85926,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62445,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116415,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 193261,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37426,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 22572,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7263,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56777,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68247,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 85598,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5008,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8345,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 574990,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 97684,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 280122,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161522,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35218,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71073,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60091,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14445,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15976,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65609,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 30795,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5165,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 338679,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 29121,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55784,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 308323,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 40594,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57737,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42187,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15754,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5098,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 761298,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 717961,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 672894,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54827,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 352641,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39032,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18972,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18675,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81393,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 171347,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101163,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7072,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56997,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 217671,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 417948,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10626,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 423904,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56853,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3943,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 319990,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57881,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90326,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65918,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 499617,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 247360,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 48139,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104555,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5094,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 22485,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110909,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4954,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110939,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7263,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3980,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83949,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70814,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 41720,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43609,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 75686,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93686,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5935,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39097,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 244622,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 214528,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73648,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283595,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 123049,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 670923,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85345,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55856,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106642,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38539,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63850,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96464,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77114,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 172197,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35604,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304989,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58086,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24389,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 51987,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55383,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76843,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 24472,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36560,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68619,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89108,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54606,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30769,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 137740,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9065,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 162968,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67484,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 542448,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120589,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6462,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 35327,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 504127,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12838,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101087,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41869,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7748,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 129922,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 20234,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70075,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 212891,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62758,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 37913,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 175389,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 93259,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 84147,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66470,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55662,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 76728,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111842,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 214963,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67599,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 99059,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311693,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7341,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78974,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 72193,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13763,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 712420,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56578,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7050,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57778,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7943,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 364031,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98787,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 87887,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99229,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84075,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63763,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6334,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 257379,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112027,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70813,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 34595,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 35868,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 209875,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9628,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 233261,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58413,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30593,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289061,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55127,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 130239,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41458,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1015109,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 135818,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 212093,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136071,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79407,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 57073,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 122249,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 26872,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 42565,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 35510,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 132471,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77665,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165956,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 400406,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11395,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 134290,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263351,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104295,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 143080,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58073,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165801,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 124656,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73825,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81457,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 293013,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 175088,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21523,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95714,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 167100,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87329,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57099,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 29597,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36717,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37204,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263826,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161676,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293493,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275770,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 26409,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 337770,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 208620,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1203839,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56194,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10801,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 123532,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64228,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59985,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5500,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142252,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 73875,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 611354,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41172,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 664204,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4407,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73722,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 30657,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 67894,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 129887,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37693,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110325,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 21593,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54686,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40649,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84826,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83092,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 142145,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57545,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 51528,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281843,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 253061,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 141124,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14120,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101308,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6230,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54657,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65137,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63675,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 131927,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 175668,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125151,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86312,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 43516,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 404266,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 706755,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 44168,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 28190,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 313099,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73663,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96985,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 73309,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 254996,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81078,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 693041,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1615433,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 174172,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68794,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10184,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 71217,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77623,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 102973,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 65182,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18933,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 19601,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 114547,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256703,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90820,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 901923,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62672,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1327850,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7179,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 86258,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86098,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9528,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 294095,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55259,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64271,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 14355,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99848,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 88818,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6963,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 725368,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8461,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90558,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 362461,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8427,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66599,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40999,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 176369,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111185,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 88708,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57081,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 538590,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108241,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18176,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68976,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 52756,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 333053,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61267,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114819,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 684671,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1089799,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31827,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 176420,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 711150,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58264,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 370796,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65275,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75118,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12481,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118506,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 410288,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 96902,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12459,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76059,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 100936,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21248,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 635460,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27212,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62804,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 196314,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 296590,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 78355,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 460051,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5892,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 363698,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37646,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70083,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10820,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13510,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77783,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 131460,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56034,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 72922,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 132952,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39044,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 140421,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66712,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70088,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284009,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6035,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17394,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 404365,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 758720,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99721,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63649,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 81488,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56775,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 597709,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6826,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 544410,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71241,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5693,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7609,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73394,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5256,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 162203,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37115,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30567,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 33212,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 58793,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98163,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 663310,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 743636,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61902,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 94482,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 148394,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 216375,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90055,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77142,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58566,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 104247,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 135429,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13845,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6093,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61282,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76549,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 121098,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275310,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 200861,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23542,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6794,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69266,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8565,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91915,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 86750,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255992,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 159217,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71230,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 45104,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70484,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63945,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43045,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69491,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42486,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16415,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80114,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56909,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84765,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55377,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 22996,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 247533,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289633,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1067712,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 130860,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78939,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 234373,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4581,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124548,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63816,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71839,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 27401,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97960,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10413,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59967,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42680,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 232593,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14438,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 526362,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 43839,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7030,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60749,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 865673,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82029,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71311,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 90289,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 124265,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 52516,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59729,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89885,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161199,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13026,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10312,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 103941,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57414,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 5674,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56385,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6449,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6386,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 23488,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84848,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307558,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 225364,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5008,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56412,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118553,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 51863,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275290,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63819,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 271143,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107017,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59298,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 899543,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69909,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 75448,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 697034,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24277,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94673,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72863,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55979,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13395,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95533,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105703,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10600,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121207,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 39643,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 316473,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84395,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 255390,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 72909,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 222006,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69281,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 19813,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8016,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 72840,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57677,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 149863,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43439,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54637,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 594421,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 361512,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 115196,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1472985,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65440,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 40726,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 26424,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 137486,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6928,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7126,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80719,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4857,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98404,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 61415,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10773,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12663,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 47595,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 186874,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58276,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 265937,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260769,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6979,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7613,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86714,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37019,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3702,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116735,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 28903,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289646,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7123,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 13225,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5975,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42598,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 26296,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 126292,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5806,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10391,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64449,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6862,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 767924,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63548,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72794,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57001,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 139703,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 141565,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 108301,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 187520,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 209887,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 475328,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 180272,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135141,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64113,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18465,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54617,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10037,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94825,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 219953,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62828,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62550,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69813,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 132212,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 40243,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5627,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17513,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 237271,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62963,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 652024,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67968,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9603,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101223,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 58355,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84706,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6436,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57528,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97050,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41971,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 869118,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5051,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54839,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128224,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9943,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59069,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104295,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 715201,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 668465,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 108083,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61259,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55677,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111390,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 208179,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38293,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 53738,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 325316,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10192,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12141,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313496,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 404339,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 211559,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78478,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 581766,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6763,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306043,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57151,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 206926,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1481275,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 137756,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82485,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66538,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60823,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2635,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19612,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 147840,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 172660,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54694,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70258,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1017877,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 16349,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 27846,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 53850,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5184,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129466,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 149203,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273162,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 151891,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 20384,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 70038,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43505,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 198574,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 105300,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8746,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69483,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82485,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34399,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 100753,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 33926,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 502862,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 182981,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73534,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3577,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115741,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 97421,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7591,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10181,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291168,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10606,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 44286,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 120626,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43420,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 234785,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 858756,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7959,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134677,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73679,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 173979,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73786,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 538198,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300200,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 72736,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59093,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 111398,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36321,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 740120,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77911,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95226,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 207960,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 120781,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 42440,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62611,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 53476,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16011,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 44320,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91703,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304085,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68408,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6478,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4987,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55258,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 42189,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101937,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63020,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71083,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 74560,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 37310,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 419883,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 94684,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87559,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 65625,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58161,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 76703,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 190460,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74728,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59395,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6530,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19426,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93844,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 178734,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77135,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42860,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 23930,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57229,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82251,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161920,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280617,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8059,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 429298,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 191089,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 272842,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 123912,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1051800,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38371,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8018,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 400064,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 75766,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55866,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61336,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44071,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69130,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 51459,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55336,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37048,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282747,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 190562,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89930,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12572,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 51434,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21665,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54129,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 149181,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4838,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19911,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 930818,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 181043,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 949122,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110955,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77591,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36152,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 640611,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57591,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75199,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 584046,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4801,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117942,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84606,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10024,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 27960,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62080,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 473943,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62086,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 258260,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293909,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68480,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81749,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96159,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99411,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5058,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10354,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 69086,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 519043,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 597643,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70206,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42579,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105110,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 225699,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82719,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137926,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 952080,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70872,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58500,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 187119,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54717,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76266,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82226,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60403,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19813,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 98695,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 536549,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136305,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54836,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 164255,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61595,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6912,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35704,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 210457,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56808,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288972,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 133629,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 35269,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137796,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3616,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39960,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57455,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 10539,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 572769,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41359,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16832,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107904,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20315,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 58060,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80711,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70559,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63580,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56699,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10435,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87258,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57500,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115268,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63531,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 469334,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60025,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5081,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 108190,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78312,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75587,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 175783,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66103,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 741689,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17643,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 401514,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8106,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77517,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9354,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 331016,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12921,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7058,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 886146,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 56272,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 174151,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95633,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35738,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98349,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 54109,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 733076,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1060784,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72836,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 131807,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58685,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79582,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 871457,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7199,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 176127,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56781,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4649,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 979712,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 114080,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101627,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 32933,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102371,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58673,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73971,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120636,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5314,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 490480,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6534,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129856,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 373256,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103461,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 136727,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 445578,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 146501,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83123,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103807,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 18824,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 139131,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60655,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9339,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11887,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 454550,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15602,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 81650,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55945,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9683,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 22184,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5374,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 50703,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 39324,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 629517,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71425,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296755,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61885,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 133233,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2651,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33085,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59605,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 52966,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57555,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54101,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27519,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 84480,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73854,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61758,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14431,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 51816,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 94845,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 156694,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15391,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 81675,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 338279,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5097,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126376,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 60714,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 271849,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61640,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 56751,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76091,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 906892,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86610,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20036,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 57635,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 175287,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55808,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14651,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 95369,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 108486,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106798,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 183588,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81720,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 20099,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5517,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 680448,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66798,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 64620,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27403,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82288,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43052,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55562,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63352,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6447,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 91600,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3038,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102305,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 112806,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 31336,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97749,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5397,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 202536,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78750,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30259,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8293,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91848,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8538,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55702,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56669,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9047,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7615,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93779,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 31914,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99790,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 35800,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109666,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6425,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72735,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61105,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59529,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29758,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56498,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39951,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55666,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10745,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 155903,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80720,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 409822,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64410,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 170798,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79515,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 82528,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 75218,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 118724,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40036,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 63139,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64873,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44676,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80707,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291370,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6782,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279201,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85224,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57695,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 143802,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56389,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 339929,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278881,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21670,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 142124,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 514430,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99847,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 200934,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12250,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 36747,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57630,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 84713,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 113201,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1377954,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68756,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312681,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7311,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62659,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 142953,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70643,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21142,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60740,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18577,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 630481,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 133485,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90851,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68853,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 43312,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72807,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 299894,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321525,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49728,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 184351,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90289,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5029,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 129227,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112072,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94959,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135707,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 159665,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127002,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64806,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93860,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62118,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73249,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9365,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 206647,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50570,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9172,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 102009,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4570,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40018,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58909,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37686,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83756,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 423427,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55070,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 177514,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 50736,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58361,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65022,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88125,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 140051,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81284,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 303958,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 18383,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 359365,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 408545,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123893,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 652448,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 250484,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 115412,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6681,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 843862,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 203238,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 54945,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 173008,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10123,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16482,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 25495,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 190151,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 365033,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85922,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12018,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79535,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 209099,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14663,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9255,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55079,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 28898,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 46296,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91193,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 390148,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 97377,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89991,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10239,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 208236,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106383,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 353929,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 254635,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58909,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 190520,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19408,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 33469,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56491,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38022,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 119455,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58304,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301007,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 86879,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 250476,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58459,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77824,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87364,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79144,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70663,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128102,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54866,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91682,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98130,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310795,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 575748,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5526,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118290,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 194324,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38428,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 131558,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 198986,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 764858,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 954681,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 847148,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 745080,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55430,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4816,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111871,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 221425,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 364951,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20855,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 27090,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78886,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324254,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 72144,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 104849,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291712,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58596,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1018923,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65181,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70846,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 89718,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7272,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4176,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22496,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318804,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25666,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 113407,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89391,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71960,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 282047,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75904,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 56604,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 301978,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66877,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66316,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75006,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66977,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12114,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9852,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 80317,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7810,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40832,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 319327,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94352,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94159,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29851,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 43417,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 939367,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 417209,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 77519,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 79607,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36876,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67090,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 288345,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 137080,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9431,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300634,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21969,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69754,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1272095,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69477,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 82293,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 717356,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 196176,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 185083,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328266,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 159581,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80259,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 96628,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62436,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12571,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102630,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 39886,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 90699,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71274,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30979,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70191,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 59884,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 56221,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 974477,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 97552,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 324624,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16130,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124802,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93781,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 81607,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 64779,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 155205,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 174865,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60015,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103182,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 334543,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 898400,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 322152,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310379,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57331,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 94066,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73927,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42388,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9626,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62187,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 120580,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15361,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38725,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 47474,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 133859,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62199,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 566079,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 406089,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 56596,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 19175,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55100,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74573,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 15465,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 37480,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101595,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30402,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66946,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 276990,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 106896,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61662,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1192420,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61247,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 17342,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 951576,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1334874,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7968,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 650229,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57834,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24172,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 343826,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 106590,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5079,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8662,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 220870,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 7029,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6088,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274255,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 162899,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5184,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94181,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 59813,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70613,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94700,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67320,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99431,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63429,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 93682,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70093,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 77374,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80544,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24633,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 795759,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36895,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285389,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71038,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6066,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58165,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 4788,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1388986,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 57356,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 115813,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272375,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7654,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298486,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281947,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9787,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15592,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36387,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 81607,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 75337,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114088,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292052,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7859,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282092,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 447334,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286575,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57263,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5185,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5492,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78686,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98421,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 115246,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8262,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42427,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 174152,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 538494,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 49621,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281180,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 59549,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98303,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 101175,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118910,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85457,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70801,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80206,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8403,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 461297,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92947,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89978,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65019,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59105,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1088110,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42182,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7366,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282230,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5831,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9644,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92760,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 110330,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9349,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55565,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 25347,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36626,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105787,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107485,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7426,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36952,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 43266,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 168700,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67197,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 126766,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 41853,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 141620,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6524,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 110517,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9433,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 64135,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5251,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4279,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96329,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63473,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62399,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5484,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 32424,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 76184,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 447606,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42791,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 683186,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8247,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54719,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10625,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 166363,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99325,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 866987,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 174705,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 325076,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 93637,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9081,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85371,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15809,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 286183,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 564679,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275624,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 662909,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23353,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105150,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 81348,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8834,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34139,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60919,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10425,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8643,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21886,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 111971,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63577,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91953,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40842,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55883,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277942,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 164953,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10107,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 189042,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 38836,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8439,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62273,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8959,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263786,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 393348,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 370614,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88625,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42472,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 88691,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 53584,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59421,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96772,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268805,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 85061,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256725,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 502240,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4619,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57802,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 120920,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298873,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19887,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78224,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4510,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62081,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92707,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 110039,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114280,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65189,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 122274,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 297223,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72970,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10103,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259566,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 263962,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 337844,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107667,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 43796,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269003,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 101827,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 47987,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9807,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65255,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 295244,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 340915,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258118,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105768,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 670975,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16359,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70934,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71268,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 54901,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8408,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7671,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58416,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43573,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10129,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19190,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72200,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76549,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 676672,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55999,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98332,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21265,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60427,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 914278,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86173,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 47103,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70433,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84454,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43006,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 133621,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38297,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 284340,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27016,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54641,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5909,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15881,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108042,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60437,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 128070,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 168692,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279693,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 245109,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129761,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 749989,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 43763,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78078,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18281,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 12649,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16300,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93836,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73825,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74557,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59246,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82447,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65301,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 512582,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107946,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 701422,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55866,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 122902,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 357885,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126613,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39205,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 126180,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273119,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 710339,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65329,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5660,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 6987,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4741,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 92666,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4256,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57009,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 335770,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 44228,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165283,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60336,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16200,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56513,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5221,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66450,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 116109,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279403,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 361816,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81663,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38334,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6295,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 498014,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5602,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116093,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6764,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76018,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71905,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 42549,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 109093,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 526370,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78996,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57349,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102856,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 374847,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 99486,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 178824,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 65449,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3042,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 541309,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 674215,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86139,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 215138,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9961,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85421,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 86499,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112158,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107067,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34917,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81040,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 29715,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37478,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94594,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 135893,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 166060,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 21282,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38486,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 38372,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55776,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101225,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64282,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 70888,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 586672,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 322450,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63637,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 114154,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56419,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290745,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6513,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 109893,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128024,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1286466,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 109608,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1116232,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76786,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 100090,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36028,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61333,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77515,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11775,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91730,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10718,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31079,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87876,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 158378,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298756,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44132,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 56989,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58019,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86647,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69639,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1541048,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279209,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57240,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 576686,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57237,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 64549,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14747,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 475761,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 206455,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 24090,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122085,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 91079,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27757,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 165546,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 398832,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58128,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 22911,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281464,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 104464,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 101338,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8139,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5351,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94921,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 709448,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40031,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74687,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93551,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 926551,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42643,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 266870,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6047,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5330,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12831,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 99405,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84312,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279634,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 18886,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 306376,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 95348,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 69752,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 108049,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 689840,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 45845,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 39544,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 738551,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83334,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135437,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28288,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37709,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8498,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54818,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69741,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 43037,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283148,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 111799,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 35694,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 308475,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31698,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1001563,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 697104,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 160985,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12316,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81583,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 26750,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13064,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 569243,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 141599,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142517,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 480857,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87024,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85837,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21596,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 128662,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55039,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61504,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43411,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55598,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90438,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258625,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 93560,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 116558,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99940,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 3,
    msa: 'paris',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 274809,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59074,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 85088,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58406,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5144,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21860,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92697,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 128323,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 171047,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30478,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106994,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 509301,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 72344,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8250,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 815573,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21425,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78827,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6086,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73575,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 57795,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 34667,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272470,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23987,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25386,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37118,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100778,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 53620,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 117357,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 56932,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 316218,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 323138,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71796,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57119,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7443,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55979,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82487,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35780,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1144955,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3689,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13604,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71538,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8317,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 8016,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41375,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 635129,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107083,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 893312,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71609,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5595,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59948,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82505,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 9035,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 170793,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 273221,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21562,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 103140,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 230976,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71497,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35723,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 61417,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55455,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 341916,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 352553,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42818,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76842,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82840,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 370288,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34830,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 313448,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44346,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93011,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293013,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 108168,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58330,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15097,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 158414,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 21237,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87947,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 98765,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40530,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 831272,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 64909,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18665,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 196320,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56854,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 43270,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 110367,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 63035,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64035,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4778,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8837,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38673,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 40282,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54049,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59718,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8327,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 79985,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34635,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65716,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54972,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100272,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107476,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106548,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 157120,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5972,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41274,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 255294,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13124,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 23661,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62901,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 138210,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9656,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57350,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 83431,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 118069,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103807,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 30332,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 5,
    seniority: 'Director',
    salary: 90793,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 496897,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 410198,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15218,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81564,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 688872,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12549,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29756,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6101,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65603,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115413,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 360083,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 119985,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69811,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75366,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 124643,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5309,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17360,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8503,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14121,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58968,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 26233,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 60119,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 194818,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25524,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73999,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18083,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94926,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89959,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 98612,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 912479,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78501,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10574,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15520,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 155958,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117801,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 75597,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 947104,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75902,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85068,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 328831,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 66437,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 169406,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9916,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1097129,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 98291,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 260308,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 362146,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 187923,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42802,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 81088,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 321403,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 108440,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74349,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54993,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4959,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40252,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1454725,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 531231,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 256340,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55043,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 428159,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114660,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68940,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6627,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 384773,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83751,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6077,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 326981,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283422,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13466,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 126274,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 42175,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 456450,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 210370,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8143,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 134454,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 47339,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 410513,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16582,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42530,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138739,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 32858,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109500,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9242,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86906,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86840,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 319548,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 145859,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60918,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88759,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119257,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56542,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 47146,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1028197,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 14009,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77853,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94681,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84109,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62038,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67563,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 113097,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23536,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61599,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16381,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 80128,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71051,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69692,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4930,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5801,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 277281,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 80838,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 357205,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94298,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9078,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 78180,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 129764,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 317303,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 117137,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60736,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42558,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62183,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7003,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 103664,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82645,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15117,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60400,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 48286,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 69146,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 444312,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62476,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9144,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89594,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62449,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58899,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36073,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 4980,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56132,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 122503,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35331,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69006,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21109,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 96965,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59083,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5641,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 68251,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 84125,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280567,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 416854,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 8777,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 5802,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 112831,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 229861,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 361413,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 212553,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298412,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 299892,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 56834,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23674,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15047,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 814661,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 355557,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55437,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105607,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125924,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69602,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 125060,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 301902,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 27809,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 26273,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96259,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 108071,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 4968,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37068,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54579,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292291,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 547408,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 15530,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 58,
    msa: 'manila',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14088,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 89045,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 42315,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 189659,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 118738,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 12732,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 332837,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58729,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30077,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61278,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6110,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88637,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127982,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34917,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57915,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56329,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9838,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 75232,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123999,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66460,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 5,
    seniority: 'Director',
    salary: 175567,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59911,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 28784,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57858,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60322,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86831,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73615,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68149,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320501,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 164510,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91237,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39584,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72890,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 110305,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 29454,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107419,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 94159,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 190903,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55930,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 82806,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12700,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 663935,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 326175,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60361,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 81763,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 159993,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11413,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 333728,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9706,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128410,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1076480,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67070,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 95077,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 131310,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 204937,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 141692,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82580,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65632,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 585546,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 179290,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 198666,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5321,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 358956,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36127,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 336689,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142987,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60025,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 198514,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56334,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38518,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60247,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7569,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5914,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93642,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 237406,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55718,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83534,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 290018,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 91720,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 709541,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56988,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 204679,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 21846,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72118,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270805,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279099,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65085,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 73918,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19690,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23056,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 13528,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79244,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 24815,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1134912,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 44129,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 122111,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272394,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75822,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59545,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127019,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300015,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 234389,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116470,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10504,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 76293,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89683,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 88667,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44071,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89055,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12269,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10317,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 169229,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28685,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98273,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 61506,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 716181,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38017,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281360,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 45734,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67203,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36097,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82428,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 93781,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87931,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64729,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15494,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 31819,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96427,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59772,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60797,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88221,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 9603,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20054,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 481054,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 69427,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1351057,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8473,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1253679,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 101868,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11434,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 568359,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 164486,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 15053,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9644,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61875,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 16039,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6491,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82151,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 847172,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12152,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 67,
    msa: 'austin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54602,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10241,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41576,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8625,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289420,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1283054,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 329019,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17694,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 120242,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5744,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 67484,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9986,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 215245,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 14,
    msa: 'washington',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88022,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19286,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293290,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 314748,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 61160,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102237,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 81636,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 107728,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272402,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 262935,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 811352,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 67625,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57584,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34503,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 34864,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 705862,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19387,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 114500,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 350580,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 94850,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 13415,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 484284,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5173,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 405613,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 73170,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43547,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8445,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4693,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 285400,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 296100,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 56780,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 156131,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 51497,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67770,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 79801,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44005,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8465,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 431267,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12772,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 14796,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64889,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6803,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60517,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 81332,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4857,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87226,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8223,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 117354,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 745287,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 94964,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 47162,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84695,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 98356,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 226415,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 172857,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 279008,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113622,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310764,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 42420,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57031,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 13316,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 108431,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115521,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88009,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 443461,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10627,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61897,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 68715,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 96149,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70958,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 531309,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 204808,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60959,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19826,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86074,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7096,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 92945,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64496,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 100503,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71845,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62141,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 137662,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 395782,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38653,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130605,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75625,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 919423,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 43815,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88442,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 72536,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 67385,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98180,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60937,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6963,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 310138,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36469,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23457,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 105700,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58456,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 35713,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 130099,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5717,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83684,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7245,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 58181,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 132415,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1200918,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1123408,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36727,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311814,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 101166,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 323010,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115862,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62686,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4936,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 125213,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54631,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71290,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 67739,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43236,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 95952,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 184102,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 79175,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 815311,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 40935,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 61566,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88584,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7574,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 5,
    seniority: 'Director',
    salary: 71863,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 9906,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 99614,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6817,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42580,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 110991,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 196809,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 15092,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 58,
    msa: 'manila',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 63461,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30110,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 96104,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277645,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 216059,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 359560,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68307,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24318,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 649881,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 112480,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 80075,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37712,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 269694,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101030,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1483192,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 34604,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 350521,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 338363,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 18692,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 106027,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55467,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 746376,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 12925,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 318036,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64426,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41072,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 112055,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 77232,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 43005,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 127283,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 327882,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 150912,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 658785,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18880,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82173,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 23121,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 30,
    msa: 'houston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90935,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 64273,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66795,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106557,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90958,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 103568,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 54826,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 117497,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 118954,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 641838,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70729,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 125382,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11996,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66465,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 322922,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6629,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 480461,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76501,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58958,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59479,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 573769,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 856909,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 64083,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 16132,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 608815,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8902,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 141924,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92899,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 37,
    msa: 'pune',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5158,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 30010,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 60582,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 369751,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64931,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58553,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63182,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 231992,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 359098,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 122158,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5565,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 78097,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70814,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 119585,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 128472,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 755117,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 379737,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6199,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 207153,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 303543,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 295774,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 78325,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 378699,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12362,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 408864,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 207187,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21727,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80731,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 77689,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5215,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 619920,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 731715,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10077,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 112638,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63488,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 132339,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 323306,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 167232,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 95930,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 90210,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17034,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 78394,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60205,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59372,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 892103,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 27175,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 235878,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 261617,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 131064,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 173880,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 91337,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 115052,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 311756,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 97014,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58280,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 67,
    msa: 'austin',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302065,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 214978,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67910,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 330942,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1059672,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 95423,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 125212,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 127281,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84783,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5995,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 302394,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300928,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 24234,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76996,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 107293,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 145583,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 31257,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55391,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100264,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10888,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 321737,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7416,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66813,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69414,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 27949,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 78393,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69203,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 201528,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 21237,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 233692,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 232848,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62696,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 299485,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59334,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1153814,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 623705,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17649,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59397,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5395,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275233,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8484,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1011854,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 668873,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 4794,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64027,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 114629,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 82679,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 5,
    seniority: 'Director',
    salary: 188064,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 72305,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26239,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 38,
    msa: 'denver',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 87613,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 35,
    msa: 'milan',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 64373,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 120755,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 80315,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55027,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 258418,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 58443,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 70043,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 759570,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 112353,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142562,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19184,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 77965,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41630,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 182610,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 533999,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 14,
    msa: 'washington',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 713229,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 2844,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 727789,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82016,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 33047,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66501,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 294576,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 17376,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 283077,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 87860,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 17,
    msa: 'boston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95610,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 341181,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 945267,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 65882,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 114035,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6351,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 7351,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7421,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6060,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 27588,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 121203,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 65469,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92364,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 280472,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 295102,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60193,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304028,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93118,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 805798,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 25038,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 35314,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 90735,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 61440,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91773,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 270557,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63090,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9833,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60952,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11213,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95624,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300863,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 949487,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9987,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 771387,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 39396,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9678,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 73159,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57461,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89909,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 60592,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 166809,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 84941,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 151666,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90191,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30242,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 91821,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 51211,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 85089,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 86763,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65216,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 170306,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25144,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66574,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 83067,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 37,
    msa: 'pune',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7525,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10654,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7231,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 37739,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 281922,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 88053,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 75800,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300722,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86397,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 35,
    msa: 'milan',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31258,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 48365,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 60188,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74419,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 19779,
  },
  {
    roleId: 40,
    role: 'Education Program Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82842,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 78690,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84179,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 129530,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94676,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 923294,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 65486,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 112347,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135747,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 40244,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55888,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 101384,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 796294,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 958352,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77462,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72620,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57954,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 111175,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278260,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 550598,
  },
  {
    roleId: 148,
    role: 'Truck Driver',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87202,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 58397,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 30220,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 63516,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 115707,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282175,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 692023,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 83970,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 833303,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44273,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 121362,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 94,
    msa: 'munich',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57722,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 31125,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 130650,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58512,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 65071,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11176,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 27918,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72424,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11444,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 35,
    msa: 'milan',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58296,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18486,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83488,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 622678,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 55246,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 536850,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68193,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 5,
    seniority: 'Director',
    salary: 232191,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 356476,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61001,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 37,
    msa: 'pune',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 6138,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5116,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67047,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 971218,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 195037,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 29408,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 124234,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 455690,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 320455,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15954,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 31367,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 49863,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36924,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 102005,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 285994,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7895,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 32411,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 209367,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 34897,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 36350,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54425,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 89981,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59136,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5919,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 608765,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86159,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 57708,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 171950,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 460652,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 101660,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 589096,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 766280,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 300226,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 161195,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 382260,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 304852,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 5,
    seniority: 'Director',
    salary: 92137,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 20783,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 130414,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 233027,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 19161,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37487,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 44215,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62834,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 177493,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10174,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 75817,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267435,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 332335,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 254839,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 253320,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 294356,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 109680,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 275211,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92784,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10172,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74643,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 35,
    msa: 'milan',
    seniorityId: 5,
    seniority: 'Director',
    salary: 144042,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5975,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 7188,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 267901,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 278986,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92485,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 112646,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 19043,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82234,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 71393,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 57420,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 9172,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 5,
    seniority: 'Director',
    salary: 180460,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 135122,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 134224,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7759,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10172,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 210813,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 94,
    msa: 'munich',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 92890,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91074,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 5,
    seniority: 'Director',
    salary: 211484,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72731,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 67,
    msa: 'austin',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66866,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 10356,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 503716,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 67,
    msa: 'austin',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 454837,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 138184,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 25285,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 292089,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 68894,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 59614,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 42641,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 57810,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 5970,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 99947,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 282683,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 174489,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 605902,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 91252,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63488,
  },
  {
    roleId: 28,
    role: 'Customer Support',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81162,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 5,
    seniority: 'Director',
    salary: 70496,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 30795,
  },
  {
    roleId: 99,
    role: 'Production Operator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5036,
  },
  {
    roleId: 52,
    role: 'Financial Analyst',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 116023,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 5,
    seniority: 'Director',
    salary: 170878,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 97224,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 156547,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 94475,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37883,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 268400,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 830193,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 75434,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5668,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1122484,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 54802,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 32790,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58315,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17562,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74128,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 212842,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 53024,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 66494,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 81420,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 103283,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8156,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 615728,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 8215,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 85368,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 259216,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 58840,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104542,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 176227,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77737,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 5,
    seniority: 'Director',
    salary: 35090,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73634,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 48220,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 59239,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 88219,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 70219,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 265836,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 65962,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 74218,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80996,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 467489,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63082,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 72408,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 5,
    seniority: 'Director',
    salary: 170509,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 58,
    msa: 'manila',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 16483,
  },
  {
    roleId: 5,
    role: 'Administrative Support',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 766622,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 89446,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 17458,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92426,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 86138,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99716,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62023,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 707182,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 14,
    msa: 'washington',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98460,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 296500,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4963,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 60417,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 312479,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6078,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 77273,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 90364,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16315,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56409,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 5,
    seniority: 'Director',
    salary: 73089,
  },
  {
    roleId: 16,
    role: 'Claims Adjuster',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 54479,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 105615,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 4612,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 405103,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 268106,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 17302,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82931,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62623,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 26841,
  },
  {
    roleId: 17,
    role: 'Clinical Trial Researcher',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 56053,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15400,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 21901,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 4651,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 829059,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4689,
  },
  {
    roleId: 75,
    role: 'Logistics Coordinator',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 54560,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66258,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 67085,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 341119,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 30,
    msa: 'houston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 61845,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 93972,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8022,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 73741,
  },
  {
    roleId: 22,
    role: 'Construction Worker',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 4298,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 11490,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 34718,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89733,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 340373,
  },
  {
    roleId: 3,
    role: 'Accounting Clerk',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55785,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 64804,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70489,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 64135,
  },
  {
    roleId: 134,
    role: 'Supply Chain Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 62222,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 779572,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 106425,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 95030,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 58,
    msa: 'manila',
    seniorityId: 5,
    seniority: 'Director',
    salary: 30264,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 60301,
  },
  {
    roleId: 64,
    role: 'Healthcare Sales Representative',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 373117,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 5,
    seniority: 'Director',
    salary: 102952,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 683414,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 30,
    msa: 'houston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 308210,
  },
  {
    roleId: 102,
    role: 'Project Management',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 137859,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38910,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 32805,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41206,
  },
  {
    roleId: 21,
    role: 'Construction Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 98635,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 59747,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82313,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 46,
    msa: 'stockholm',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 71668,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 99419,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 92671,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 303707,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58886,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15733,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 5,
    seniority: 'Director',
    salary: 24235,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 88777,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 17,
    msa: 'boston',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 381115,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142981,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 272711,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 10594,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 192234,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 18220,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75603,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74937,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 329580,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 61042,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 55880,
  },
  {
    roleId: 146,
    role: 'Training Instructor',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 7558,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 23725,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66505,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 35,
    msa: 'milan',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 990377,
  },
  {
    roleId: 13,
    role: 'Business Development Strategist',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 5,
    seniority: 'Director',
    salary: 92159,
  },
  {
    roleId: 88,
    role: 'Nanny',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 29536,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 291851,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 462327,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 974,
    msa: 'hyderabad (india)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5765,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 115819,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 7978,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 65500,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 38,
    msa: 'denver',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 819374,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 143305,
  },
  {
    roleId: 26,
    role: 'Customer Operations',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 298636,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76756,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1080852,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 89770,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 774065,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 5,
    seniority: 'Director',
    salary: 11736,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 4878,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 62091,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 82863,
  },
  {
    roleId: 68,
    role: 'Investment Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 138261,
  },
  {
    roleId: 119,
    role: 'Retail Associate',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38362,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 96027,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94391,
  },
  {
    roleId: 49,
    role: 'Field Technician',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1105168,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 1047859,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55279,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 35212,
  },
  {
    roleId: 20,
    role: 'Compliance Auditor',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10708,
  },
  {
    roleId: 120,
    role: 'Retail Sales',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 72510,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 106066,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 766133,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15989,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 591371,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 63236,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 92808,
  },
  {
    roleId: 62,
    role: 'Healthcare Operations',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 5,
    seniority: 'Director',
    salary: 86159,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 193125,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 37,
    msa: 'pune',
    seniorityId: 5,
    seniority: 'Director',
    salary: 9651,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 123901,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6166,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 362162,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 3,
    msa: 'paris',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71306,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 74924,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 55143,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 49691,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 163002,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70613,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 5,
    seniority: 'Director',
    salary: 162224,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 62001,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 28230,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 5,
    seniority: 'Director',
    salary: 44554,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 58392,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 308460,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 84149,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 5,
    seniority: 'Director',
    salary: 20552,
  },
  {
    roleId: 94,
    role: 'Operations Coordinator',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42124,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 42909,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66798,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 112826,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 76073,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 5,
    seniority: 'Director',
    salary: 86582,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 69604,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 2522,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75685,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55458,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 63914,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 21,
    msa: 'san francisco',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 104596,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 17,
    msa: 'boston',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87075,
  },
  {
    roleId: 29,
    role: 'Cybersecurity Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 566794,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 147776,
  },
  {
    roleId: 46,
    role: 'Environmental Engineer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 37046,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 13,
    msa: 'amsterdam',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 62809,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 15,
    msa: 'los angeles',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 47094,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 67,
    msa: 'austin',
    seniorityId: 5,
    seniority: 'Director',
    salary: 190773,
  },
  {
    roleId: 30,
    role: 'Data Analyst',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 307263,
  },
  {
    roleId: 112,
    role: 'Recreation Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 55695,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 71450,
  },
  {
    roleId: 131,
    role: 'Social Services Counselor',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 37414,
  },
  {
    roleId: 132,
    role: 'Software Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 8471,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 52,
    msa: 'istanbul',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 323815,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 3,
    msa: 'paris',
    seniorityId: 5,
    seniority: 'Director',
    salary: 57803,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 8464,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 33,
    msa: 'brussels',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 293758,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 37,
    msa: 'pune',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 38632,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 193752,
  },
  {
    roleId: 59,
    role: 'Healthcare Assistant',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 14169,
  },
  {
    roleId: 79,
    role: 'Manufacturing Engineer',
    msaId: 35,
    msa: 'milan',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66774,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 58,
    msa: 'manila',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 170680,
  },
  {
    roleId: 97,
    role: 'Procurement Buyer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 770545,
  },
  {
    roleId: 35,
    role: 'Design Engineer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 234593,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 80503,
  },
  {
    roleId: 125,
    role: 'Sales Agent',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 59876,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56682,
  },
  {
    roleId: 96,
    role: 'Pharmacist',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 130119,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 5,
    msa: 'sao paulo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 15921,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 30,
    msa: 'houston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 75348,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 180589,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5619,
  },
  {
    roleId: 67,
    role: 'Infrastructure Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 131101,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 127546,
  },
  {
    roleId: 15,
    role: 'Change Consultant',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56545,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 75690,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 11378,
  },
  {
    roleId: 34,
    role: 'Delivery Attendant',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 12659,
  },
  {
    roleId: 23,
    role: 'Content Producer',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 81975,
  },
  {
    roleId: 141,
    role: 'Technical Support Engineer',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 87176,
  },
  {
    roleId: 138,
    role: 'Systems Engineer',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 58038,
  },
  {
    roleId: 8,
    role: 'Art Librarian',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 68388,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 110,
    msa: 'copenhagen',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 80770,
  },
  {
    roleId: 100,
    role: 'Production Supervisor',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 38655,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 55296,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 18987,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 18822,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 58250,
  },
  {
    roleId: 109,
    role: 'Quality Assurance',
    msaId: 17,
    msa: 'boston',
    seniorityId: 5,
    seniority: 'Director',
    salary: 207886,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 17,
    msa: 'boston',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 70561,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 66390,
  },
  {
    roleId: 2,
    role: 'Accountant',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 30925,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 86771,
  },
  {
    roleId: 44,
    role: 'Entrepreneur',
    msaId: 68,
    msa: 'cairo',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 5212,
  },
  {
    roleId: 135,
    role: 'Supply Planner',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 671561,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 358319,
  },
  {
    roleId: 95,
    role: 'Operations Support',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 10327,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 36075,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 31,
    msa: 'seattle',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 289956,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 8,
    msa: 'singapore',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68981,
  },
  {
    roleId: 72,
    role: 'Law Enforcement Officer',
    msaId: 45,
    msa: 'chennai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 35855,
  },
  {
    roleId: 137,
    role: 'Systems Analyst',
    msaId: 94,
    msa: 'munich',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 113224,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 30,
    msa: 'houston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 998675,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 17,
    msa: 'boston',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 90782,
  },
  {
    roleId: 24,
    role: 'Content Writer',
    msaId: 38,
    msa: 'denver',
    seniorityId: 5,
    seniority: 'Director',
    salary: 107368,
  },
  {
    roleId: 38,
    role: 'Digital Artist',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 294165,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 68570,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 16,
    msa: 'sydney',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 92691,
  },
  {
    roleId: 84,
    role: 'Medical Technician',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 6317,
  },
  {
    roleId: 144,
    role: 'Technology Consultant',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 82488,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 773955,
  },
  {
    roleId: 53,
    role: 'General Laborer',
    msaId: 3,
    msa: 'paris',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 947121,
  },
  {
    roleId: 133,
    role: 'Solutions Architect',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 6191,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 48,
    msa: 'san jose (california)',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 361335,
  },
  {
    roleId: 130,
    role: 'Service Coordinator',
    msaId: 3,
    msa: 'paris',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 51072,
  },
  {
    roleId: 127,
    role: 'Security Analyst',
    msaId: 38,
    msa: 'denver',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63918,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 277120,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 60738,
  },
  {
    roleId: 41,
    role: 'Educator',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 84501,
  },
  {
    roleId: 57,
    role: 'HR Operations',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58180,
  },
  {
    roleId: 124,
    role: 'Sales Account Executive',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 5,
    seniority: 'Director',
    salary: 142934,
  },
  {
    roleId: 48,
    role: 'Facilities Operations Coordinator',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 39368,
  },
  {
    roleId: 98,
    role: 'Product Marketing',
    msaId: 3,
    msa: 'paris',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 41540,
  },
  {
    roleId: 101,
    role: 'Project Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 240826,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 11,
    msa: 'chicago',
    seniorityId: 5,
    seniority: 'Director',
    salary: 189192,
  },
  {
    roleId: 31,
    role: 'Data Engineer',
    msaId: 28,
    msa: 'dallas',
    seniorityId: 5,
    seniority: 'Director',
    salary: 170522,
  },
  {
    roleId: 25,
    role: 'Corporate Attorney',
    msaId: 30,
    msa: 'houston',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 174937,
  },
  {
    roleId: 103,
    role: 'Property Management',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 74025,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56765,
  },
  {
    roleId: 107,
    role: 'Public Safety Officer',
    msaId: 24,
    msa: 'philadelphia',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 100846,
  },
  {
    roleId: 78,
    role: 'Maintenance Technician',
    msaId: 94,
    msa: 'munich',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 43136,
  },
  {
    roleId: 51,
    role: 'Financial Advisor',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 63660,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 56,
    msa: 'montreal',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 83984,
  },
  {
    roleId: 147,
    role: 'Transportation Coordinator',
    msaId: 71,
    msa: 'berlin',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 94683,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 5,
    seniority: 'Director',
    salary: 45572,
  },
  {
    roleId: 150,
    role: 'UX Designer',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 66918,
  },
  {
    roleId: 129,
    role: 'Security Guard',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 210686,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 17,
    msa: 'boston',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 637493,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 20,
    msa: 'mumbai',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 5772,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 84,
    msa: 'kuala lumpur',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 117573,
  },
  {
    roleId: 6,
    role: 'Application Developer',
    msaId: 7,
    msa: 'delhi',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 17971,
  },
  {
    roleId: 90,
    role: 'Nurse',
    msaId: 1,
    msa: 'london (uk)',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 40622,
  },
  {
    roleId: 81,
    role: 'Marketing Coordinator',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 6176,
  },
  {
    roleId: 14,
    role: 'Care Aide',
    msaId: 55,
    msa: 'minneapolis',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 70280,
  },
  {
    roleId: 39,
    role: 'E-Commerce Brand Manager',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 31943,
  },
  {
    roleId: 33,
    role: 'Data Scientist',
    msaId: 22,
    msa: 'madrid',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 99294,
  },
  {
    roleId: 1,
    role: 'Academic Researcher',
    msaId: 140,
    msa: 'kolkata',
    seniorityId: 1,
    seniority: 'Entry Level',
    salary: 3068,
  },
  {
    roleId: 56,
    role: 'Guest Services',
    msaId: 14,
    msa: 'washington',
    seniorityId: 5,
    seniority: 'Director',
    salary: 98783,
  },
  {
    roleId: 110,
    role: 'Real Estate Officer',
    msaId: 26,
    msa: 'atlanta',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 58767,
  },
  {
    roleId: 140,
    role: 'Tax Accountant',
    msaId: 2,
    msa: 'new york city',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 120515,
  },
  {
    roleId: 118,
    role: 'Restaurant Staff',
    msaId: 23,
    msa: 'dubai',
    seniorityId: 6,
    seniority: 'Executive',
    salary: 314581,
  },
  {
    roleId: 123,
    role: 'Safety Coordinator',
    msaId: 51,
    msa: 'phoenix',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 82832,
  },
  {
    roleId: 126,
    role: 'Sales Representative',
    msaId: 18,
    msa: 'melbourne',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 69819,
  },
  {
    roleId: 139,
    role: 'Talent Recruiter',
    msaId: 113,
    msa: 'rio de janeiro',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 22028,
  },
  {
    roleId: 108,
    role: 'QA Engineer',
    msaId: 9,
    msa: 'bengaluru',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 24321,
  },
  {
    roleId: 91,
    role: 'Office Clerk',
    msaId: 14,
    msa: 'washington',
    seniorityId: 2,
    seniority: 'Junior',
    salary: 56025,
  },
  {
    roleId: 77,
    role: 'Machinist',
    msaId: 38,
    msa: 'denver',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 76655,
  },
  {
    roleId: 116,
    role: 'Research Scientist',
    msaId: 176,
    msa: 'ahmedabad',
    seniorityId: 5,
    seniority: 'Director',
    salary: 23176,
  },
  {
    roleId: 106,
    role: 'Public Affairs Officer',
    msaId: 32,
    msa: 'jakarta',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 16185,
  },
  {
    roleId: 82,
    role: 'Medical Practitioner',
    msaId: 10,
    msa: 'toronto',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 925137,
  },
  {
    roleId: 65,
    role: 'IT Operations',
    msaId: 41,
    msa: 'barcelona',
    seniorityId: 4,
    seniority: 'Manager',
    salary: 66967,
  },
  {
    roleId: 85,
    role: 'Mental Health Therapist',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 7,
    seniority: 'Senior Executive',
    salary: 565274,
  },
  {
    roleId: 80,
    role: 'Manufacturing Process Improvement',
    msaId: 37,
    msa: 'pune',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 10852,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 29,
    msa: 'rotterdam',
    seniorityId: 3,
    seniority: 'Associate',
    salary: 63393,
  },
  {
    roleId: 36,
    role: 'Development Coordinator',
    msaId: 50,
    msa: 'abu dhabi',
    seniorityId: 5,
    seniority: 'Director',
    salary: 164291,
  },
];
